import "./pantalla3.css";
const PaseoVirtual = () => {
  return (
    <>
      <svg viewBox="0 0 1388.36 974.12">
        <defs>
          <clipPath id="clip-path" transform="translate(2.38)">
            <rect class="cls3-1" width="1378.39" height="840.15" />
          </clipPath>
          <clipPath id="clip-path-2" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M463.72,308.43s14.35,3.95,24.37-.39,13.69-11.15,13.69-11.15S475.76,291,463.72,308.43Z"
            />
          </clipPath>
          <clipPath id="clip-path-3" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="462.76"
              y="290.98"
              width="38.62"
              height="21.67"
            />
          </clipPath>
          <clipPath id="clip-path-4" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M279.68,749.66a73.53,73.53,0,0,1,.47-7.42c-.2,2.19-.36,4.73-.47,7.42M395.6,733.14c-1.11-2.12-2-3.91-2.71-5.11a49.81,49.81,0,0,1,2.71,5.11m-4.18-7.32c-.21-.14-.42-.27-.65-.4l.29-.09.36.49"
            />
          </clipPath>
          <clipPath id="clip-path-5" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="279.67"
              y="724.37"
              width="115.86"
              height="24.77"
            />
          </clipPath>
          <clipPath id="clip-path-6" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="279.67"
              y="725.92"
              width="117.29"
              height="52.62"
            />
          </clipPath>
          <clipPath id="clip-path-7" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M275.8,687.45C259.9,671.32,248,643.79,248,643.79c-6.51-30.64-7.59-133.42-7.59-133.42h0c.26,2.6.54,5.49.85,8.52.59,7.67,1.43,16.89,2.65,27.28a143.69,143.69,0,0,0,2,15.77v0c2.53,21.83,5.19,42.89,6.94,52.59v.07h0v.11h0v.11h0c2.74,14.68,14.11,48,22.87,72.39"
            />
          </clipPath>
          <clipPath id="clip-path-8" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="239.62"
              y="510.77"
              width="35.76"
              height="176.45"
            />
          </clipPath>
          <clipPath id="clip-path-9" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M308.79,435.21c-4.12,0-7.73-.21-10.71-.49,1-3.17,1.95-6.48,2.89-9.73h1.39c12.31,0,30.1-5.1,30.22-5.13-.54,3.87-1.18,8.91-1.77,14.25-4.38.37-10.3.76-17.23,1-1.66,0-3.25.08-4.77.08M301,425c.92-3.17,1.77-6.28,2.51-9.11-1.22,4.79-2.38,8.67-2.51,9.11m63.35-2.2h0c-3.43-2.19-9.57-8.38-9.76-11.3s1.81-10.17,4.52-18.77,16.26-30.5,20.24-37.29,18.4-32.67,18.5-32.81c-.11.72-.2,1.35-.26,1.91-.71,6.65-5,26.15-4.69,30.48s2.53,7.23,2.53,10.86-14.1,44.64-31.08,57m0,0A83.57,83.57,0,0,1,346,418.38a105.23,105.23,0,0,0,18.33,4.49h0M305,409.71a35.73,35.73,0,0,0,.78-4.83,16.2,16.2,0,0,0-.63-4.7c.37,1.17.72,2.28,1,3.29-.3,1.91-.72,4-1.19,6.21m92.87-87.14,1.35-10.64-.6,5.68c-.26,1.9-.53,3.56-.75,5"
            />
          </clipPath>
          <clipPath id="clip-path-10" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="298.26"
              y="311.1"
              width="101.56"
              height="123.83"
            />
          </clipPath>
          <clipPath id="clip-path-11" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M302.41,425H301c.13-.44,1.28-4.32,2.51-9.1.51-2,1-4.15,1.5-6.27s.91-4.3,1.19-6.2c1.36,4.47,2.14,7.53,2.14,7.53s14.45-5.48,26-13.71a41,41,0,0,0,4.94-4.12,21.37,21.37,0,0,0,1.62-1.4c.1,0,8.83-3.54,15.23-5.24a24.74,24.74,0,0,1-6.26-9.19h0a96.19,96.19,0,0,1-1.61-16V361a40.06,40.06,0,0,1,1.5-9.25c.4-1.09.77-2,1.06-2.78,3.42-6.74,7.49-10.4,9.14-11.12-2.54,2-9.19,9-9.89,15s2.15,16.46,2.15,16.46,3.24-15.25,6.49-19.15S371,340.56,371,340.56h0a7.13,7.13,0,0,1,1.2,1.31c2.89,4.11,3.44,16.46,3.44,16.46s3.79-8.29,6.32-15.91,12.46-25.22,17.33-30.71v.14l-1.33,10.64h0c-.09.15-14.55,26-18.52,32.81S361.9,384,359.19,392.64s-4.7,15.83-4.52,18.77,6.33,9.14,9.75,11.31a107.05,107.05,0,0,1-18.34-4.45,56.72,56.72,0,0,1-12.37-5.82l-1,7.37h0c-.1,0-17.89,5.14-30.22,5.14M349,354.06a15.64,15.64,0,0,1,1-3.22l.51-1.09c-.23.63-.43,1.27-.62,1.92s-.57,1.53-.89,2.4m20.27-14.74c-3.18-1.38-8.86-1.57-9.15-1.58a5.52,5.52,0,0,1,1.93-.26,16,16,0,0,1,7.22,1.84"
            />
          </clipPath>
          <clipPath id="clip-path-12" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="301.12"
              y="311.1"
              width="98.7"
              height="112.99"
            />
          </clipPath>
          <clipPath id="clip-path-13" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M308.74,385.59a7.46,7.46,0,0,1-3.47-.71S286,358.35,285.9,346l-1.45-21.61-4.33,21.71h0l-3.42-.58c-1.46-16.9,8-44.41,8.11-44.78h0a43.53,43.53,0,0,0,8.29-.8c3.8-.88,26.84-8.46,26.84-8.46-3.53-2.3-18.29-5.72-18.29-5.72s1.21-3.42,8.54-4.68,22.15-2.31,22.15-2.31c-1.54-1-5-1.73-9.25-2.1,9-.26,18.3-.16,27.52-.33,26.12-.46,42.54-4.46,42.54-4.46,8,2.36,17.36,14.75,20.93,19.84-3,1.1-13.9,5.08-21.29,7.09,0,0-4.88,31.87-12.74,43.87,0,0-7.5-9.42-16.35-10.14,0,0-17,14.58-24,22.32V350s-7.31,15.36-17.2,27.21c-5.8,6.92-10.72,8.35-13.82,8.35m12-81.79s-6.49,20.72-3.18,49.61l6.69-14.49s-3.51-25.34-3.51-35.1m51-23.46s6.55,13.3,8.65,25.46,0,33.58,0,33.58,4.76-9.87,5.49-16.51,5-25.71,2.16-31.41-16.3-11.12-16.3-11.12m-94.25,6.47a5.73,5.73,0,0,1,.16-1.09c1.27-4.89,27.65-29.13,42.31-35.2,9-3.72,22-5.09,31.09-5.09,5.75,0,9.95.55,10.65,1.37,1.77,2.1,4.16,7.83,4.32,8.2a10.52,10.52,0,0,0-3.24-2.33,10,10,0,0,0-2.84-.26c-2.41,0-5.3.26-5.3.26h0s-2.6-.26-6.95-.26a112.59,112.59,0,0,0-29.67,4c-19.64,5.48-40.35,29.33-40.35,29.33A63.66,63.66,0,0,1,292.81,280c-6.82,2.88-15.22,5.71-15.22,5.71a8,8,0,0,0-.16,1.09M403.29,268a59.78,59.78,0,0,0-7.86-8.63c-2.67.23-5.25.33-7.72.33-17.12,0-29-5-32.23-6.58a84.32,84.32,0,0,0,11.24,3.47c10.44,2.83,28.69,2.83,28.69,2.83a42.64,42.64,0,0,1,7.86,8.64"
            />
          </clipPath>
          <clipPath id="clip-path-14" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="273.95"
              y="244.54"
              width="138.76"
              height="140.85"
            />
          </clipPath>
          <clipPath id="clip-path-15" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M309,410.57s-6.16-24.13-13.92-36c-6.29-9.64-15-28.75-15-28.75l4.33-21.7,1.45,21.6c.08,12.29,19.37,38.82,19.37,38.82a7.46,7.46,0,0,0,3.47.71c3.09,0,8.05-1.42,13.81-8.35,9.9-11.82,17.2-27.21,17.2-27.21v4.94c7.05-7.74,24-22.32,24-22.32,8.85.71,16.35,10.13,16.35,10.13,7.86-12.06,12.74-43.87,12.74-43.87,7.39-2,18.27-6,21.29-7.08.95,1.36,1.49,2.19,1.49,2.19h0c-4.48,15-16.38,23.66-16.38,23.66l.64-5.91h0c-4.88,5.48-14.82,23.09-17.33,30.71q-2.81,8.12-6.33,15.9s-.54-12.38-3.44-16.45a7.89,7.89,0,0,0-1.19-1.32,4.44,4.44,0,0,0-1.76-1.22,16,16,0,0,0-7.27-1.86,5.94,5.94,0,0,0-1.92.26h0c-1.65.73-5.72,4.39-9.16,11.12l.81-2.07c-.46,1-.87,1.94-1.24,2.94l-.51,1.1a15.36,15.36,0,0,0-1,3.21c-3.73,10.25-9.89,28.84-9.59,39h0a42.16,42.16,0,0,1-5,4.13c-11.53,8.19-26,13.68-26,13.68m40.84-33.33h0a56.33,56.33,0,0,1-1.55-16.33v.34c-.06,7.82,1.55,16,1.43,16v.42"
            />
          </clipPath>
          <clipPath id="clip-path-16" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M466,524.17c-.28-2-.57-4-.87-5.7a5.73,5.73,0,0,1-1,.08c-1.88,0-6.16-.62-11-5.42-1-1-2.11-2.2-3.19-3.29,5.76.9,11.54,1.75,16.38,2.36,0,0,1.85-6.83,4.69-17.71a27.06,27.06,0,0,0,10.85,19.27,34.73,34.73,0,0,0,.58,5.58,16.79,16.79,0,0,0-2.83-.22,23.83,23.83,0,0,0-4.84.52c-2.76.57-6.1,2.55-8.8,4.59m21.84-22.08c3-5.9,6-12,6.19-12.72,0,2.4-3.11,7.67-6.19,12.72M494,489q-.48-3-1.25-5.89A24.92,24.92,0,0,1,494,489m-69.56-8.23a12.19,12.19,0,0,1-1.43-1.61c-2.17-2.94-3.26-7-2.44-8.51a2.52,2.52,0,0,1,2.26-1,4.52,4.52,0,0,1,3.49,1.69l-1.88,9.44m3.78-18.93c-.22-.45-.42-.88-.61-1.29-2.71-6-2.71-10.53-1.9-13.56a2.81,2.81,0,0,1,2.62-2.51,4.21,4.21,0,0,1,2.47.95,3.8,3.8,0,0,1,.58.62l-3.16,15.79m59-3.29c-1.39-9.53.81-24.9.81-24.9a135.41,135.41,0,0,0-.81,24.9"
            />
          </clipPath>
          <clipPath id="clip-path-17" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="419.85"
              y="433.38"
              width="74.38"
              height="91.32"
            />
          </clipPath>
          <clipPath id="clip-path-18" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M487,631c-10.83-1-56.4-39.89-58.35-41.84s-29.13-18.87-30.15-19.5h0c.91.25,35.77,3.29,35.93,3.29h0s-19.7-9.78-23.31-11.21h0l-20.94-22.13s-1.19-4.39-2.37-10.24c.67-4.86,1.3-9,1.75-11.72a38.11,38.11,0,0,1,2.34-8.52c-1.64,8.44-4,26.93,4.9,34.38,11.58,9.73,57.13,30.4,57.93,30.71a52.28,52.28,0,0,0,9.17,7.68h0a56.26,56.26,0,0,0,6.68,3.84h0a27.76,27.76,0,0,1,4.7,2.94,21.45,21.45,0,0,1,5.23,6.11h0q.27.62.48,1.26c2,6.46,6,34.81,6,34.81m13.79-7.17-.08-.12c1.59-5.18,2.46-8.78,2.46-8.78s-2,2.49-4.47,5.85c-2.87-4.18-8.06-11.77-11.15-16.91-1.2-2-2.65-4.25-4.14-6.59a96.82,96.82,0,0,0-5.81-9.27,35.89,35.89,0,0,1-3.6-7c-.85-3.29-6-29.47-6.6-32.52h0v-.29c-.07-.42-.14-.84-.2-1.25a36.18,36.18,0,0,1,17.55-21.55c-10.43.64-19.37,11.9-19.37,11.9h0S461,530.6,461,529.26c0-.68,2.15-2.92,5-5.09a24.89,24.89,0,0,1,8.8-4.58,23.91,23.91,0,0,1,4.84-.53,17.8,17.8,0,0,1,2.83.22,6.92,6.92,0,0,1,1.27.31S489,553,495.05,572.66s8.63,35.79,8.38,40.58a64.73,64.73,0,0,1-2.62,10.52h0m-56-64.67q-5.47-9.2-10.07-19c-7.92-17-21.15-45.67-21.15-45.67h0l-1.09-.75a3.66,3.66,0,0,1,1.09.75c1.63,2,12.48,22,15.72,30.91,2.42,6.58,9.42,21.93,15.53,33.73m22.7-9.87a2.87,2.87,0,0,0-.07-.5,2.08,2.08,0,0,1,.07.5m-223.6-3c-1.22-10.4-2-19.64-2.65-27.29.64,6.3,1.39,13.43,2.21,20.91.12,2.19.27,4.3.44,6.38m142.71-23c-.93-6.07-1.46-12.4-.58-16.53a54.36,54.36,0,0,1,8.36-18.52h0c7,2.2,14.36,3.91,17.63,5.32-1.16.42-12.09,4.39-15.19,6.22-3.33,2-8.56,13.49-9.83,20.73-.11.67-.24,1.6-.39,2.78m-67.87-60.33c-11.82,0-25.88-1.49-31-4-8.39-4.22.11-23.72.85-25.4a200.69,200.69,0,0,0-9.64,21h0a199.24,199.24,0,0,1,9.61-21l.06-.1a73.94,73.94,0,0,0,9.47,1.35c3,.28,6.59.49,10.71.49,1.52,0,3.11,0,4.77-.09,6.93-.27,12.85-.67,17.23-1,5.21-.43,8.24-.78,8.24-.78s7.74,14,11.5,23h0c-3.76-9-11.5-23-11.5-23s2.59,23.11-2.48,27.11c-2.13,1.67-9.41,2.43-17.83,2.43"
            />
          </clipPath>
          <clipPath id="clip-path-19" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="241.05"
              y="433.38"
              width="261.77"
              height="198.13"
            />
          </clipPath>
          <clipPath id="clip-path-20" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M369.75,344.59A16.2,16.2,0,0,0,360,354a34.18,34.18,0,0,0-1.26,24.44s-.9-11.46,2.71-20.07A52.72,52.72,0,0,1,369.75,344.59Z"
            />
          </clipPath>
          <clipPath id="clip-path-21" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="355.48"
              y="345.15"
              width="14.3"
              height="34.06"
            />
          </clipPath>
          <clipPath id="clip-path-22" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M363.43,352.23a24.25,24.25,0,0,1,0,13.09c-1.54,5.76-4.68,6.29-4.68,6.29s2.17,1.68,5.6-1.59c4.52-4.3,2.71-21.94,2.71-21.94l-3.61,4.1Z"
            />
          </clipPath>
          <clipPath id="clip-path-23" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="358.34"
              y="348.25"
              width="10.01"
              height="24.77"
            />
          </clipPath>
          <clipPath id="clip-path-24" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M352.23,368.89s-2.83-10.36-2.15-16.45,7.36-13.08,9.9-15.05h0c.28,0,6,.19,9.15,1.58h0a4.6,4.6,0,0,1,1.76,1.21h0s-8.94,5.6-12.2,9.5-6.5,19.21-6.5,19.21"
            />
          </clipPath>
          <clipPath id="clip-path-25" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="349.76"
              y="337.41"
              width="21.45"
              height="30.95"
            />
          </clipPath>
          <clipPath id="clip-path-26" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M356.2,378.42s4.1,3.4,6.87,1.76c0,0-1.08,4.7-4.34,4.7s-2.53-6.46-2.53-6.46Z"
            />
          </clipPath>
          <clipPath id="clip-path-27" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="355.48"
              y="379.21"
              width="7.15"
              height="6.19"
            />
          </clipPath>
          <clipPath id="clip-path-28" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M284,300.8c-.07-.07-7.23-7.34-6.67-14-.26,4.95,5.15,12.35,6.67,14v-.54"
            />
          </clipPath>
          <clipPath id="clip-path-29" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="276.81"
              y="286.33"
              width="7.15"
              height="13.93"
            />
          </clipPath>
          <clipPath id="clip-path-30" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M284.11,300.8h0c-1.52-1.63-6.93-9-6.67-14a8.19,8.19,0,0,1,.16-1.09s8.4-2.83,15.22-5.71c9.18-2.19,19.23-3,29.64-3.29,4.24.38,7.72,1.1,9.26,2.1,0,0-14.91,1-22.23,2.26s-8.52,4.68-8.52,4.68,14.76,3.41,18.28,5.72c0,0-23,7.57-26.83,8.45a43,43,0,0,1-8.31.88"
            />
          </clipPath>
          <clipPath id="clip-path-31" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M415,294s-.23-.93-.69-2.49a84.78,84.78,0,0,0-11-23.48A60.18,60.18,0,0,1,415,294m-59.53-40.81a5.17,5.17,0,0,1-.88-.44s.3.17.88.44"
            />
          </clipPath>
          <clipPath id="clip-path-32" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="354.05"
              y="252.29"
              width="60.08"
              height="41.79"
            />
          </clipPath>
          <clipPath id="clip-path-33" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M415,294s-.23-.93-.69-2.49l-.8.3c-3.58-5.09-13-17.48-20.94-19.84,0,0-16.41,4-42.54,4.46-9.21.17-18.5.07-27.52.33-2.46-.22-5.19-.33-8-.33-7.53,0-15.31.81-18.84,2.43-.89.4-1.85.82-2.85,1.24a63.63,63.63,0,0,0-15.22,5.7s20.71-23.86,40.35-29.33a113,113,0,0,1,29.67-4c4.35,0,6.95.26,6.95.26h0a5.17,5.17,0,0,0,.88.44c3.21,1.53,15.11,6.58,32.23,6.58,2.47,0,5-.1,7.72-.33a59.34,59.34,0,0,1,7.86,8.64,84.52,84.52,0,0,1,11,23.48c.46,1.56.69,2.49.69,2.49h0"
            />
          </clipPath>
          <clipPath id="clip-path-34" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M415,294s-.55-.83-1.49-2.19l.8-.3c.46,1.56.69,2.49.69,2.49h0"
            />
          </clipPath>
          <clipPath id="clip-path-35" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M292.82,280.05c1-.42,2-.84,2.85-1.24,3.53-1.62,11.31-2.43,18.84-2.43,2.76,0,5.49.11,7.95.33-10.41.31-20.46,1.1-29.64,3.29"
            />
          </clipPath>
          <clipPath id="clip-path-36" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M317.53,353.41c-3.31-28.89,3.18-49.61,3.18-49.61,0,9.79,3.51,35.1,3.51,35.1l-6.69,14.49"
            />
          </clipPath>
          <clipPath id="clip-path-37" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M320.14,465.32c-13.3,0-30.13-1.46-35.14-2.44-7.05-1.37-7.76-4.11-7.76-4.11l1.72-4.39h0a201.11,201.11,0,0,1,9.61-21c-.74,1.68-9.24,21.18-.85,25.39,5.12,2.56,19.14,4.05,31,4.05,8.42,0,15.7-.76,17.82-2.43,5-4,2.49-27.11,2.49-27.11s7.74,14,11.5,23h0s-5.89,6-16.92,8.23a78.91,78.91,0,0,1-13.47.86"
            />
          </clipPath>
          <clipPath id="clip-path-38" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M470.29,581.92c-.54-7.48-1.64-22.34-2.43-30a8.08,8.08,0,0,0-.1-.86V551c0-.33-.06-.65-.11-1s-.09-.6-.13-.86h0a5.11,5.11,0,0,0,.13.86c.05.3.08.62.11,1v.12a5.16,5.16,0,0,0,.1.87c.76,6.8,1.61,18,2.15,25.73h0l.29,4.24"
            />
          </clipPath>
          <clipPath id="clip-path-39" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="467.05"
              y="549.46"
              width="2.86"
              height="32.51"
            />
          </clipPath>
          <clipPath id="clip-path-40" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M485.8,651.08c-7.77,0-28.9-16.45-35.11-22.79-5.09-5.21-15.1-20.31-22.16-29.22l-1-2.91,10.07,2.92a44.93,44.93,0,0,0-14.5-10.26c-8.14-3.29-30.22-9.54-30.22-9.54h0a65.47,65.47,0,0,1-6.63-7.63c-.85-1.09-1.25-3.9-1.32-7.67,5.26,2.9,11.35,6,13.58,6.27h0c1,.64,28.2,17.55,30.15,19.51s47.52,40.85,58.35,41.83c0,0-4-28.35-6-34.81-.14-.43-.3-.84-.48-1.26,3.67,6.58,6.14,33.93,6.14,33.93s.1-21.59-1.59-28.19a20.48,20.48,0,0,0-1.65-4c1.49,2.36,2.94,4.63,4.14,6.58,3.13,5.14,8.28,12.73,11.15,16.91-2.8,3.92-6,9-7.05,12.81q-2,8.19-3.32,16.58A61.93,61.93,0,0,0,496,637.25c-2.94,7-6.27,12.91-9.07,13.65a4.21,4.21,0,0,1-1,.12m11.28-15.42a.13.13,0,0,1,.05-.11c1.63-4.25,3-8.36,4-11.78l.07.12h0c-1.14,3.67-2.58,7.82-4.17,11.76m-112-22.65a88.37,88.37,0,0,1-13.52-32,70.83,70.83,0,0,1-1-13c0-27.81,10.18-69.59,11.72-72.59,1.81-3.53,12-7.18,12-7.18A54.26,54.26,0,0,0,386,506.69c-.88,4.13-.35,10.46.58,16.53-.92,7.79-2.27,25.55-2.69,37.48-4.53-.88-7.76-1.74-7.76-1.74s3.44,2.07,7.68,4.39a48.76,48.76,0,0,0,.27,8.66c.85,3.07,4.22,6.59,6.27,8.55l-16.53,8.7,4.72,12.06,6.66,11.57h0m43.22-14-.27-.34a3.89,3.89,0,0,1,.27.34m-40.07-2.62c1-4.63,2.21-9.65,3.63-14.26h0c-.84,2.9-2.23,7.9-3.66,14.26m87-6.93a28.41,28.41,0,0,0-4.7-2.94,21.38,21.38,0,0,1,4.7,2.94m2.3-1.41c-3.69-5.32-7.37-10-7.6-10.29-.54-7.77-1.39-18.93-2.15-25.73a8.58,8.58,0,0,0-.1-.87V551c0-.33-.06-.66-.11-1s-.09-.59-.13-.86h0a2.15,2.15,0,0,0-.07-.5h0v-.23c.62,3.05,5.76,29.21,6.6,32.52a35.6,35.6,0,0,0,3.6,7m-43.17-14.37c-.16,0-35-3.08-35.93-3.29,4.22.46,35.78,3.29,35.93,3.29m-30.22-10.88c-2.25,0-5-.09-8.18-.32A104.39,104.39,0,0,1,385,560.82c.17-8.78,1.58-21.16,2.89-30.8,1.18,5.82,2.37,10.22,2.37,10.22l20.94,22.1h0a59.6,59.6,0,0,1-6.94.32"
            />
          </clipPath>
          <clipPath id="clip-path-41" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M385.29,613h0l-.06-.11c.92-6.07,2-11.73,3.14-16.61-.83,3.84-1.49,7.41-2,10.27l-.07-.09-.7,4.67c-.18,1.15-.28,1.83-.29,1.89"
            />
          </clipPath>
          <clipPath id="clip-path-42" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="385.52"
              y="595.9"
              width="2.86"
              height="17.02"
            />
          </clipPath>
          <clipPath id="clip-path-43" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M385.21,612.9l-6.66-11.57-4.72-12.06,16.53-8.7c.84.8,1.46,1.33,1.62,1.46-1.42,4.61-2.64,9.62-3.63,14.26-1.1,4.88-2.22,10.54-3.14,16.6"
            />
          </clipPath>
          <clipPath id="clip-path-44" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M338.15,728.64c-23,0-53.09-3.43-53.69-5.34-.65-2.2,1.42-6.36,1.76-7-.61.83-5.58,7.67-5.58,11.29,0-3.62,5-10.46,5.58-11.29v-.08h0l-1.72-4.63L282.08,705l.2.51a15.33,15.33,0,0,0,8.37,9c22.23,9.3,62.06,13.48,62.06,13.48a140.48,140.48,0,0,1-14.62.65m-5.31-15.81c-18.84,0-37.89-3.52-40.57-5.62-5-4-18.28-53.36-24.07-69.1s-18.2-55.56-22.29-76.09h0c-.85-7.45-1.7-15-2.47-22.16-1.36-23.12-.35-49.1-.35-49.1s27.39-11.62,40.12-11.62H284c.73,0,1.51.05,2.33.05,12.95,0,35.94-4.24,41-5.65a109.88,109.88,0,0,0,11.26-4.66c.12.1,30.54,22.75,41.55,26-8.91,21.14-16,57.57-14.46,73,2.17,21.72,13,47.5,13,47.5s2.26,66.5-7.86,85.66c-4.76,9-21.34,11.81-38.09,11.81m35.46-63.09s-15.5,20-27.63,28.15-31.63,18-31.63,18,31.67-3.61,41.68-12.6,17.58-33.54,17.58-33.54m-72.64-63.83h0s-6.68-8-21.55-21.41S243.79,532,243.79,532s4.82,9.87,7.14,13.74v.06A82,82,0,0,1,243.74,532s7,21.12,11.92,27.57,23.48,22.87,39.93,26.4m.14.09a198.38,198.38,0,0,1-26-18.64h0a225.34,225.34,0,0,0,25.92,18.52h0m84.61-91.14a51.33,51.33,0,0,1,5.35-10.3,60.19,60.19,0,0,0-5.35,10.3m-141.15,0a2.41,2.41,0,0,1,0-.38,6.59,6.59,0,0,1,2-3.72c6.87-9.79,31.61-31.48,31.61-31.48s.54-2.55,1.63-2.89,4.53-1.85,4.61-1.88h0l-1.72,4.38s.71,2.75,7.77,4.12c5,1,21.83,2.43,35.13,2.43a78.91,78.91,0,0,0,13.47-.86c11.08-2.2,16.92-8.16,16.92-8.16h0a9.72,9.72,0,0,1,3.13-.73,1.73,1.73,0,0,1,1.64.73c.91,1.61,0,4.65,0,4.65l.84.79-.92-.77h0c-1.75.62-30,10.55-42.75,11h-1.66c-13.3,0-33.63-5.71-35-7.58s-1.48-8.16-1.48-8.16c-1.09.34-1.63,2.89-1.63,2.89S248,480.9,241.16,490.69a6.59,6.59,0,0,0-2,3.72,2.41,2.41,0,0,0,0,.38m155.27-6.58a37.82,37.82,0,0,0-2.94-9.06h0s-13.26-1.51-17.58-3.87c6.46,2.61,17.58,3.87,17.58,3.87a37.82,37.82,0,0,1,2.94,9.06h0"
            />
          </clipPath>
          <clipPath id="clip-path-45" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="238.19"
              y="455.05"
              width="155.92"
              height="273.97"
            />
          </clipPath>
          <clipPath id="clip-path-46" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M282.14,705c-1.75-4.78-3.94-10.81-6.34-17.55h0c2.4,6.71,4.59,12.75,6.34,17.55"
            />
          </clipPath>
          <clipPath id="clip-path-47" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="276.81"
              y="687.22"
              width="5.72"
              height="17.02"
            />
          </clipPath>
          <clipPath id="clip-path-48" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M275.8,687.45h0c-8.71-24.4-20.15-57.73-22.87-72.39,2.74,14.69,14.16,48,22.87,72.39"
            />
          </clipPath>
          <clipPath id="clip-path-49" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M252.93,614.83v-.06c-1.75-9.71-4.41-30.77-6.93-52.59h0c2.52,21.82,5.18,42.88,6.93,52.59v.06"
            />
          </clipPath>
          <clipPath id="clip-path-50" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M245.91,561.92a143.21,143.21,0,0,1-2-15.76c.58,5,1.26,10.28,2,15.76"
            />
          </clipPath>
          <clipPath id="clip-path-51" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M245.91,562h0c-.77-5.48-1.45-10.76-2-15.76q-.26-3.13-.44-6.39c.77,7.2,1.62,14.72,2.47,22.17"
            />
          </clipPath>
          <clipPath id="clip-path-52" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M340.15,734.31c-31,0-57.49-1.95-59.23-5.08a2.47,2.47,0,0,1-.28-1.23c0-3.61,5-10.45,5.58-11.28-.34.68-2.41,4.89-1.76,7,.6,1.89,30.71,5.33,53.69,5.33a140.35,140.35,0,0,0,14.62-.65s-39.85-4.18-62.08-13.48a15.32,15.32,0,0,1-8.35-9l-.2-.53h0c-1.75-4.78-3.94-10.81-6.34-17.55-8.71-24.41-20.15-57.75-22.87-72.39h0v-.11h0v-.16h0v-.07c-1.75-9.7-4.41-30.71-6.93-52.59h0c4.08,20.54,16.5,60.32,22.28,76.1s19,65.18,24.07,69.1c2.68,2.1,21.73,5.62,40.57,5.62,16.75,0,33.33-2.77,38.09-11.8,10.12-19.16,7.86-85.66,7.86-85.66s-10.85-25.79-13-47.5c-1.55-15.47,5.54-51.9,14.45-73h0v-.05a60.19,60.19,0,0,1,5.35-10.3c1.68-2.4,3.67-4.51,5.83-5.38h0a37.89,37.89,0,0,1,2.94,9.05s-10.16,3.65-12,7.19c-1.54,3-11.72,44.78-11.72,72.58a71.87,71.87,0,0,0,1,13,88.09,88.09,0,0,0,13.57,32.08l1-6.58,5.51,7.33a219.09,219.09,0,0,0-3.24,25.83c-.08,1.1-.12,2.42-.12,3.93,0,19.13,5.94,67.12,5.94,67.12,2,2.09,2.44,5.67,2.44,8.49a28.49,28.49,0,0,1-.31,4.13,162.21,162.21,0,0,1-56.41,10.48M243.45,539.8c-2.46-22.59-4.34-41.93-4.34-45a2.54,2.54,0,0,1,0-.39,6.66,6.66,0,0,1,2-3.72c6.87-9.78,31.61-31.48,31.61-31.48s.54-2.54,1.63-2.88c0,0,.07,6.21,1.48,8.16s21.69,7.55,35,7.55h1.66c12.77-.5,41-10.42,42.75-11.05h0s-14.18,6.81-16.57,7.91h0a107.91,107.91,0,0,1-11.2,4.65c-5.1,1.4-28.09,5.65-41,5.65-.83,0-1.61,0-2.34-.06h-.9c-12.73,0-40.12,11.63-40.12,11.63s-1,26,.35,49.09"
            />
          </clipPath>
          <clipPath id="clip-path-53" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M373.85,475.28c-.49-.2-1-.4-1.39-.62-5.08-2.52-13.64-10.36-16.32-12.88,3.23,2.65,14.1,11.49,17.69,13.49h0"
            />
          </clipPath>
          <clipPath id="clip-path-54" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="356.91"
              y="461.24"
              width="17.16"
              height="13.93"
            />
          </clipPath>
          <clipPath id="clip-path-55" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M380.23,494.84c-11-3.23-41.43-25.88-41.55-26,7.42-3.4,15.61-7.42,16.54-7.9h0l.92.77c2.68,2.52,11.24,10.37,16.32,12.89.44.22.9.42,1.39.61,4.32,2.36,17.58,3.87,17.58,3.87-1.93.62-3.89,2.52-5.83,5.39a51.33,51.33,0,0,0-5.35,10.3h0"
            />
          </clipPath>
          <clipPath id="clip-path-56" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M379.8,495.29h.43m5.37-10.8c1.94-2.87,3.9-4.77,5.83-5.39h0c-2.16.87-4.15,3-5.83,5.39m-46.92-15.61h0c2.39-1.09,16.55-7.89,16.55-7.89-.93.47-9.12,4.49-16.54,7.89"
            />
          </clipPath>
          <clipPath id="clip-path-57" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M464.79,505.15l-44.21-5.28,21.05-105.19h1.48c2.53,0,8.06,0,14.72.25,10.34.32,23.43,1.09,32.4,2.88h0s-3.69,16.68-8.28,36.92a11.56,11.56,0,0,0-2.12,2.72c3.71-17.18,6.64-31.52,6.64-32.91,0-1.68-24.17-3.19-36.89-3.19-4.24,0-7.2.17-7.56.55-.95,1-3.39,11.25-6.22,24.57l-.45-.43-6.48,32.4.43.4c-3.61,18.78-6.48,35.18-6.24,36.14.44,1.86,27.62,5.38,38.06,5.38,2.16,0,3.61-.15,3.95-.5s1-2.72,2-6.58l.89.8,3.24-13.41c-.06.33-.12.67-.17,1-2.91,12.07-5.27,21.18-6.24,23.45M454.32,398l.22.83,18.3,1.18.83-1c-7.31-.83-19.35-1.05-19.35-1.05m17.64,80L475.09,465c-1,4.19-1.95,8.27-2.86,12.13-.1.26-.19.54-.27.82m3.13-13-1-1c1.06-4.72,2.15-9.61,3.21-14.45a29.74,29.74,0,0,0,.48,3.89c-.9,3.88-1.79,7.75-2.68,11.55"
            />
          </clipPath>
          <clipPath id="clip-path-58" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="419.85"
              y="394.68"
              width="70.09"
              height="109.9"
            />
          </clipPath>
          <clipPath id="clip-path-59" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M461.12,500.69c-10.44,0-37.62-3.53-38.06-5.39-.24-.95,2.63-17.36,6.24-36.13l3.3,3c-.8,4.05-1.65,8.34-2.35,12.07a2.12,2.12,0,0,0,.33,1.61,1.79,1.79,0,0,0,1.35.8l13.74,1.1h.13a1.89,1.89,0,0,0,1.82-1.61v-.23l15.89,14.48C462,490,453,489,444.37,488.21c-4.89-.48-15.58-1.53-18.13-1.53a1.57,1.57,0,0,0-.53,0c-.54.39-1.31,4.49-1.15,6.09,0,.46.17.74.37.81,1.7.72,34.24,4.25,36.56,4.49l1.34,2.12.1-.39c.35-1.27,1.87-7,1.15-8.85l2.9,2.65c-1,3.87-1.71,6.27-2,6.59s-1.79.5-4,.5m13-36.75-3.28-3.18,1.45-7.62a2,2,0,0,0-1.47-2.38l-.1,0a75.29,75.29,0,0,0-10.92-.7l-11.08-10.77,4.18.33h.13A1.9,1.9,0,0,0,454.7,438l4.83-25.23a2,2,0,0,0-1.47-2.38l-.1,0a75.66,75.66,0,0,0-11.45-.72h-2.46a1.94,1.94,0,0,0-1.8,1.58c-.71,3.54-2.24,11.15-3.66,18.36l-2.87-2.78c2.83-13.33,5.27-23.54,6.22-24.57.36-.38,3.31-.55,7.56-.55,12.7,0,36.89,1.5,36.89,3.19,0,1.36-2.93,15.72-6.64,32.91A21.18,21.18,0,0,0,477.17,449v.48c-1.06,4.84-2.15,9.73-3.21,14.45m-12.35-48-.47,2.62,17.25,2.19.65-2.57L461.61,416m2.17-4.38h-1.47l-.55,2.66a161.31,161.31,0,0,1,20.31,2.13l.4-2.61a108.09,108.09,0,0,0-18.69-2.2"
            />
          </clipPath>
          <clipPath id="clip-path-60" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="422.71"
              y="402.43"
              width="62.94"
              height="99.06"
            />
          </clipPath>
          <clipPath id="clip-path-61" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M481.87,513h0A27.1,27.1,0,0,1,471,493.75h0a46.8,46.8,0,0,1,0-12.4c.05-.35.11-.69.17-1l.75-3.11c.08-.29.17-.56.27-.82a19.07,19.07,0,0,1,2.06-4.29c.55-.87,1.92-2.33,3.29-4,1.67-2.06,3.33-4.45,3.48-6.5a21,21,0,0,1-1.27-2.45,30.3,30.3,0,0,1-2-6.44,29.44,29.44,0,0,1-.48-3.87v-.48a21.27,21.27,0,0,1,2.55-11.27,11.51,11.51,0,0,1,2.12-2.71,5.49,5.49,0,0,1,1.41-1,7.46,7.46,0,0,1,2.76-.78h.36a4,4,0,0,1,1.6.28h0s-2.2,15.36-.81,24.89h0c.93,6.43,3.81,17.55,5.51,24.6.51,1.94.93,3.91,1.25,5.89a2.81,2.81,0,0,1,0,.41h0c-.13.73-3.18,6.82-6.19,12.71s-6,11.64-6,11.64"
            />
          </clipPath>
          <clipPath id="clip-path-62" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="469.91"
              y="433.38"
              width="24.31"
              height="80.48"
            />
          </clipPath>
          <clipPath id="clip-path-63" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M309,695.92s19.52-9.77,31.63-18,27.63-28.15,27.63-28.15-7.58,24.54-17.58,33.54S309,695.92,309,695.92"
            />
          </clipPath>
          <clipPath id="clip-path-64" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M454.75,575h0a33.53,33.53,0,0,1-4-5.25c-1.69-2.75-3.73-6.47-5.88-10.63,5.37,9.14,9.94,15.89,9.94,15.89"
            />
          </clipPath>
          <clipPath id="clip-path-65" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="444.17"
              y="558.75"
              width="10.01"
              height="15.48"
            />
          </clipPath>
          <clipPath id="clip-path-66" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M454.74,575c-.8-.37-46.33-21-57.93-30.71-8.89-7.46-6.54-25.95-4.9-34.39a22.67,22.67,0,0,1,8.44-10.71c4-2.55,13.21-4.68,13.21-4.68h0s13.23,28.66,21.15,45.67c3,6.58,6.73,13.24,10.07,19,2.15,4.17,4.19,7.88,5.88,10.64a33.45,33.45,0,0,0,4,5.24"
            />
          </clipPath>
          <clipPath id="clip-path-67" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M467.17,546.92l-1.84-9.74h0s.61,2.25,1.84,9.74h0"
            />
          </clipPath>
          <clipPath id="clip-path-68" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="465.62"
              y="537.08"
              width="1.43"
              height="9.29"
            />
          </clipPath>
          <clipPath id="clip-path-69" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M467.17,546.92c-1.23-7.49-1.84-9.74-1.84-9.74s8.95-11.31,19.39-11.81a36.14,36.14,0,0,0-17.55,21.55"
            />
          </clipPath>
          <clipPath id="clip-path-70" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M472.83,400l-18.3-1.18-.22-.83s12,.22,19.35,1.1l-.83,1"
            />
          </clipPath>
          <clipPath id="clip-path-71" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M462.21,518.35s6.1-6.38,6.79-7.12,2-16.78,2-16.78l-4.67,17.7L450,509.79s3.73,5.75,12.26,8.56Z"
            />
          </clipPath>
          <clipPath id="clip-path-72" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="449.89"
              y="495.29"
              width="21.45"
              height="23.22"
            />
          </clipPath>
          <clipPath id="clip-path-73" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M485.06,425.25l3.67-15.09h.58a39.55,39.55,0,0,1-3.66,15.41l-.59-.32Z"
            />
          </clipPath>
          <clipPath id="clip-path-74" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="485.64"
              y="410.16"
              width="4.29"
              height="15.48"
            />
          </clipPath>
          <clipPath id="clip-path-75" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M380.38,339.38s2.09-21.42,0-33.58-8.65-25.46-8.65-25.46,13.41,5.49,16.3,11.12-1.44,24.78-2.16,31.36-5.49,16.52-5.49,16.52"
            />
          </clipPath>
          <clipPath id="clip-path-76" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M295.66,585.93c-16.45-3.52-35.05-19.95-39.93-26.4S243.81,532,243.81,532a82.76,82.76,0,0,0,7.17,13.8c2.32,3.88,6.43,11.26,18.72,21.61a198.36,198.36,0,0,0,26,18.55h0"
            />
          </clipPath>
          <clipPath id="clip-path-77" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M295.66,585.93a225.34,225.34,0,0,1-25.92-18.52h0c-2.64-2.28-5.2-4.67-7.53-7.13A93.9,93.9,0,0,1,251,545.8v0c-2.32-3.86-7.14-13.75-7.14-13.75s15.36,19.14,30.22,32.52,21.55,21.41,21.55,21.41"
            />
          </clipPath>
          <clipPath id="clip-path-78" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M269.7,567.41c-12.29-10.34-16.4-17.73-18.72-21.61a93.9,93.9,0,0,0,11.19,14.48c2.33,2.46,4.89,4.85,7.53,7.13"
            />
          </clipPath>
          <clipPath id="clip-path-79" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M392,582.08h0c.54-1.8.86-2.79.87-2.8h0l-.87,2.8"
            />
          </clipPath>
          <clipPath id="clip-path-80" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="391.24"
              y="578.88"
              width="1.43"
              height="3.09"
            />
          </clipPath>
          <clipPath id="clip-path-81" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M392,582.08h0c.29-.94.59-1.87.9-2.77,0,0-.33,1-.87,2.81m-1.65-1.5c-2-2-5.42-5.48-6.27-8.54-.32-1.1-.37-4.32-.27-8.66L385,564c.07,3.75.47,6.53,1.32,7.68a66.2,66.2,0,0,0,6.63,7.62l-2.52,1.32"
            />
          </clipPath>
          <clipPath id="clip-path-82" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M392,582.05c-.16-.13-.78-.66-1.62-1.46l2.52-1.31h0c-.31.9-.61,1.83-.9,2.77"
            />
          </clipPath>
          <clipPath id="clip-path-83" transform="translate(2.38)">
            <polyline
              class="cls3-1"
              points="412.47 493.7 412 493.48 412.1 493.48 412.47 493.74"
            />
          </clipPath>
          <clipPath id="clip-path-84" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="411.26"
              y="492.2"
              width="1.43"
              height="1.55"
            />
          </clipPath>
          <clipPath id="clip-path-85" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M387.77,530.12c-.43-2.2-.86-4.5-1.23-6.88.14-1.17.28-2.11.39-2.77,1.27-7.24,6.5-18.77,9.83-20.73,3.15-1.85,14-5.81,15.19-6.22l.47.22,1.09.74s-16.67,2-20.7,11c0,0-.44,1.67-1,4.34a38.74,38.74,0,0,0-2.35,8.51c-.44,2.69-1.07,6.86-1.74,11.73"
            />
          </clipPath>
          <clipPath id="clip-path-86" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M384.93,560.88l-1-.2c.42-11.92,1.77-29.69,2.69-37.47.37,2.38.8,4.72,1.23,6.87-1.31,9.65-2.72,21.94-2.89,30.8"
            />
          </clipPath>
          <clipPath id="clip-path-87" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M391.91,509.84c.53-2.67,1-4.34,1-4.34,4-9,20.68-11.05,20.68-11.05h0s-9.24,2.13-13.21,4.67A22.65,22.65,0,0,0,392,509.84"
            />
          </clipPath>
          <clipPath id="clip-path-88" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M470.61,586.45h0l-.07-1a4.48,4.48,0,0,0,.07,1m-.1-1.46-.22-3.07c0,.62.1,1.19.14,1.71V585"
            />
          </clipPath>
          <clipPath id="clip-path-89" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="469.91"
              y="581.97"
              width="1.43"
              height="4.64"
            />
          </clipPath>
          <clipPath id="clip-path-90" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M483.46,597.21c-2-3.15-4.1-6.43-5.81-9.28a98.24,98.24,0,0,1,5.81,9.28m-2.85-1.71h0a21.71,21.71,0,0,0-5.21-6.16,17.39,17.39,0,0,1,5.26,6.16"
            />
          </clipPath>
          <clipPath id="clip-path-91" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M470.51,585h0V583.6c0-.52-.08-1.1-.14-1.71l-.29-4.25h0c.17,2.37.32,4.39.42,6V585"
            />
          </clipPath>
          <clipPath id="clip-path-92" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M486.71,629.48s-2.47-27.35-6.14-33.94a17.35,17.35,0,0,0-5.26-6.15,21.38,21.38,0,0,0-4.7-2.94h0c0-.32,0-.65-.07-1v-1.85c-.1-1.52-.25-3.58-.42-5.94.23.29,3.91,5,7.6,10.28,1.71,2.86,3.8,6.13,5.81,9.28a20.47,20.47,0,0,1,1.7,4c1.69,6.58,1.59,28.2,1.59,28.2"
            />
          </clipPath>
          <clipPath id="clip-path-93" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M434.44,573.61l-23.31-11.2c3.61,1.41,23.31,11.2,23.31,11.2"
            />
          </clipPath>
          <clipPath id="clip-path-94" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M434.44,573.61h0c-.15,0-31.71-2.88-35.93-3.3h0c-2.23-.23-8.32-3.36-13.58-6.27v-3.11A104.39,104.39,0,0,0,396,562.45c3.19.23,5.93.32,8.18.32a59.6,59.6,0,0,0,6.94-.32h0l23.31,11.2h0m-50.62-10.22c-4.24-2.37-7.68-4.39-7.68-4.39s3.23.86,7.76,1.73c0,1-.06,1.85-.08,2.7"
            />
          </clipPath>
          <clipPath id="clip-path-95" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M384.93,564l-1.11-.62c0-.85,0-1.75.08-2.69l1,.19V564"
            />
          </clipPath>
          <clipPath id="clip-path-96" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M428.43,599.08l-.13-.16.13.15V599m-.28-.42a38.83,38.83,0,0,0-5.6-5.92c-2.28-1.65-29.67-13.38-29.67-13.38h0s24.58,8.77,30.72,14.25a46,46,0,0,1,4.55,5.09"
            />
          </clipPath>
          <clipPath id="clip-path-97" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="392.67"
              y="578.88"
              width="35.76"
              height="20.13"
            />
          </clipPath>
          <clipPath id="clip-path-98" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M437.62,599.08l-10.07-2.92,1,2.91-.13-.15a3.89,3.89,0,0,0-.27-.34,46,46,0,0,0-4.55-5.09c-6.14-5.48-30.72-14.26-30.72-14.26s22.1,6.29,30.22,9.54A45,45,0,0,1,437.6,599"
            />
          </clipPath>
          <clipPath id="clip-path-99" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M339.29,393.07a44.43,44.43,0,0,0,3.3-3.55,26,26,0,0,1-1.69,2.19h0a21.22,21.22,0,0,1-1.61,1.39m9-32.15a36.51,36.51,0,0,1,.61-6.85c.32-.86.62-1.66.89-2.4a40.06,40.06,0,0,0-1.5,9.25"
            />
          </clipPath>
          <clipPath id="clip-path-100" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="339.75"
              y="351.35"
              width="10.01"
              height="41.79"
            />
          </clipPath>
          <clipPath id="clip-path-101" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M339.28,393.08c-.29-10.18,5.88-28.77,9.6-39a36.48,36.48,0,0,0-.61,6.84,57,57,0,0,0,1.61,16.33,132.28,132.28,0,0,1-7.29,12.28,44.43,44.43,0,0,1-3.3,3.55h0"
            />
          </clipPath>
          <clipPath id="clip-path-102" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M349.77,351.67c.19-.65.39-1.29.62-1.92l.44-.87c-.29.75-.65,1.69-1.06,2.79"
            />
          </clipPath>
          <clipPath id="clip-path-103" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="349.76"
              y="348.25"
              width="1.43"
              height="3.09"
            />
          </clipPath>
          <clipPath id="clip-path-104" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M350.39,349.75c.37-1,.78-2,1.24-2.94,0,0-.3.76-.8,2.07l-.44.87"
            />
          </clipPath>
          <clipPath id="clip-path-105" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M380.72,605.68s2.94,7.33,3.4,8.11,3.4,2.05,3.4,2.05-.92,22.29-.6,36.77c.27,12.9,7.41,58.13,7.41,58.13s-4.87-42.55-5.73-59.61,3.15-37.29,3.15-37.29l-5.51-7.34-1,6.58-4.53-7.37Z"
            />
          </clipPath>
          <clipPath id="clip-path-106" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="379.8"
              y="605.19"
              width="14.3"
              height="105.25"
            />
          </clipPath>
          <clipPath id="clip-path-107" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M495.92,637.32c.24-.57.48-1.1.71-1.75-.23.6-.47,1.18-.71,1.75"
            />
          </clipPath>
          <clipPath id="clip-path-108" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="495.66"
              y="636.14"
              width="1.43"
              height="1.55"
            />
          </clipPath>
          <clipPath id="clip-path-109" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M500.72,623.69l-2-2.92c2.41-3.36,4.47-5.85,4.47-5.85s-.87,3.59-2.46,8.78"
            />
          </clipPath>
          <clipPath id="clip-path-110" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M488.31,650.15q1.28-8.37,3.32-16.57c1-3.8,4.28-8.9,7.05-12.81l2,2.92c-1,3.42-2.4,7.53-4,11.77v.11c-.23.6-.47,1.18-.71,1.75a61.6,61.6,0,0,1-7.61,12.83"
            />
          </clipPath>
          <clipPath id="clip-path-111" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M394.37,710.69s-3.52,5.73-15.66,10.27a155.4,155.4,0,0,1-26,7.09s10.16-.83,25-3.57,18.87-8.26,18.87-8.26,0-3.86-2.25-5.48Z"
            />
          </clipPath>
          <clipPath id="clip-path-112" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="352.62"
              y="710.44"
              width="44.34"
              height="17.02"
            />
          </clipPath>
          <clipPath id="clip-path-113" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M306.55,404.58s-3.68-21.11-9.07-30.21-15.1-29.78-15.1-29.78l-1.68-5.21s-.32-27.53,3.33-38.58c0,0-10.34,25.47-8.13,44.78l3.43.58s6.79,16.22,14.68,27.72,12.46,30.71,12.46,30.71Z"
            />
          </clipPath>
          <clipPath id="clip-path-114" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="273.95"
              y="300.26"
              width="32.9"
              height="103.7"
            />
          </clipPath>
          <clipPath id="clip-path-115" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M279.41,294.38s-1.55-4.67,2.09-10.54,28.55-28.95,42.72-33.29a137,137,0,0,1,28.91-5.09s-19.2-1.09-33.23,5.09-42.38,30.51-43.18,34.61,2.7,9.22,2.7,9.22Z"
            />
          </clipPath>
          <clipPath id="clip-path-116" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="275.38"
              y="244.54"
              width="77.24"
              height="49.53"
            />
          </clipPath>
          <clipPath id="clip-path-117" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M272.72,459.18S247,485.33,243.81,493.45s3.32,76.78,3.32,76.78-8.78-67.82-8-75.89,33.6-35.2,33.6-35.2Z"
            />
          </clipPath>
          <clipPath id="clip-path-118" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="238.19"
              y="459.69"
              width="34.33"
              height="111.45"
            />
          </clipPath>
          <clipPath id="clip-path-119" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M453,439.27h-.11l-4.63-.37-9.24-9c1.42-7.28,3-15,3.71-18.57a1.54,1.54,0,0,1,1.45-1.28h2.38a76,76,0,0,1,11.47.71,1.61,1.61,0,0,1,1.32,1.8c0,.06,0,.11,0,.16L454.46,438a1.53,1.53,0,0,1-1.47,1.3m-1.61-4.19c-.54,0-1.09.85-.61,1.82a5,5,0,0,0,1.45,1.63c1.1-.54,2.33-2.36,1.58-3.12a.62.62,0,0,0-.45-.21c-.48,0-.9.66-.9.66s-.53-.78-1.07-.78"
            />
          </clipPath>
          <clipPath id="clip-path-120" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="438.45"
              y="410.16"
              width="20.02"
              height="29.41"
            />
          </clipPath>
          <clipPath id="clip-path-121" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M453,439.65h-.13l-4.18-.33-.43-.42,4.63.37H453a1.54,1.54,0,0,0,1.47-1.31l4.86-25.2a1.64,1.64,0,0,0-1.18-1.93H458a74.55,74.55,0,0,0-11.47-.7h-2.39a1.53,1.53,0,0,0-1.45,1.27c-.73,3.55-2.29,11.3-3.71,18.57l-.31-.3c1.42-7.22,3-14.83,3.66-18.36a1.94,1.94,0,0,1,1.8-1.58h2.46a77,77,0,0,1,11.45.71,2,2,0,0,1,1.59,2.29.5.5,0,0,0,0,.12l-4.83,25.22a1.89,1.89,0,0,1-1.82,1.61"
            />
          </clipPath>
          <clipPath id="clip-path-122" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="438.45"
              y="410.16"
              width="21.45"
              height="29.41"
            />
          </clipPath>
          <clipPath id="clip-path-123" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M445.8,477.4h-.11L432,476.31a1.52,1.52,0,0,1-1.1-.65,1.74,1.74,0,0,1-.26-1.3c.69-3.66,1.52-7.87,2.32-11.86l12,11-.18.24s-.53-.78-1.07-.78-1.09.83-.6,1.81a4.76,4.76,0,0,0,1.45,1.63,3.77,3.77,0,0,0,1.63-1.78l1.21,1.09-.08.44a1.58,1.58,0,0,1-1.48,1.3"
            />
          </clipPath>
          <clipPath id="clip-path-124" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="429.86"
              y="462.78"
              width="17.16"
              height="15.48"
            />
          </clipPath>
          <clipPath id="clip-path-125" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M445.8,477.79h-.13l-13.74-1.1a1.79,1.79,0,0,1-1.35-.8,2.12,2.12,0,0,1-.33-1.61c.7-3.72,1.55-8,2.35-12.07l.32.28c-.8,4-1.63,8.2-2.32,11.85a1.76,1.76,0,0,0,.26,1.31,1.52,1.52,0,0,0,1.1.65l13.73,1.09h.11a1.57,1.57,0,0,0,1.48-1.29l.08-.44.31.29v.23a1.88,1.88,0,0,1-1.82,1.6"
            />
          </clipPath>
          <clipPath id="clip-path-127" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M470.48,460.49l-10.34-10a73.61,73.61,0,0,1,10.48.7,1.62,1.62,0,0,1,1.26,1.86s0,.05,0,.08l-1.41,7.38"
            />
          </clipPath>
          <clipPath id="clip-path-128" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="459.9"
              y="450.4"
              width="11.44"
              height="9.29"
            />
          </clipPath>
          <clipPath id="clip-path-129" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M470.79,460.8l-.31-.31,1.41-7.38a1.64,1.64,0,0,0-1.18-1.93h-.07a73.61,73.61,0,0,0-10.48-.7l-.39-.39a75.3,75.3,0,0,1,10.92.71,2,2,0,0,1,1.59,2.28s0,.08,0,.12l-1.45,7.61"
            />
          </clipPath>
          <clipPath id="clip-path-130" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="459.9"
              y="450.4"
              width="12.87"
              height="10.84"
            />
          </clipPath>
          <clipPath id="clip-path-131" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M482.07,416.4a161.31,161.31,0,0,0-20.31-2.13l.55-2.61h1.47a107.75,107.75,0,0,1,18.67,2.2l-.4,2.61"
            />
          </clipPath>
          <clipPath id="clip-path-132" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="462.76"
              y="411.71"
              width="20.02"
              height="4.64"
            />
          </clipPath>
          <clipPath id="clip-path-133" transform="translate(2.38)">
            <polyline
              class="cls3-1"
              points="478.39 420.7 461.14 418.55 461.61 415.93 479.04 418.12 478.39 420.7"
            />
          </clipPath>
          <clipPath id="clip-path-134" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="461.33"
              y="416.36"
              width="18.59"
              height="4.64"
            />
          </clipPath>
          <clipPath id="clip-path-135" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M452.23,438.52a4.83,4.83,0,0,1-1.45-1.62c-.48-1,.07-1.82.61-1.82s1.07.78,1.07.78.42-.66.9-.66a.62.62,0,0,1,.45.21c.75.76-.48,2.58-1.58,3.11"
            />
          </clipPath>
          <clipPath id="clip-path-136" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="449.89"
              y="434.93"
              width="4.29"
              height="3.09"
            />
          </clipPath>
          <clipPath id="clip-path-137" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M444.52,476.37a4.76,4.76,0,0,1-1.45-1.63c-.49-1,.06-1.81.6-1.81s1.07.78,1.07.78l.18-.24,1.23,1.09a3.75,3.75,0,0,1-1.63,1.79"
            />
          </clipPath>
          <clipPath id="clip-path-138" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="442.74"
              y="473.62"
              width="2.86"
              height="3.09"
            />
          </clipPath>
          <clipPath id="clip-path-139" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M462.79,499.34l-1-1.59h-.08c-.34,0-34.86-3.76-36.54-4.46,0,0-.09-.06-.14-.46a15.8,15.8,0,0,1,1-5.75h.29c3.55,0,36,3.29,37.35,3.8,1,.39,0,5.26-.82,8.49"
            />
          </clipPath>
          <clipPath id="clip-path-140" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="424.14"
              y="487.55"
              width="40.05"
              height="12.38"
            />
          </clipPath>
          <clipPath id="clip-path-141" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M462.92,500.23l-1.34-2.12c-2.31-.24-34.86-3.77-36.56-4.48-.2-.08-.32-.35-.37-.82-.16-1.6.61-5.7,1.16-6.08a1.14,1.14,0,0,1,.52,0c2.52,0,13.21,1,18.13,1.52,8.6.86,17.61,1.87,19.14,2.2l.61.56c.73,1.82-.8,7.57-1.15,8.85l-.1.38M426.3,487.08h-.25a15.8,15.8,0,0,0-1,5.75c0,.4.14.45.14.46,1.68.7,36.2,4.38,36.54,4.46h.08l1,1.59c.86-3.23,1.78-8.1.82-8.49-1.33-.52-33.8-3.8-37.35-3.8"
            />
          </clipPath>
          <clipPath id="clip-path-142" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="424.14"
              y="486"
              width="40.05"
              height="13.93"
            />
          </clipPath>
          <clipPath id="clip-path-143" transform="translate(2.38)">
            <polyline
              class="cls3-1"
              points="475.08 464.98 475.08 464.97 475.08 464.97 475.08 464.98"
            />
          </clipPath>
          <clipPath id="clip-path-144" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="474.2"
              y="464.34"
              width="1.43"
              height="1.55"
            />
          </clipPath>
          <clipPath id="clip-path-145" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M468,494.45l-.89-.8c1.72-6.67,4.29-17.65,7-29.67l1,1h0L472,477.92a27.44,27.44,0,0,0-.75,3.1L468,494.44M429.3,459.2l-.43-.4,6.48-32.41.45.44c-2.11,9.87-4.42,21.53-6.5,32.37"
            />
          </clipPath>
          <clipPath id="clip-path-146" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M467.07,493.65l-2.9-2.66a.9.9,0,0,0-.44-.5l-.17-.06L447.67,476l4.78-25a2.15,2.15,0,0,0-.31-1.57,1.75,1.75,0,0,0-1.26-.83,75.66,75.66,0,0,0-11.45-.72H437a1.92,1.92,0,0,0-1.79,1.58c-.53,2.61-1.52,7.5-2.58,12.81l-3.3-3c2.08-10.84,4.39-22.47,6.5-32.37l2.87,2.79c-.45,2.24-.88,4.47-1.26,6.5a2.14,2.14,0,0,0,.33,1.62,1.85,1.85,0,0,0,1.35.79l9.56.77,11.08,10.77h-3a1.94,1.94,0,0,0-1.8,1.58c-.93,4.62-3.28,16.28-4.92,24.88a2.12,2.12,0,0,0,.33,1.61,1.83,1.83,0,0,0,1.35.79l13.74,1.1h.13a1.9,1.9,0,0,0,1.82-1.62l3.38-17.64,3.28,3.18c-2.71,12.06-5.28,23-7,29.61"
            />
          </clipPath>
          <clipPath id="clip-path-147" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M471.2,481a27.6,27.6,0,0,1,.75-3.11L471.2,481"
            />
          </clipPath>
          <clipPath id="clip-path-148" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M448.21,438.89l-9.07-.73a1.48,1.48,0,0,1-1.1-.65,1.79,1.79,0,0,1-.27-1.3c.38-2,.8-4.1,1.23-6.29l9.24,9"
            />
          </clipPath>
          <clipPath id="clip-path-149" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M448.65,439.27l-9.56-.77a1.85,1.85,0,0,1-1.35-.79,2.14,2.14,0,0,1-.33-1.62c.38-2,.81-4.26,1.26-6.51l.31.3c-.43,2.19-.85,4.32-1.23,6.29a1.8,1.8,0,0,0,.27,1.3,1.47,1.47,0,0,0,1.13.7l9.07.73.43.42"
            />
          </clipPath>
          <clipPath id="clip-path-150" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M447.36,475.67l-1.21-1.09a1.17,1.17,0,0,0-.06-1.34.6.6,0,0,0-.44-.2,1.08,1.08,0,0,0-.73.42l-12-11c1.06-5.39,2.07-10.36,2.6-13a1.57,1.57,0,0,1,1.46-1.27h2.36a74.68,74.68,0,0,1,11.48.71,1.48,1.48,0,0,1,1,.68,1.68,1.68,0,0,1,.24,1.26l-4.73,24.82"
            />
          </clipPath>
          <clipPath id="clip-path-151" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M447.67,476l-.31-.29,4.73-24.82a1.68,1.68,0,0,0-.24-1.26,1.45,1.45,0,0,0-1-.68,74.68,74.68,0,0,0-11.48-.71H437a1.54,1.54,0,0,0-1.45,1.27c-.54,2.65-1.55,7.62-2.61,13l-.32-.28c1.06-5.31,2-10.2,2.58-12.81a1.92,1.92,0,0,1,1.79-1.58h2.46a75.66,75.66,0,0,1,11.45.72,1.75,1.75,0,0,1,1.26.83,2.15,2.15,0,0,1,.31,1.57l-4.78,25"
            />
          </clipPath>
          <clipPath id="clip-path-152" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M465.58,479.66h-.1l-13.73-1.09a1.59,1.59,0,0,1-1.39-1.75,1.23,1.23,0,0,1,0-.19c1.64-8.59,4-20.26,4.94-24.87a1.53,1.53,0,0,1,1.45-1.27h3.37l10.34,10-3.42,17.88a1.57,1.57,0,0,1-1.48,1.31m-1.49-4.25h0c-.54,0-1.1.85-.6,1.82a4.78,4.78,0,0,0,1.45,1.64c1.09-.54,2.32-2.36,1.57-3.13a.62.62,0,0,0-.45-.21c-.49,0-.9.66-.9.66s-.54-.78-1.07-.78"
            />
          </clipPath>
          <clipPath id="clip-path-153" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M465.59,480.06h-.13L451.72,479a1.77,1.77,0,0,1-1.35-.79,2.12,2.12,0,0,1-.33-1.61c1.64-8.6,4-20.26,4.92-24.88a1.92,1.92,0,0,1,1.8-1.57h3l.39.38H456.8a1.53,1.53,0,0,0-1.45,1.27c-.94,4.61-3.3,16.28-4.94,24.87a1.63,1.63,0,0,0,1.19,1.91l.18,0,13.73,1.09h.1a1.55,1.55,0,0,0,1.48-1.3l3.42-17.88.31.31-3.38,17.65a1.89,1.89,0,0,1-1.82,1.61"
            />
          </clipPath>
          <clipPath id="clip-path-154" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M446.19,474.58l-1.23-1.1a1.12,1.12,0,0,1,.73-.42.69.69,0,0,1,.44.2,1.17,1.17,0,0,1,.06,1.34"
            />
          </clipPath>
          <clipPath id="clip-path-155" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M464.94,478.91a4.78,4.78,0,0,1-1.45-1.64c-.5-1,.06-1.82.6-1.82h0c.53,0,1.07.78,1.07.78s.41-.66.9-.66a.62.62,0,0,1,.45.21c.75.77-.48,2.59-1.57,3.13"
            />
          </clipPath>
          <clipPath id="clip-path-156" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M464.17,491l-.61-.56.17.06a.9.9,0,0,1,.44.5"
            />
          </clipPath>
          <clipPath id="clip-path-157" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M480.44,377.11a2,2,0,0,1-.49-.06c-2.83-.8-1.07-12.63-2.12-23.68s-1-25.39,8.2-25.83h.26c6.59,0,12.51,11.79,9.93,27.35-2.46,15-12.36,22.22-15.78,22.22m7.42-37.84c-3,0-5.3,1.73-6.7,5.06-2.37,5.63-1.44,14.51,1,17.29a4.25,4.25,0,0,0,3.18,1.47,4.74,4.74,0,0,0,1.35-.2c2.4-.7,5.39-3.42,6.62-8.94.94-4.19.09-9.6-2-12.57a4.27,4.27,0,0,0-3.11-2.11h-.38"
            />
          </clipPath>
          <clipPath id="clip-path-158" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="477.06"
              y="328.13"
              width="21.45"
              height="49.53"
            />
          </clipPath>
          <clipPath id="clip-path-159" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M485.35,362.58a3.71,3.71,0,0,1-2.85-1.33c-2.36-2.67-3.24-11.29-.93-16.78.93-2.19,2.77-4.79,6.28-4.79h.39A3.82,3.82,0,0,1,491,341.6c2,2.87,2.8,8.12,1.9,12.18-1,4.39-3.46,7.77-6.32,8.6a4.14,4.14,0,0,1-1.26.19m-1.52-14.26a2.06,2.06,0,0,0-1.43.68,2.28,2.28,0,0,0-.67,1.7c0,2.72,3.71,6.41,3.87,6.58l.09.09h.12c.19-.07,4.62-1.62,5.49-4.94a3,3,0,0,0-.38-2.83,2.32,2.32,0,0,0-1.74-.8h-.37a4,4,0,0,0-2.38,1.85c-.34-.66-1.15-2-2.26-2.26h-.34m2,8.5c-.58-.58-3.64-3.83-3.64-6.12a1.8,1.8,0,0,1,.52-1.36,1.67,1.67,0,0,1,1.15-.56h.25c1.24.27,2.13,2.34,2.14,2.37l.17.41.2-.39a4,4,0,0,1,2.29-2h.3a2,2,0,0,1,1.43.65,2.65,2.65,0,0,1,.27,2.4c-.72,2.79-4.38,4.31-5.08,4.58"
            />
          </clipPath>
          <clipPath id="clip-path-160" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="479.92"
              y="338.97"
              width="14.3"
              height="23.22"
            />
          </clipPath>
          <clipPath id="clip-path-161" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M485.37,363a4.18,4.18,0,0,1-3.18-1.47c-2.45-2.77-3.38-11.66-1-17.28,1.4-3.29,3.71-5.06,6.7-5.06h.38a4.24,4.24,0,0,1,3.11,2.11c2,3,2.91,8.38,2,12.57-1.23,5.48-4.22,8.23-6.62,8.93a4.74,4.74,0,0,1-1.35.2m2.48-23.36c-3.51,0-5.35,2.59-6.28,4.79-2.31,5.49-1.43,14.11.93,16.78a3.71,3.71,0,0,0,2.85,1.33,4.14,4.14,0,0,0,1.26-.19c2.86-.83,5.34-4.21,6.32-8.59.9-4.07.09-9.32-1.9-12.19a3.82,3.82,0,0,0-2.79-1.92h-.39"
            />
          </clipPath>
          <clipPath id="clip-path-162" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="478.49"
              y="338.97"
              width="15.73"
              height="23.22"
            />
          </clipPath>
          <clipPath id="clip-path-163" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M456.32,373.68a11.5,11.5,0,0,1-9.11-4.61,11,11,0,0,1-1.64-3.68c4.52-11.76,3.32-19.89.93-24.28a17.16,17.16,0,0,1,5.15-7.88,12.57,12.57,0,0,1,7.65-3c8.05,0,14.1,10.62,10.45,30.18-1.65,8.88-7.59,13.28-13.38,13.28m2.16-34.34a7.34,7.34,0,0,0-5.38,2.84,16.47,16.47,0,0,0-3.71,11.75c.4,4.51,2,7.92,4.6,9.58a6.32,6.32,0,0,0,3.49,1.1,6.57,6.57,0,0,0,2.69-.58c4.84-2.19,7.33-10.54,6.34-16.61-.81-4.93-3.66-7.86-7.81-8h-.22"
            />
          </clipPath>
          <clipPath id="clip-path-164" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="445.6"
              y="329.68"
              width="27.17"
              height="43.33"
            />
          </clipPath>
          <clipPath id="clip-path-165" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M466.25,390.76c-1.53-1.95-2.19-11.57,1.12-14.36,4.75-4,11.08.71,8.31,11.17C474.31,392.69,468.63,393.81,466.25,390.76Z"
            />
          </clipPath>
          <clipPath id="clip-path-166" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="464.19"
              y="373.01"
              width="14.3"
              height="21.67"
            />
          </clipPath>
          <clipPath id="clip-path-167" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M457.48,364.07a6,6,0,0,1-3.26-1c-2.43-1.58-4-4.86-4.37-9.21a16.13,16.13,0,0,1,3.59-11.32,6.88,6.88,0,0,1,5-2.68h.21c5.37.22,6.92,4.87,7.37,7.62,1,5.88-1.42,14-6,16.06a6.12,6.12,0,0,1-2.52.55m-2.87-13-.48.35,3.66,5.82,6.05-7.43-.44-.42-5.5,6.83-3.25-5.15"
            />
          </clipPath>
          <clipPath id="clip-path-168" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="449.89"
              y="338.97"
              width="17.16"
              height="24.77"
            />
          </clipPath>
          <clipPath id="clip-path-169" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M457.48,364.57a6.48,6.48,0,0,1-3.49-1.1c-2.57-1.67-4.2-5.08-4.6-9.59a16.44,16.44,0,0,1,3.71-11.74,7.37,7.37,0,0,1,5.38-2.87h.22c4.15.18,7,3.11,7.81,8,1,6.07-1.5,14.46-6.34,16.61a6.57,6.57,0,0,1-2.69.58m1-24.73a6.92,6.92,0,0,0-5,2.68,16.16,16.16,0,0,0-3.59,11.37c.38,4.38,1.94,7.67,4.37,9.2a5.89,5.89,0,0,0,3.26,1,6.12,6.12,0,0,0,2.52-.55c4.63-2.06,7.05-10.18,6-16.06-.45-2.75-2-7.4-7.37-7.62h-.21"
            />
          </clipPath>
          <clipPath id="clip-path-170" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="448.46"
              y="338.97"
              width="18.59"
              height="24.77"
            />
          </clipPath>
          <clipPath id="clip-path-171" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M433.57,322.65c-7.78,0-12.84-3.12-14.1-6.38-1.59-4,3.85-14.4,17.65-21.34-1.25,1.45-4.87,6-4,9.16.37,1.41,1.54,2.37,3.48,2.85a9.13,9.13,0,0,0,2,.23c4.58,0,10.35-3.29,16.41-6.65a79.19,79.19,0,0,1,12.35-6c12-4.05,19.82-4.39,19.9-4.39h.83c9.93,2.71,13.75,7.07,13.75,7.07h-.34c-16.33,0-26.87,8.23-46.41,19.1-8.39,4.67-15.68,6.38-21.46,6.38M446.44,291a70.5,70.5,0,0,1,11.26-2.38A80.83,80.83,0,0,0,446.44,291m33-2.8c-2.59-.26-5.7-.45-9.21-.45-1.39,0-2.84,0-4.34.1,1.68-.09,3.31-.14,4.86-.14a74.33,74.33,0,0,1,8.69.49"
            />
          </clipPath>
          <clipPath id="clip-path-172" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="416.99"
              y="287.88"
              width="84.4"
              height="34.06"
            />
          </clipPath>
          <clipPath id="clip-path-173" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M408,399.6a11.62,11.62,0,0,1-3.26-.46c-9.06-2.73-11.87-17.19-5.81-35.87,5.18-16,23.46-28.08,36.26-28.08,3.92,0,7.33,1.1,9.67,3.64a11.17,11.17,0,0,1,1.58,2.2c2.39,4.39,3.59,12.52-.93,24.28-.48,1.23-1,2.48-1.6,3.79-6.42,13.93-23.83,30.45-35.89,30.45m19.56-56.24c-4.23,0-8.95,1.89-13.24,5.4-6.78,5.53-11,13.93-11,21.87,0,5.21,2.13,9.53,5.68,11.57a10.15,10.15,0,0,0,5.14,1.34c3.38,0,7.17-1.46,11.08-4.33,8.59-6.26,14.33-18,13.1-26.66a9.86,9.86,0,0,0-7.06-8.65,12.36,12.36,0,0,0-3.72-.54"
            />
          </clipPath>
          <clipPath id="clip-path-174" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="392.67"
              y="334.32"
              width="57.22"
              height="65.01"
            />
          </clipPath>
          <clipPath id="clip-path-175" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M387.66,372.77c-.72-6.21-9,1.62-15.56-1.7-3.68-1.86-4.39-4.45-5.42-4.45-1.39,0-2.45,6.94.73,11.58C374.07,388,388.78,382.59,387.66,372.77Z"
            />
          </clipPath>
          <clipPath id="clip-path-176" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="364.06"
              y="366.83"
              width="24.31"
              height="21.67"
            />
          </clipPath>
          <clipPath id="clip-path-177" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M407.6,328.18c-8.4,4.51-12.32,15.05-11,17.67s16.05-6,19.54-12.46-1.41-9-8.58-5.22Z"
            />
          </clipPath>
          <clipPath id="clip-path-178" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="395.53"
              y="323.48"
              width="24.31"
              height="24.77"
            />
          </clipPath>
          <clipPath id="clip-path-179" transform="translate(2.38)">
            <path
              class="cls3-1"
              d="M414.19,383.05a9.75,9.75,0,0,1-4.92-1.28c-3.45-2-5.42-6-5.43-11.13,0-7.79,4.13-16,10.8-21.47a21.06,21.06,0,0,1,12.95-5.32,12.53,12.53,0,0,1,3.6.51,9.44,9.44,0,0,1,6.7,8.26c1.25,8.52-4.39,20-12.85,26.14-3.86,2.81-7.56,4.23-10.85,4.23m3.43-31a3.74,3.74,0,0,0-.94.13c-4.24,1.1-6,7.29-5,17.55v.29H412c.39,0,9.71-.08,15.63-4.39,2.5-1.8,3.5-4.28,2.5-6.31a5,5,0,0,0-4.73-2.45,10.25,10.25,0,0,0-3.84.81c-.11-1-.54-3.66-2.07-4.9a3,3,0,0,0-1.86-.66m-5.38,17.37c-.92-9.68.69-15.55,4.57-16.53a3.1,3.1,0,0,1,.81-.11,2.36,2.36,0,0,1,1.51.53c1.7,1.36,1.92,4.85,1.92,4.85v.44l.38-.17a10,10,0,0,1,4-.92,4.42,4.42,0,0,1,4.19,2.13c.86,1.73,0,3.85-2.3,5.48-5.24,3.81-13.48,4.23-15.05,4.27"
            />
          </clipPath>
          <clipPath id="clip-path-180" transform="translate(2.38)">
            <rect
              class="cls3-1"
              x="404.11"
              y="343.61"
              width="35.76"
              height="38.7"
            />
          </clipPath>
        </defs>
        <g id="Capa_2" data-name="Capa 2">
          <g id="Capa_1-2" data-name="Capa 1">
            <g id="Capa_1-2-2" data-name="Capa 1-2">
              <g class="cls3-2">
                <rect class="cls3-3" width="1380.77" height="426.21" />
                <path
                  class="cls3-4"
                  d="M372.42,541.14c1.76,6.58-.83,13.44-2.52,20A76,76,0,0,0,368,588c.65,6.23,2.08,12.56.87,18.65-1.9,9.57-9.63,16.29-16.89,22.12a17.18,17.18,0,0,1-5.46,3.38c-3.62,1.1-7.42-.46-10.91-1.93A534.47,534.47,0,0,0,95,588.92c-12.09.75-24.4,1.93-36.38-.3a68.94,68.94,0,0,1-36.89-20.21A16.4,16.4,0,0,1,18,562.48a325.48,325.48,0,0,0,109.65-6.4c12.66-2.93,25.18-6.58,37.88-9.2,14.55-3,29.32-4.46,44.06-6l41.39-4.22c29.83-3,59.67-6.06,89.53-8.84C352.83,526.74,369,528.23,372.42,541.14Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-5"
                  d="M1000.09,563c-4.62-8.38,1-19.8,9.06-24.13s17.57-3.68,26.56-3.17A500,500,0,0,0,1115.1,534c11.41-1.17,22.89-2.75,33.72-6.76,6-2.26,11.9-5.25,18-7.28a121.72,121.72,0,0,1,19.72-4.21c32.43-5.06,65.3-10.13,97.82-5.88,8.15,1.09,16.89,2.6,24.17-1.45,4.63-2.56,8.43-7.25,13.58-8,3.23-.49,6.45.69,9.61,1.6,9.12,2.63,18.67,3.15,27.83,5.64s18.38,7.46,23.07,16.33c5.66,10.73,3.33,24.34-1.14,35.69s-11,21.94-13.61,33.9c-.74,3.36-1.19,6.88-2.82,9.87a22.45,22.45,0,0,1-4.82,5.69c-8.61,7.86-18.9,14.06-30.09,15.46-6.3.8-12.68,0-19-.88-18.9-2.79-37.54-7.29-56.16-11.78l-11.24-2.79c-6.37-1.54-12.76-3.07-19.13-4.39-26.85-5.31-54.25-5.9-81.53-6.47l-96.81-2.05c-16.61-.35-34.83-1.37-47-13.57-4.18-4.18-7.49-9.87-7.35-16.08s4.7-12.28,10.39-12.28"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-6"
                  points="1184.45 543.84 1186.76 515.99 1195.21 514.67 1195.21 558.47 1017.11 559.66 1017.11 543.84 1184.45 543.84"
                />
                <polyline
                  class="cls3-7"
                  points="1200.09 513.93 1201.56 410.96 1323.36 413.13 1375.7 397.89 1375.7 503.99 1326.38 514.67 1201.35 513.86"
                />
                <path
                  class="cls3-8"
                  d="M1202.4,513.11c-2.34-2.88-.06-7.61,2.86-9.7s6.57-3.29,8.46-6.58c1.37-2.37,1.5-5.48,2.89-7.82,2.17-3.72,7.14-5.23,8-9.6l-4.27-3.08a37.79,37.79,0,0,1,23.07-11.13,4.5,4.5,0,0,0-5-.89,62.23,62.23,0,0,0,12-3.57c-1.28.23-.29-2.19,1-2.64l14.92-4.8a3.31,3.31,0,0,0,2.29-1.63c.41-.94-.49-2.38-1.3-1.85l9.9-6.58a31.55,31.55,0,0,0-9.51-3.55c.58-1.67,2-2.75,3.28-3.8s2.6-2.36,2.84-4.12-1.33-3.81-2.78-3.1l7-7.86-7-2.7.64-3.08-5-1.1,1.52-2.77-5.73-1.21a11,11,0,0,1,8.69-6.23c-.87-1.37.15-3.35,1.48-4.16s2.9-.94,4.23-1.72c1.17-.68,1.24-3.45.06-2.82l4.87-2.06-2.42-1.57a2.6,2.6,0,0,0,2.57-2.64v0a2.85,2.85,0,0,0-.15-1,8,8,0,0,0,4.64-3.63l-3.15-3.7a3.26,3.26,0,0,1,3.16-1.91c2.91,1.69,1.55,8.11,4.69,9.13,2.12.69,4-2.44,3.31-4.79s-2.72-3.83-4.72-4.87c1.25-.4,1.69-2.3,1.19-3.64a7.54,7.54,0,0,0-2.74-3l-4.54-3.59,2.59-2.32c-2.86-.41-4.49-4.89-2.69-7.42a9.23,9.23,0,0,0-4-2l2.17-2.45c-3.16-3.9-7.68-5.95-12.09-7.87l-2.7-1.19-3-1.34c-4.88-2.2-9.89-4.39-15.11-4.44s-10.86,2.3-13.46,7.42l-21.3-7.39c-4.52-1.58-10.89-2.2-12.62,2.71a3.26,3.26,0,0,0-3.9-1.9,12.61,12.61,0,0,0-4,2.31,26,26,0,0,1-23,3.66c-1.39-.45-3-1-4.15.11s-.91,2.8-1,4.38c-.37,4.73-3.93,8.51-7.88,10.13s-8.29,1.5-12.5,1.36l-.61-3.23c-1.73-1.51-4.46-2.95-5.84-1-1,1.41-.34,3.57-1,5.22-2,5.4-11.76-2-14.1,3.23a9.23,9.23,0,0,1-1.08,10c-1.12,1.27-2.63,2.12-3.56,3.58s-.93,4,.55,4.64c-5.12,3-7.58,10.69-5.4,16.71a7.76,7.76,0,0,1,.82,3.29c-.14,1.47-1.3,2.69-1.27,4.17,0,2.93,3.78,3.19,6.38,3.06,6-.31,11.89,2.68,17.41,5.59,1.42.76,3,1.68,3.45,3.37s-.3,3.29-.22,5c.17,3.91,4.17,5.77,7.22,7.68,4.47,2.82,7.82,7.39,11.07,11.85l7,9.59a13.18,13.18,0,0,0,3.39,3.62c1.88,1.17,4.2,1.18,6.12,2.27,8.06,4.53,3.18,22.12,11.53,25.87-5,8.47-5.43,19.24-5.62,29.41q8.36.39,16.73,0a4.61,4.61,0,0,0,2.15-.46c2.37-1.42,1.42-5.61,2.86-8.13"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-8"
                  d="M1381,521.39l-12.61-4.59a9.87,9.87,0,0,0-3-.73c-1.24,0-2.52.37-3.68,0-2-.69-3-3.46-5.06-3.38-1.08,0-1.87.85-2.87,1.11-2.64.77-6.34-1.84-7.76.54a19.77,19.77,0,0,0-11.91.26,3.43,3.43,0,0,0-.78-3.43,5.75,5.75,0,0,1-8.27-.15,5.58,5.58,0,0,1-.73-.95c-.58-1.1-.89-2.48-2-3.08s-2.4-.3-3.22-1.1c-1.22-1.26.19-3.56-.65-5.11-1.54-2.82-7.46.69-8.47-2.37-.46-1.41.65-3.53-.67-4.18-.83-.4-1.88.36-2.71,0s-.75-1.88-.71-3-1.07-2.48-1.81-1.69l-1.57-5.7c-8-1-13.14-9.48-20.69-12.46-2.38-.94-5.67-2.43-4.93-4.92.57-1.94,3.53-3.05,2.92-5-.8-2.52-5.77-.23-6.8-2.66-.6-1.42.88-2.76,2-3.77s2-3.11.66-3.84a5.52,5.52,0,0,0-1.61-.3c-1.9-.37-2.68-2.95-1.93-4.78s2.44-3,4-4.12l-1.75-1.57,7.6-12.78a6.59,6.59,0,0,0,1-2.26c.33-2.34-1.82-5.16-.16-6.81a2.69,2.69,0,0,0,3.08-2.26,2.76,2.76,0,0,0-1.55-2.95,12.55,12.55,0,0,0,7.11-8.81c.28-1.34.4-2.83,1.29-3.86,1.48-1.67,4.5-1.44,5.6-3.4A6.39,6.39,0,0,1,1302,390c1.89-.78,4.12-.57,5.86-1.68s1.83-4.59-.2-4.64c1.42-3,4.7-4.54,7.73-5.83,7.82-3.3,15.66-6.68,23.84-8.93a95.07,95.07,0,0,1,21.19-3.31c4.19-.18,8.6-.14,12.26-2.2l6.75,2.87,4.15.53a35.38,35.38,0,0,1,.26,9l2.15-1.36v152Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-9"
                  d="M1077.29,408c-5.2-2.74-2.65-14.59-8.42-15.08l1.1-2.79a6,6,0,0,0-6.56,1.21,11.48,11.48,0,0,0,.37-10.91A3.26,3.26,0,0,0,1062,384a49.55,49.55,0,0,0,0-15.47l-1.89,8.77c-1.93-3.45-1.55-8,0-11.61s4.22-6.59,6.82-9.52l6.17-6.93-.66,3.55,4-1.1,6.72,4.73a14.47,14.47,0,0,1-1.63-6.24c.1-2.2,1.54-4.46,3.56-4.57a16.59,16.59,0,0,1,1.69,7.58c.66,2.9,4,5.07,6.33,3.36s.08-6.77-2.35-5.34l.69-9.52a3.07,3.07,0,0,0-3.25,0c-.17-4.31-3.77-7.33-6.22-10.73s-3.18-9.52.54-11.07c-1.49.71-2-2.19-1.33-3.79a33.59,33.59,0,0,1,10.07-13.39,3.63,3.63,0,0,1,2-1c1.09,0,2,.88,3,1.37s2.54.22,2.62-.95a7.34,7.34,0,0,0,2.71,2,9.48,9.48,0,0,0-7-9.26l1.34-4.05-3.6-2c-.1-3.29,3.62-5.29,6.68-5s5.92,1.9,9,2c2.88.07,6.73-.7,7.82,2.19.73,1.95-.58,4-1.37,5.92s-.54,4.95,1.39,5.15a2.83,2.83,0,0,0,3.86-1.6,3.29,3.29,0,0,0-1.48-4.2,2.39,2.39,0,0,0-.37-.15,2.71,2.71,0,0,0-1.84-.08,23.72,23.72,0,0,1,7.05-8.57,8.2,8.2,0,0,1-4.15-2.67c-1-1.44-.77-3.89.75-4.53-2.13.82-4.26-1.8-4.3-4.26s1.17-4.69,2-7,1-5.22-.63-6.92a15.66,15.66,0,0,1,11.54-3.75c.07,1.1.13,2.29.24,3.43a50.58,50.58,0,0,0,5.5,18.85l2.69.74a2.61,2.61,0,0,0-1,2.67c2.4.44,5.17.24,6.77-1.72s.7-5.95-1.71-6c2-.94,1.85-4.73-.21-5.48l1.79-3.45-8.52-14.05a8.18,8.18,0,0,0,1.21-9.24,23.37,23.37,0,0,0,12.52-15c1,2.14,4,1.32,6,.47a28,28,0,0,1,23.4,1.48c-.09,4-4.68,6.34-5.35,10.28a5.43,5.43,0,0,0,4.32,6.17h0a2.4,2.4,0,0,0,3.43-1,2.86,2.86,0,0,0-.91-3.73,2.29,2.29,0,0,0-2-.26,156.22,156.22,0,0,0,21-17.68l15.56-5.81,4.61,10.48a112.68,112.68,0,0,1-5.39,14.41,11.37,11.37,0,0,0,9.4-10.13,4.62,4.62,0,0,1,5.62-3.69h0l.25.08c-1.87,0-3.18,2.19-3.24,4.18s.72,3.92,1.25,5.85c2.44,9.57-1.2,19.74-8.94,25l1.79,5.6c-2.57.46-3,4.69-1.31,6.78s4.59,2.56,7.17,2.9c-1.4-.73-1.53-3-.69-4.39a10,10,0,0,1,3.65-3.05,35.32,35.32,0,0,0,12.59-13.89l4.21-2.19-3.59,21.62c-1.06,6.49-2,13.52.67,19.42a9.4,9.4,0,0,0,1.91,2.88,7.52,7.52,0,0,0-4.56,3.22,2.71,2.71,0,0,0-3.88,0c1.59,1.81,2.81,4,4.54,5.65s4.28,2.68,6.38,1.62,2.72-4.82.67-6a7.08,7.08,0,0,0,3.32-2.47c.74-1.24.56-3.3-.7-3.81l6.34-7.1c3.09,1.91-.5,6.88-.31,10.72.21,4.17,4.83,6,8.6,6.86,1.76,2.26,0,5.78-2.16,7.52s-5,2.83-6.42,5.36c-2.4,4.39.24,11.33-3.6,14.26a7.48,7.48,0,0,0-1.73,1.35c-1.09,1.4-.27,3.5.27,5.24a14.34,14.34,0,0,1-2,12.33c-1.65,2.25-3.95,5.63-1.85,7.37-7.11,5.2-11.39,15.7-19.91,16.87-1.7.24-3.48.05-5,.69a13.74,13.74,0,0,0-3.63,2.54c-4.91,4.08-10.82,6.45-16.62,8.78l-39.89,15.86c-2.76,1.1-5.6,2.19-8.54,2.13-1.93-.06-3.82-.64-5.74-.57-2.54.08-4.93,1.27-7.31,2.19-10.08,3.88-21.16,3.29-31.78,2.19-5.73-.58-11.76-1.25-17.07,1.18a8.19,8.19,0,0,1-3.76,1.19c-1.63-.11-2.94-1.42-4.42-2.19s-3.74-.57-4.16,1.1a14.64,14.64,0,0,0-4.51-5.93"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-9"
                  d="M737.85,488.72l13.59-9.19-8.06-5.79,12.09-13.63c-3.14-2.45-2.42-8.69,1.19-10.21,2.59-6.67.88-14.32-1.34-21.14A146.94,146.94,0,0,0,741,397.59l-18.57,4c7-5.49,8.63-17.1,4.12-25.05A20.27,20.27,0,0,0,704,367.1c-4.31,1.1-8.62,3.68-12.94,2.57-5.81-1.52-9.33-9.17-15.29-9.55-8.47-.52-11.71,13.23-19.84,15.86,6.38,6,.47,19.89-7.87,18.55a21.27,21.27,0,0,1-9.33,13.84,56,56,0,0,0-35.15-.44L602,390.82c-9.16-13.27-31-12.52-38.9,1.68-2.07,3.73-4,8.69-8.06,9-2.13.16-4.09-1.17-6-2.19-9.72-5.16-22.53-2.19-29.46,6.8a29,29,0,0,0-.8,32.62c1.55,2.27,3.46,4.32,4.47,6.92,2,5.11.1,11-1.92,16s-4.22,10.69-2.77,16,8.66,8.66,11.82,4.29c-2.48,7.51,7.41,12.25,14.75,13l46.33,4.87c17.74,1.87,36.45,3.57,52.65-4.48,4.15-2.06,8.06-4.75,12.52-5.92,5.93-1.58,12.09-.33,18.19.57a153.47,153.47,0,0,0,73.43-7.17"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-9"
                  d="M134,515.94l15.86-13.55a119.45,119.45,0,0,0-32-9.79l20.4-21.94-10.48-5.48c.18-11.85,8.58-22.95,19.27-25.48l-5.76-4.82c1.14-8.61,12.24-8.95,19.8-11.92,18.92-7.44,22.41-40.86,42.3-44l-10.76-9.33L196,349.55c-5-8-10.18-16.24-17.58-21.66s-17.66-7.44-25.26-2.34c-4.28,2.87-7.6,7.8-12.55,8.78a68.41,68.41,0,0,1-1-26.93c.39,5.06,7,8,10.55,4.65l-23.64-20.84c-6.56-5.79-15-11.93-22.83-8.34-4.45,2.05-7.37,6.88-11.75,9.12-8.24,4.21-18.64-2-26.9,2.19-12.53,6.34-10.16,30.71-23.31,35.34-3.42,1.2-7.4.74-10.28,3.06-3.18,2.56-3.69,7.4-3.94,11.67l-3.87,67.87a82.29,82.29,0,0,0,10.92,22.47L29.4,465.41c8.43-1.58,12.46,11.58,10,20.45s-7.8,17.93-4.94,26.71l22.16,5.84c1.37,8.2-10.76,14.72-7.75,22.39,2.53,6.45,11.47,3.78,17,.1a251.74,251.74,0,0,0,59.34-26.14c6.92-4.19,14.5-10.24,14.45-18.82"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-9"
                  d="M215.63,501.22c9.4,3.43,18,9.3,27.42,12.52s20.83,3.29,28.21-3.88c-1.83,4.81,3.87,9.32,8.68,9.16s9.48-2.69,14.24-2c2.66.36,5.11,1.7,7.61,2.75a38.4,38.4,0,0,0,27.51.87c2.77-1,5.7-2.28,8.47-1.33s4.37,3.62,6.51,5.57c6.25,5.71,16.36,4.12,22.39-1.85s8.56-15.15,8.93-24c.27-6.09,0-13.16,4.39-17,2.66-2.35,7.11-3.89,6.81-7.59-.47-5.79-10.56-2.94-13.18-8,6.86.26,11.6-7.62,12.83-14.92s.48-15.09,3.25-21.93c-3.85-4.57-11.6.58-16.4-2.77-2-1.38-3-3.89-4.56-5.75-4.45-5.21-12.09-4.25-18.6-4.78A35.52,35.52,0,0,1,327.34,405c-2.53-2.7-4.95-6-8.43-6.78-2.94-.68-5.93.6-8.7,1.85l-60.69,27.42c-13.18,6-28.2,14.26-30.7,29.44-.36,2.13-.4,4.46.71,6.25,1.32,2.19,3.95,2.95,5.52,4.91,3.32,4.16.38,10.44-2.23,15.16s-4.23,12.07.23,14.68c1.94,1.09,4.39.8,6.37,1.86,7.16,3.83,1.35,19.87,9.06,22.32"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-9"
                  d="M657.71,523c-.43,9.68,7.5,18.86,16.46,19,4.15.07,8.17-1.51,12.29-2,14-1.52,28.81,9.88,41.47,3.14,5.29-2.81,8.86-8.26,13-12.82,10.73-11.91,25.65-18.09,40.16-23.56q36.81-13.89,74.54-24.82c4.16-1.21,8.43-2.42,12-5.1,4.51-3.42,7.44-8.93,12.09-12.07,3.27-2.19,7.12-3.17,10.84-4.27,9-2.66,18.28-7.21,22.54-16.14s-.08-22.61-9.33-23.36l.67-11.16A140,140,0,0,0,865,408.14c-.79-5.7-7.55-8.2-12.73-6.8s-9.42,5.3-14.25,7.75c-18.37,9.33-40.86-3.47-60.12,3.47s-28,30.16-40,47.88c-14.55,21.26-35.64,36.1-59.42,41.82-12.19,2.88-27.64,5.79-30.74,18.86a30.62,30.62,0,0,1,16.22,6"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-8"
                  d="M158,415c-4.91,19-34.75,21.5-36.54,41.08-.2,2.19,0,4.52-.36,6.73-1.23,7.13-8.36,11.35-15,12.16s-13.42-.74-20.08-.27c-11.31.89-21.42,7.68-31,14.21-3.81,2.62-7.65,5.25-10.67,9C41,501.91,39.05,507,37.45,512.1a124.78,124.78,0,0,0-5.3,27A150.36,150.36,0,0,0,99.48,501a49.63,49.63,0,0,1,8.28-7.08c3.47-2.11,7.4-3.11,11.23-4.21a192.15,192.15,0,0,0,79.78-46.34c3.67-3.53,7.4-7.56,8.41-12.75s-2.12-11.63-7.05-11.71l2.52-7.34c-16.44-6.48-34.4,1.87-50.19,10.05"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-8"
                  points="895.33 539.9 869.13 557.87 895.33 600.07 895.33 539.9"
                />
                <path
                  class="cls3-6"
                  d="M1225.17,815c-31.47,12.32-105.53-5.65-105.53-5.65L790.07,751.09l-235.56-46-.7-15.08L569.42,683l374.86,56.78h0l52.57,8s45.13,5.09,95.44,12.88c49.75,7.69,104.57,18,125.76,28.59C1218.06,789.2,1256.63,802.66,1225.17,815Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-10"
                  d="M1247,700.12s-183.17-11.25-306.91-31.21h-.15V660S1184.59,683.86,1247,700.12Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-10"
                  d="M804.62,645.57l-3.53,7.67S599,636,550.57,628.83v-8.2l.61.08h.27l1.72.23,1.36.19,1.15.15.81.11,1.07.15,1.22.16a1.68,1.68,0,0,1,.63.08l2,.27,1.47.2,1.77.23,1.83.24h0l3,.39,2.1.27,1.1.14,4.55.59,2.4.31h0l2.47.32,2.54.32h0l5.28.67,5.53.69h0l4.3.53,2.24.28,8.57,1.09c32,3.89,70,8.11,95.69,9.71l16.38,1.1C768,642.18,804.62,645.57,804.62,645.57Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-6"
                  d="M1386,620.42v74.84c-40.49,18-133.75,4.86-133.75,4.86-57.44-15.26-291.6-39-291.6-39l5.13-8.37.22-33.13,34.63,3.74,13.84-11.43,1.28-7.68L1103.6,613,1243,623.35C1382.41,633.7,1386,620.42,1386,620.42Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-11"
                  d="M1386,531.14v89.28s-3.52,13.28-143.32,2.93L1102.85,613l-88.12-8.77V587.49s274.09,21.16,332.7,11.35l6.49-67.7S1382.4,532.07,1386,531.14Z"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-7"
                  points="1210.46 401.15 1193.89 401.15 1185.02 543.84 1016.86 543.84 963 531.14 963 401.15 1210.11 390.8 1210.46 401.15"
                />
                <path
                  class="cls3-6"
                  d="M875.06,564.12C881.61,579.21,893,600,893,600l-1.11,9.66H832.48V512l13.9-7.91,53.16-6.38,9.81,33.44S868.5,549.07,875.06,564.12Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-7"
                  d="M866.51,424.57,740.68,429v26.87L771,457.49l95.78,5.24Zm-7,31.48-27,2.28-62-6.52V430.65h89Z"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-12"
                  points="861.89 430.65 861.89 456.05 834.86 458.33 772.88 451.81 772.88 430.65 861.89 430.65"
                />
                <path
                  class="cls3-6"
                  d="M722.85,639.12,706.47,638c-25.68-1.6-63.66-5.82-95.69-9.71-2.91-.33-5.76-.7-8.57-1.09l-2.24-.28-4.3-.53h0l-5.53-.7-5.28-.66h0l-2.54-.32-2.47-.29h0l-2.4-.31-4.55-.59-1.1-.14-2.1-.26-3-.4h0l-1.84-.24-1.81-.25-1.47-.2-2-.27c-.21,0-.42-.07-.63-.08l-1.22-.16-1.07-.15-.81-.11-1.15-.15-1.36-.19-1.72-.23h-.26l-.62-.08-2.43-51.09,173.44,16.71Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-6"
                  d="M354.19,524.63v12.62S272.61,576,231.31,582.5s-192.2-13-192.2-13V547.39s149.24,26.39,185.33,18.22S347.18,532.12,354.19,524.63Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-8"
                  d="M354.19,524.63c-7.05,7.49-93.67,32.82-129.74,41S39.12,547.39,39.12,547.39C55.24,536.31,112.65,519.28,157,508.9l49.82-9h2.9C241.22,500.69,354.19,524.63,354.19,524.63Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-6"
                  d="M862.88,974.12H3.37l231-221.7L562.59,881.24S806.91,943.6,862.88,974.12Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-13"
                  d="M322.37,484.63l1.09,33.07L209.64,499.92h-2.9c-8.89.3-27.74,3.82-49.82,9l-88.64,9.34V489.33l125.81-8.12L203.16,451l79.57,1.89,43-1.89Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-14"
                  d="M206.75,499.92l-49.82,9C179,503.79,197.86,500.22,206.75,499.92Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-14"
                  d="M209.65,499.92h-2.9C207.63,499.89,208.61,499.89,209.65,499.92Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-4"
                  d="M1386,692.29V974.12H858.56c-57.26-30.49-307.24-92.78-307.24-92.78l-7.67-166.92L818,769.92l303.82,57.52s88.85,29.91,121.66,0c0,0,48.36-48.36-154.58-68.46-51.05-8-96.87-13.21-96.87-13.21l-53.35-8.18h0l-1.14-73.1c126.62,21.08,314,32.93,314,32.93S1345.29,711.32,1386,692.29Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-8"
                  d="M721.75,586.24l-173.61-16.7-.39-8.26,55.65-10.39c55-15.3,117.41-9.49,117.41-9.49Z"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-6"
                  points="205.56 451 196.49 481.21 70.68 489.33 70.68 469.56 170.32 465.96 183.11 451 205.56 451"
                />
                <line
                  class="cls3-1"
                  x1="942.46"
                  y1="668.93"
                  x2="942.32"
                  y2="660.04"
                />
                <path
                  class="cls3-10"
                  d="M1245.64,829.13c-32.38,29.73-120.05,0-120.05,0L825.8,772,555.1,716.79l-.57-12.28,235.91,46.92,330.08,59.42s74.24,18.29,105.7,5.75-7.12-26.3-7.12-26.3c-21.22-10.81-76.12-21.32-126-29.16C1293.36,781.07,1245.64,829.13,1245.64,829.13Z"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-4"
                  points="552.95 628.83 807.46 654.5 807.48 717.96 552.95 680.96 552.95 628.83"
                />
                <rect
                  class="cls3-6"
                  x="752.63"
                  y="610.28"
                  width="64.42"
                  height="33.77"
                />
                <path
                  class="cls3-10"
                  d="M562.59,874.25v11S780.2,932,850.32,974.12h32.4S743.43,911.84,562.59,874.25Z"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-15"
                  points="894.56 405.51 963 401.15 963 661.13 894.56 657.54 894.56 405.51"
                />
                <polygon
                  class="cls3-16"
                  points="565.41 883.67 520.11 907.64 500.99 442.55 26.88 447.99 26.88 325.29 541.24 373.92 565.41 883.67"
                />
                <polygon
                  class="cls3-16"
                  points="963 401.15 1009.3 405.51 1008.29 434.92 969.45 434.92 968.04 652.76 963 661.13 963 401.15"
                />
                <polygon
                  class="cls3-17"
                  points="1005.28 511.16 974.08 516.61 968.93 515.07 969.45 434.92 1008.29 434.92 1005.28 511.16"
                />
                <polygon
                  class="cls3-17"
                  points="1005.28 528.59 968.81 533.22 968.25 619.63 1002.26 623.36 1005.28 528.59"
                />
                <polygon
                  class="cls3-18"
                  points="968.93 515.07 974.08 516.61 1005.28 511.16 1110.97 494.82 1101.91 501.36 1102.04 505.71 1083.8 514.43 1077.75 514.43 1077.25 508.44 968.93 526.23 968.93 515.07"
                />
                <polygon
                  class="cls3-19"
                  points="968.81 533.22 1005.28 528.59 1079.17 516.61 1079.17 514.43 1077.75 514.43 1077.25 508.44 968.93 526.23 968.81 533.22"
                />
                <polygon
                  class="cls3-20"
                  points="1009.3 405.51 1021.88 407.14 1018.31 509.15 1005.28 511.16 1009.3 405.51"
                />
                <polygon
                  class="cls3-20"
                  points="1005.28 528.59 1017.11 526.67 1015.85 611.92 1002.26 623.36 1005.28 528.59"
                />
                <polygon
                  class="cls3-21"
                  points="830.64 613 807.48 611.92 807.48 624.62 756.15 620.63 757.16 727.37 726.96 723.01 722.94 529.13 720.92 443.09 830.64 439.43 830.64 613"
                />
                <polygon
                  class="cls3-20"
                  points="839.07 439.43 838.7 609.73 830.64 613 830.64 439.43 839.07 439.43"
                />
                <path
                  class="cls3-22"
                  d="M945,617.63c-.1,4.51-31.51,7.34-70.12,6.32s-69.87-5.49-69.77-10,31.5-7.33,70.13-6.31S945.1,613.12,945,617.63Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-23"
                  d="M939,635.88a5.68,5.68,0,0,0,1-.27,7.49,7.49,0,0,0,5-7.36V617.63c-.1,4.51-31.51,7.34-70.12,6.32s-69.87-5.49-69.77-10a25.88,25.88,0,0,0,0,9.69l-.47,71.65,1.49,41.91s-1,4.39,8.06,7.68c0,0,33.24,18.51,75.54,18.51s40.29-1.09,40.29-1.09,11.08-1.1,11.08-10.9,1-45.74,1-45.74a6.4,6.4,0,0,1-2,2.77c-4.48,4.07-18.34,10.65-60.35,6l1-75.17S925.9,641.32,939,635.88ZM845.38,710s-27.2-3.29-36.26-14.16L808,628.93a7.27,7.27,0,0,0,3.17,1.59l35.25,6.58Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-24"
                  d="M939.94,635.6v72.75c-4.47,4.07-18.33,10.65-60.34,5.94l1-75.16s45.32,2.19,58.42-3.29A7.17,7.17,0,0,0,939.94,635.6Z"
                  transform="translate(2.38)"
                />
                <line
                  class="cls3-25"
                  x1="942.32"
                  y1="708.37"
                  x2="942.32"
                  y2="708.36"
                />
                <path
                  class="cls3-24"
                  d="M846.38,637l-1,73s-27.2-3.29-36.26-14.16L808,628.87a7.16,7.16,0,0,0,3.17,1.59Z"
                  transform="translate(2.38)"
                />
                <line
                  class="cls3-25"
                  x1="810.35"
                  y1="628.84"
                  x2="810.35"
                  y2="628.83"
                />
                <line
                  class="cls3-25"
                  x1="807.48"
                  y1="621.17"
                  x2="807.46"
                  y2="623.61"
                />
                <polygon
                  class="cls3-17"
                  points="757.16 727.37 766.22 720.84 764.72 621.29 756.15 620.63 757.16 727.37"
                />
                <polygon
                  class="cls3-26"
                  points="839.03 457.44 931.29 451.81 931.29 497.4 838.9 517.46 839.03 457.44"
                />
                <polygon
                  class="cls3-26"
                  points="546.03 474.78 756.15 462.7 757.16 522.6 550.13 561.28 546.03 474.78"
                />
                <polygon
                  class="cls3-15"
                  points="500.48 442 352.51 444.17 371.64 883.12 520.62 907.09 500.48 442"
                />
                <polygon
                  class="cls3-18"
                  points="693.24 620.63 303.19 788.37 205.56 713.21 403.86 659.93 693.24 620.63"
                />
                <polygon
                  class="cls3-18"
                  points="49.79 583.4 269.98 561.28 403.86 659.93 205.56 713.21 49.79 688.63 49.79 583.4"
                />
                <polyline
                  class="cls3-19"
                  points="693.24 620.63 693.24 628.83 303.19 802.53 303.19 788.37"
                />
                <polygon
                  class="cls3-20"
                  points="53.06 327.09 53.06 458.88 49.67 688.7 0 674.54 0 325.29 53.06 327.09"
                />
                <path
                  class="cls3-27"
                  d="M555.09,974.12S522.93,747.58-2.38,662.3V974.12Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-28"
                  d="M672.57,962.09l-6.64-262,68.6-79.71s7.16,1.51,6.15,34.07.11,307.59.11,307.59Z"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-28"
                  points="237.17 716.22 218.51 723.18 191.41 444.49 205.56 417.49 237.17 716.22"
                />
                <polygon
                  class="cls3-28"
                  points="528.66 917.98 505.52 938.68 498.21 928.33 482.42 508.44 505.55 462.7 528.66 917.98"
                />
                <path
                  class="cls3-28"
                  d="M616.54,965.55c-.52-1.76-1.2-3.83-1.84-5.77s-1.33-4-2-5.94c-1.39-4-2.86-7.9-4.38-11.84-3-7.88-6.26-15.66-9.59-23.42q-10.08-23.19-22.08-45.47T551.07,829.8c-4.47-7.09-9.26-13.9-14-20.84-4.93-6.7-9.73-13.54-14.9-20a500.84,500.84,0,0,0-67.71-71.81c-1.51-1.39-3.12-2.63-4.68-3.93l-4.74-3.88-4.73-3.88c-.79-.63-1.56-1.3-2.38-1.92l-2.44-1.83c-6.52-4.83-12.93-9.87-19.72-14.26-3.36-2.26-6.69-4.57-10.07-6.79l-10.34-6.3-5.17-3.16c-.86-.54-1.74-1-2.63-1.49l-2.65-1.39-10.61-5.77c-3.51-2-7.19-3.59-10.79-5.35l-10.9-5.11-22.27-9.28c-7.42-2.95-15-5.72-22.56-8.4-3.8-1.32-7.59-2.68-11.39-3.95L285,626.64c-30.57-10-61.53-18.65-92.66-26.55-7.8-1.89-15.58-3.9-23.4-5.72L145.44,589c-7.82-1.76-15.69-3.29-23.54-5l-11.78-2.47-11.81-2.26C66.83,573,35.14,568,3.42,563.28c31.81,3.84,63.64,7.89,95.29,13.26l11.88,1.94,11.86,2.09c7.9,1.46,15.81,2.81,23.7,4.39l23.65,4.71c7.87,1.62,15.72,3.39,23.58,5.08,31.41,7,62.68,14.85,93.67,24l11.61,3.51c3.87,1.17,7.72,2.43,11.58,3.65,7.71,2.49,15.39,5.06,23.07,7.86s15.22,5.76,22.83,8.69l11.24,5c3.73,1.7,7.54,3.23,11.18,5.18l11,5.58,2.74,1.41c.93.46,1.84.93,2.73,1.46l5.38,3.08,10.76,6.16c3.53,2.2,7,4.46,10.51,6.67,7.05,4.39,13.78,9.3,20.6,14.08l2.56,1.81c.85.61,1.65,1.28,2.49,1.9l5,3.85,4.95,3.84c1.64,1.29,3.33,2.52,4.92,3.92a511.88,511.88,0,0,1,71.42,71.87c5.5,6.58,10.59,13.4,15.83,20.16,5,6.94,10.14,13.82,14.92,21,9.68,14.26,18.86,28.82,27.41,43.87s16.59,30.49,23.92,46.33c3.64,7.92,7.23,15.89,10.55,24q2.52,6.09,4.88,12.29c.8,2.05,1.55,4.15,2.32,6.24s1.49,4.14,2.26,6.51Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-28"
                  d="M683.9,967.93l-.33-1.38-.41-1.63-.87-3.29c-.6-2.19-1.24-4.5-1.9-6.75-1.31-4.52-2.72-9-4.18-13.58-2.93-9-6-18.07-9.47-27-6.76-17.87-14.28-35.5-22.55-52.71a668.71,668.71,0,0,0-57.65-98.28q-16.45-23-34.78-44.53a528,528,0,0,0-38.63-40.72A546.15,546.15,0,0,0,471,641.61,526.37,526.37,0,0,0,425.46,610a521.28,521.28,0,0,0-98.94-47.76c-17.2-6.19-34.71-11.48-52.37-16q-26.79-6.59-53.73-12.67c-35.91-8.11-71.9-15.74-108-22.48S40,498.42,3.37,494.82c36.69,1.77,73.28,5.92,109.79,10.79s72.84,10.8,109.15,17.13q27.19,4.78,54.39,10C295,536.47,313.08,541,331,546.45A534.13,534.13,0,0,1,435,590.63a544.33,544.33,0,0,1,48.65,30.52A563.63,563.63,0,0,1,529.32,657q22,19.17,42.23,40.58t38.49,45A698.8,698.8,0,0,1,675.1,843q14.24,26.65,26.26,54.73,6,14,11.38,28.52c1.79,4.82,3.53,9.67,5.19,14.61.84,2.47,1.65,5,2.45,7.47l1.19,3.83.59,2,.63,2.2Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-28"
                  d="M778.42,966.27h0v-.56l-.09-.89-.21-1.88-.49-3.93c-.34-2.65-.73-5.36-1.14-8.07-.83-5.49-1.76-10.9-2.77-16.38q-3.08-16.45-7-32.84-8-32.85-19.13-64.63a660.93,660.93,0,0,0-25.47-62.2l-3.59-7.56-3.72-7.48c-1.23-2.51-2.51-5-3.8-7.43l-3.88-7.4c-2.69-4.85-5.29-9.78-8.1-14.55-1.39-2.4-2.75-4.83-4.17-7.21l-4.3-7.1a531.31,531.31,0,0,0-81.42-103,488.08,488.08,0,0,0-103.25-77.51,526.79,526.79,0,0,0-118.66-48.18l-7.74-2.07-3.87-1-3.9-.92-15.65-3.6-15.72-3.16c-2.61-.55-5.29-1-8-1.42l-8-1.35-4-.67-2-.33c-.67-.12-1.31-.21-2-.36l-8.08-1.6-15.94-3.17q-16-3.06-31.94-6Q196.48,450,132.27,440.05c-10.71-1.65-21.42-3.15-32.13-4.72l-16.09-2.19c-5.36-.74-10.73-1.46-16.1-2.08l-16.11-1.95c-5.37-.63-10.75-1.15-16.14-1.72-10.75-1.24-21.53-2-32.33-2.89,10.82.25,21.65.29,32.46.84,5.41.23,10.82.41,16.23.69l16.22.93q8.1.44,16.21,1.1l16.21,1.1c10.79.88,21.6,1.71,32.39,2.68q64.79,5.76,129.37,13.62,16.17,1.92,32.3,4l16.15,2.07,7.95,1.1c.6.08,1.3.15,2,.23l2,.2,4.05.42,8.1.84c2.71.27,5.41.54,8.14.94l16.34,2.19,16.3,2.72,4.07.7,4.06.83,8.11,1.63a546.35,546.35,0,0,1,126.72,42.55A514.21,514.21,0,0,1,633.3,581.6a567.12,567.12,0,0,1,93.9,105.75l5.07,7.42c1.67,2.49,3.28,5,4.93,7.52,3.32,5,6.42,10.14,9.62,15.24,1.56,2.56,3.08,5.16,4.63,7.74s3.07,5.18,4.56,7.81l4.46,7.86,4.33,8a707,707,0,0,1,31.14,65.81q14,33.87,24.61,69.24,5.31,17.71,9.72,35.86c1.46,6.07,2.84,12.18,4.13,18.37.64,3.11,1.26,6.23,1.85,9.41l.86,4.84.41,2.51.21,1.31.27,1.61Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-28"
                  d="M558.51,958.32a3.91,3.91,0,0,0-1.59,1.63c-.24.46-.17.65-.16.4a3.32,3.32,0,0,0,.06-.44v-.71c0-.62-.1-1.24-.19-1.86a51.54,51.54,0,0,0-2.53-9.18,146.32,146.32,0,0,0-9-19.19,323.64,323.64,0,0,0-23.58-36.4,536.07,536.07,0,0,0-57.41-65A671.18,671.18,0,0,0,326.93,725.36,705.73,705.73,0,0,0,171,660.64,759,759,0,0,0,5.42,633.7,758.35,758.35,0,0,1,172,656.44,707.68,707.68,0,0,1,330.6,717.55,678.26,678.26,0,0,1,472.15,817.64a548,548,0,0,1,60.29,65.18A337.34,337.34,0,0,1,558,920.4a166.17,166.17,0,0,1,10.48,21.29,68.12,68.12,0,0,1,3.72,12.6,37.93,37.93,0,0,1,.47,3.82c.06.65,0,1.43.06,2.19s-.06,1.61-.15,2.41a17.42,17.42,0,0,1-1.68,5.82,13.73,13.73,0,0,1-2.17,3.14,15.79,15.79,0,0,1-1.48,1.36c-.52.38-1.08.74-1.63,1.09Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-29"
                  d="M1103.78,384.88s-45.67-17.73-19.42-21.42,9.07-37,9.07-37,1.31-21.8,19.8-16.55,4.6-13.7,19.59-21.65,26.07-44.88,36.63-22.07-8.48,38.19,28.2,45.76,8.26,31.07-17.27,48.18,9.27,16.45-23.24,25.51S1103.78,384.88,1103.78,384.88Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-30"
                  d="M463.72,308.43s14.35,3.95,24.37-.39,13.69-11.15,13.69-11.15S475.76,291,463.72,308.43Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-31">
                  <rect
                    class="cls3-30"
                    x="465.14"
                    y="290.98"
                    width="38.62"
                    height="21.67"
                  />
                  <g class="cls3-32">
                    <image
                      class="cls3-33"
                      width="66"
                      height="34"
                      transform="matrix(0.65, 0, 0, -0.71, 464.02, 313.76)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAlCAYAAAD2pT8KAAAACXBIWXMAABDqAAAQ6gGC0wqYAAACgElEQVRoQ+2awW3DMAxFP4scO0YP3X+JLtFJegh7sGhTJEXLsZ0oSD5QRIRjW/+JpBSgxMyM1xYBwMfat15FFxn8/vwBxIUPlrH8wcRUEknH870mHkRf35/NazMIugJMtJhgGZeYCGAZY4oJAJuYuHxPxYMBiTSDwJVAZdKcmmwBUjFBQVP3AsNCWUAwZpMVkD1ZwDq2gDCU3s2yqCqNZbUlMwApBw7L4YhMwRBSILCYCEwSm/6xqV90AAIeCsVnhDOpTDA6G6qJI0AwMeGh/cOAiFI9BpQ2VJiYAMDEg5VNuGvYLIhNCpAS2z7yZOeQOiOAyqQ31Vi1Vh95onOIb5YNk65M2EySMF0g5GXTBGRiNxcLCIcqaJaNSUWm3KqhAtQsm0MB4RAtIABUfcKZbEyip68QfNlsKpNOQDtUgxCxfOoX0fKyJAu8yRrQqdvvPDdsVgxCi3FzFhy6/UaAoqy4sWzevzWK1jNCZDOjZzXS1ZbMkOd1nEMIvpS6Sgur6gch0kBmk7S8zPaPqF/sOYfAPDvqH9HciJFpOwiRPLfTZNc5pJg67RyS6HYQWjpLWpOKTLlVk/unuFk2twJKdAwIkQbiTEarFMSycmtlU5WcehebWANKdCwIEcsn+UnBxPNEOwAxsOsckugcEFo6S1ZM5oDK9T3nkETngxBZIG7VzHUHCMakAJHndWy/ie4HQqSB2CyAiZ2pBBjB9xFbNonuD0Ikmdpp8pDtN9HjQGj1lE1UJjaj5vun2JVNovdvjaIxMkKU9Y9W6Ww5hyQaC4Qo7B9lDBMT4n7RAtTQmCC0bP9omYz6hW2wicYHIeppqGvnkET0/tehCdEFq6xeQ/8E0wbZgWvaZAAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M279.68,749.66a73.53,73.53,0,0,1,.47-7.42c-.2,2.19-.36,4.73-.47,7.42M395.6,733.14c-1.11-2.12-2-3.91-2.71-5.11a49.81,49.81,0,0,1,2.71,5.11m-4.18-7.32c-.21-.14-.42-.27-.65-.4l.29-.09.36.49"
                  transform="translate(2.38)"
                />
                <g class="cls3-34">
                  <rect
                    class="cls3-30"
                    x="282.04"
                    y="724.37"
                    width="115.86"
                    height="24.77"
                  />
                  <g class="cls3-35">
                    <image
                      class="cls3-33"
                      width="177"
                      height="36"
                      transform="matrix(0.68, 0, 0, -0.75, 280.61, 751.05)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALEAAAAoCAYAAACxQBtOAAAACXBIWXMAABAlAAAQJQEuD214AAAAx0lEQVR4Xu3duwnDQBBF0ZVRQVYZBpdrcBvuaB35l1ipLpwTSbDhY5iZFWiZc84BXdtp7wQc3fp6uN8e/87BYVyu55/3d4iHpoKoT4ilmCghJs9gR54QkyfE5AkxeV8rNoMdTbYT5GknyBNi8lw7k6cnJk+IydMTkyfE5AkxeXpi8qzYyFOJydMTk+crNvJUYvKEmLx3OzENdkSpxORZsZGnEpMnxOQJMXkuO8hTiclTiclTicmzJyZv8fck4rZ1jLHsnYIjewJiAyG6coJh+QAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <rect
                  class="cls3-30"
                  x="282.04"
                  y="725.92"
                  width="117.29"
                  height="52.62"
                />
                <g class="cls3-36">
                  <image
                    class="cls3-33"
                    width="177"
                    height="74"
                    transform="matrix(0.68, 0, 0, -0.75, 280.61, 779.2)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALEAAABRCAYAAACdbUdHAAAACXBIWXMAABAlAAAQJQEuD214AAABNElEQVR4Xu3asakCURRF0TdiD8Lvwp6MLcaKrEawivsjmUzT2bBWZDDh5nAd3WZmFnRdz59Pl7/7twfhcN6vx1prrdOP5+DwREzeef/oNKbJEpMnYvJETJ6bmDxLTJ6IyRMxeftN7CQmyhKT5+0EeZaYPBGTJ2Ly3MTkWWLyREyeiMkTMXkiJk/E5HnFRp4lJk/E5ImYPDcxeZaYPBGTJ2LyREyeiMkTMXlesZFnickTMXnOCfIsMXkiJk/E5ImYPBGTJ2LyvGIjzxKTJ2LyREyeiMnzxY48S0yeiMkTMXluYvIsMXkiJk/E5ImYPBGTJ2LyvGIjzxKTJ2LyREzefhOPm5gmS0yeiMkTMXkiJk/E5PnFjjxLTJ6IyRMxeW5i8iwxeSImb5uZ56+H4MBu2/j3GnH/XjQf/CsvJTkAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M257.16,780.33l-.14-.56c-.46,0,1-2.84,1-3.4-.1-5.88,10.07-12.93,10.81-22.56.21-2.78,1-3.29,1.28-5.57,0,0,2.34-3.1,2-1.13-.16,1,.74-2.45,1-3.4,3-10.12,6-17.9,6-18,8.77,2.44,15.24,8.41,46.86,8.41a225.29,225.29,0,0,0,60.5-8.76,4.84,4.84,0,0,1,.78.41c.51.62,1.11,1.38,1.75,2.26.78,1.24-67.18,23.34-86.73,31.42-15.63,6.46-37.08,15.22-45.33,20.25a4.9,4.9,0,0,0-.39.71c-1.39,2-14.51,23.19,10.78,69.66C294,899,279.25,974.12,279.25,974.12H412.47S410.76,838.22,402.34,809s-10.08-79-10.08-79l-5.69.64L273.13,771.89c-.3.09-5,1.91-5,2.27l-8,3.4"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-30"
                  d="M275.8,687.45C259.9,671.32,248,643.79,248,643.79c-6.51-30.64-7.59-133.42-7.59-133.42h0c.26,2.6.54,5.49.85,8.52.59,7.67,1.43,16.89,2.65,27.28a143.69,143.69,0,0,0,2,15.77v0c2.53,21.83,5.19,42.89,6.94,52.59v.07h0v.11h0v.11h0c2.74,14.68,14.11,48,22.87,72.39"
                  transform="translate(2.38)"
                />
                <g class="cls3-37">
                  <rect
                    class="cls3-30"
                    x="241.99"
                    y="510.77"
                    width="35.76"
                    height="176.45"
                  />
                  <g class="cls3-38">
                    <image
                      class="cls3-33"
                      width="62"
                      height="243"
                      transform="matrix(0.66, 0, 0, -0.72, 240.56, 686.47)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAEICAYAAAAHlUdAAAAACXBIWXMAABCbAAAQmwF0iZxLAAAB2UlEQVR4Xu3csU3DUBhG0d/IFezACEzBAhmJibIAw7AEtalI0jip43NPh0hz5cf7RCJl2bZtG8syM7P+//R9/t1/6ZP6PL3t/u5l9zcHx4Zfjvpy71UHxD5xNvxy1LWzzj7xwjVseDuuac40hWu61TWFa9pxTeGadlzTra4pXMOGN2caNrwd17Dh3eqawjXNmaZwTTuuKVzTjmu61TWFawrXsDvenGkK1xSuac6wbveoF64pXHO91bFrnX3ihWsK17DhzZmmcE3hGjacfc+NfZeVPeqFa9jwbnWtnD3qhWsK17Dh7bhWzh71wjVsOHurs0+cDW/HNYVrmjMNG96caQrXNGeawjU3O279lbNPnA1vzjSFa/q3VFO4ph3XFK5pxzXd6prCNWx4c6ZpzjSFawrXsDvenGkK1xSu6Rv8NIVrCtew4c2ZpnBN4ZrCNe24pnBN4Rr2IyT2Q0P2qBeuKVzDhrfjWjl71AvXsOHsrc4+cTa8HdcUrmnONGx4c6YpXNOcaQrXtOMaNrw50xSuac403eqawjVseHOmYcPbcU3hmuZMw4Y3Z5rCNWx4O65pzjSFawrXsDvenGkK17DhfZGdpnDNOjNfMzPvH68PXnos68z8PHrREf0B0yYLmlItFGUAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M308.79,435.21c-4.12,0-7.73-.21-10.71-.49,1-3.17,1.95-6.48,2.89-9.73h1.39c12.31,0,30.1-5.1,30.22-5.13-.54,3.87-1.18,8.91-1.77,14.25-4.38.37-10.3.76-17.23,1-1.66,0-3.25.08-4.77.08M301,425c.92-3.17,1.77-6.28,2.51-9.11-1.22,4.79-2.38,8.67-2.51,9.11m63.35-2.2h0c-3.43-2.19-9.57-8.38-9.76-11.3s1.81-10.17,4.52-18.77,16.26-30.5,20.24-37.29,18.4-32.67,18.5-32.81c-.11.72-.2,1.35-.26,1.91-.71,6.65-5,26.15-4.69,30.48s2.53,7.23,2.53,10.86-14.1,44.64-31.08,57m0,0A83.57,83.57,0,0,1,346,418.38a105.23,105.23,0,0,0,18.33,4.49h0M305,409.71a35.73,35.73,0,0,0,.78-4.83,16.2,16.2,0,0,0-.63-4.7c.37,1.17.72,2.28,1,3.29-.3,1.91-.72,4-1.19,6.21m92.87-87.14,1.35-10.64-.6,5.68c-.26,1.9-.53,3.56-.75,5"
                  transform="translate(2.38)"
                />
                <g class="cls3-39">
                  <rect
                    class="cls3-30"
                    x="300.64"
                    y="311.1"
                    width="101.56"
                    height="123.83"
                  />
                  <g class="cls3-40">
                    <image
                      class="cls3-33"
                      width="158"
                      height="171"
                      transform="matrix(0.68, 0, 0, -0.74, 297.78, 436.97)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJ8AAAC7CAYAAAB7JkzAAAAACXBIWXMAABBNAAAQTQFnjAHgAAACZklEQVR4Xu3csU0DQRRF0W/kxuiCLqgFqiCjBCiEEuhhyLADxAaYuck5EUIOr95qxiuf1lprYK/nmXm8O/oU/Jfz919vL798DP7g/uHHf1s+MuIjc3nsOnawmeUjIz4y4iMjPjLiIyM+MldXLe5a2MvykREfGfGRER8Z3+2SsXxkxEdGfGTER0Z8ZMRHxlULGctH5rJ8po/NLB8Z8ZERHxnxkXHVQsbykREfGfGRER8Z8ZFx2iVj+ciIj4y3WshYPjLiI+O0S8bykREfGfGRER8Z8ZFx2iVj+ciIj4z4yIiPjPjIeKWKjKsWMh67ZMRHRnxkxEdGfGScdslYPjLiIyM+MuIjIz4y4iNzddXiroW9LB8Z8ZERHxnxkfHdLhnLR0Z8ZMRHRnxkxEdGfGRctZCxfGT8VgsZy0dGfGTER8Zpl4zlIyM+MuIjIz4y4iMjPjKuWshYPjLiI+OtFjKWj4wDBxnLR0Z8ZMRHRnxkxEdGfGRctZCxfGTER0Z8ZMRHxlstZJx2yXjskhEfGfGRER8Z8ZERHxlXLWQsHxnxkREfGfGRER+Zq9Ou4y57WT4y4iMjPjLiIyM+Mr7bJWP5yIiPjPjIiI+M+MiIj4z4yLjnI2P5yPiVKjKWj4z4yIiPjNMuGctHRnxkxEdGfGTER0Z8ZFy1kLF8ZMRHxlstZCwfGQcOMpaPjPjIiI+M+MiIj4z4yLhqIWP5yIiPjPjIiI+Mt1rIOO2S8dglIz4y4iMjPjLiIyM+Mq5ayFg+MuIjIz4y4iPjwEHGWy1kPHbJnNZaT0cfght7n5nX88x8HHwQbu1zZuYLpa45XwwW/oEAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M302.41,425H301c.13-.44,1.28-4.32,2.51-9.1.51-2,1-4.15,1.5-6.27s.91-4.3,1.19-6.2c1.36,4.47,2.14,7.53,2.14,7.53s14.45-5.48,26-13.71a41,41,0,0,0,4.94-4.12,21.37,21.37,0,0,0,1.62-1.4c.1,0,8.83-3.54,15.23-5.24a24.74,24.74,0,0,1-6.26-9.19h0a96.19,96.19,0,0,1-1.61-16V361a40.06,40.06,0,0,1,1.5-9.25c.4-1.09.77-2,1.06-2.78,3.42-6.74,7.49-10.4,9.14-11.12-2.54,2-9.19,9-9.89,15s2.15,16.46,2.15,16.46,3.24-15.25,6.49-19.15S371,340.56,371,340.56h0a7.13,7.13,0,0,1,1.2,1.31c2.89,4.11,3.44,16.46,3.44,16.46s3.79-8.29,6.32-15.91,12.46-25.22,17.33-30.71v.14l-1.33,10.64h0c-.09.15-14.55,26-18.52,32.81S361.9,384,359.19,392.64s-4.7,15.83-4.52,18.77,6.33,9.14,9.75,11.31a107.05,107.05,0,0,1-18.34-4.45,56.72,56.72,0,0,1-12.37-5.82l-1,7.37h0c-.1,0-17.89,5.14-30.22,5.14M349,354.06a15.64,15.64,0,0,1,1-3.22l.51-1.09c-.23.63-.43,1.27-.62,1.92s-.57,1.53-.89,2.4m20.27-14.74c-3.18-1.38-8.86-1.57-9.15-1.58a5.52,5.52,0,0,1,1.93-.26,16,16,0,0,1,7.22,1.84"
                  transform="translate(2.38)"
                />
                <g class="cls3-41">
                  <rect
                    class="cls3-30"
                    x="303.5"
                    y="311.1"
                    width="98.7"
                    height="112.99"
                  />
                  <g class="cls3-42">
                    <image
                      class="cls3-33"
                      width="150"
                      height="158"
                      transform="matrix(0.68, 0, 0, -0.74, 302.07, 427.33)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJcAAACtCAYAAAC9fu2yAAAACXBIWXMAABBNAAAQTQFnjAHgAAACIklEQVR4Xu3cIVIDURRFwTfUOBaLRSFQsbARtsCm0B+RKuxPUhzXrSJGnrrmZeZYa62B//U5My9Pu6fgUefMzM/lffcc3OT59e3vt+UiIy4y4iIjLjLiIiMuMuIiIy4y58zMrGPzGNzPcpERFxlxkREXGXGRERcZcZERFxlxkTlnZryhQcFykREXGYdrMpaLjLjIiIuMuMiIi4y4yIiLjLjIiIuMuMiIi4zbIhnLRUZcZMRFRlxkxEVGXGTERUZcZMRFRlxkxEVGXGQcrslYLjLiIiMuMuIiIy4yvixIxnKRERcZcZERFxlxkREXGYdrMpaLjLjIiIuMuMiIi4y4yIiLjLjIiIuMuMiIi4zbIhnLRUZcZMRFRlxkxEVGXGTERUZcZMRFRlxkxEVGXGSu3+dyuCZguciIi4y4yIiLjLjIiIuMuMiIi4y4yIiLjLjIiIuMN67JWC4y4iIjLjLiIiMuMuIiIy4y4iIjLjLiIiMuMm6LZCwXGXGRERcZcZERFxlxkREXmevH33ZPwQMsFxlxkREXGXGRcbgmY7nIiIuMuMiIi4y4yIiLjLjIiIuMuMiIi4y4yIiLjLjI+FcEGctFRlxkxEVGXGTERUZcZMRFRlxkxEVGXGTERUZcZByuyVguMuIi47OVZCwXGXGRERcZcZERFxlxkREXGXGRERcZh2sylouMuMiIi4y4yIiLzLHW+tg9BHf6npmvYy1/FaTxC9+qI24b4AtlAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M308.74,385.59a7.46,7.46,0,0,1-3.47-.71S286,358.35,285.9,346l-1.45-21.61-4.33,21.71h0l-3.42-.58c-1.46-16.9,8-44.41,8.11-44.78h0a43.53,43.53,0,0,0,8.29-.8c3.8-.88,26.84-8.46,26.84-8.46-3.53-2.3-18.29-5.72-18.29-5.72s1.21-3.42,8.54-4.68,22.15-2.31,22.15-2.31c-1.54-1-5-1.73-9.25-2.1,9-.26,18.3-.16,27.52-.33,26.12-.46,42.54-4.46,42.54-4.46,8,2.36,17.36,14.75,20.93,19.84-3,1.1-13.9,5.08-21.29,7.09,0,0-4.88,31.87-12.74,43.87,0,0-7.5-9.42-16.35-10.14,0,0-17,14.58-24,22.32V350s-7.31,15.36-17.2,27.21c-5.8,6.92-10.72,8.35-13.82,8.35m12-81.79s-6.49,20.72-3.18,49.61l6.69-14.49s-3.51-25.34-3.51-35.1m51-23.46s6.55,13.3,8.65,25.46,0,33.58,0,33.58,4.76-9.87,5.49-16.51,5-25.71,2.16-31.41-16.3-11.12-16.3-11.12m-94.25,6.47a5.73,5.73,0,0,1,.16-1.09c1.27-4.89,27.65-29.13,42.31-35.2,9-3.72,22-5.09,31.09-5.09,5.75,0,9.95.55,10.65,1.37,1.77,2.1,4.16,7.83,4.32,8.2a10.52,10.52,0,0,0-3.24-2.33,10,10,0,0,0-2.84-.26c-2.41,0-5.3.26-5.3.26h0s-2.6-.26-6.95-.26a112.59,112.59,0,0,0-29.67,4c-19.64,5.48-40.35,29.33-40.35,29.33A63.66,63.66,0,0,1,292.81,280c-6.82,2.88-15.22,5.71-15.22,5.71a8,8,0,0,0-.16,1.09M403.29,268a59.78,59.78,0,0,0-7.86-8.63c-2.67.23-5.25.33-7.72.33-17.12,0-29-5-32.23-6.58a84.32,84.32,0,0,0,11.24,3.47c10.44,2.83,28.69,2.83,28.69,2.83a42.64,42.64,0,0,1,7.86,8.64"
                  transform="translate(2.38)"
                />
                <g class="cls3-43">
                  <rect
                    class="cls3-30"
                    x="276.32"
                    y="244.54"
                    width="138.76"
                    height="140.85"
                  />
                  <g class="cls3-44">
                    <image
                      class="cls3-33"
                      width="209"
                      height="193"
                      transform="matrix(0.68, 0, 0, -0.75, 276.32, 387.6)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANEAAADSCAYAAADUriVBAAAACXBIWXMAABAlAAAQJQEuD214AAACz0lEQVR4Xu3dsU0EQRBE0RnU2WCRACKji4WUsHGJZ3AP424lvvueh7RuqXqa3bl9zjkL+K+3l6sngOfm/fV29Qxw5+vn88/fmgii2WtfPQM8oYkgEiKIZhnnINFEEAkRRMY5iDQRRKOHoDHOQWScg0iIIJq1jXNQaCKIbOcg0kQQWXFDpIkgEiKIjHMQaSKIrLghMs5BZJyDSIggMs5BNDIEjXEOIiGCyIX2EGkiiIQIIituiDQRREIEke0cRJoIIiGCyHYOIk0EkRBB5FMIiKy4ITLOQSREEFlxQ6SJIBIiiIxzELmLGyLjHETGOYg0EURCBJFxDiJvcUNkxQ2RMxFEzkQQaSKIhAgi4xxEtnMQGecgEiKInIkg0kQQCRFExjmIZssQJJoIImciiIQIIiGCyJkIIk0EkV/Kg0gTQSREEAkRREIEkRU3RJoIIiGCaLZvISDRRBBZLECkiSASIoiECCIhgsinEBBpIoisuCHSRBAJEURCBJEzEUQutIdIE0HkTASREEEkRBA5E0GkiSAaPQSNJoLImQgiTQSRJoJIE0FkOwfRmOagcSaCyJkIIiGCyDgHkSaCyIobIuMcRMY5iIQIIuMcRJoIIiGCyC/lQaSJIPIpBESaCCIhgsj/iSDSRBBZcUOkiSASIogsFiDSRBAJEUS2cxBpIoiECCJvcUNkxQ2RcQ4iIYLIOAeRu7ghMs5BZJyDSBNBJEQQCRFEzkQQWXFDZJyDaNbWRVBoIoiECCLbOYg0EURW3BAZ5yAyzkEkRBAJEUTORBBpIoisuCEyzkHkLm6InIkgMs5BpIkgEiKI/GYrRJoIIiGCSIggsuKGSBNBJEQQWXFDpIkgchc3RJoIIiGCSIggsp2DSBNBJEQQCRFEXkCFSBNBJEQQGecgchc3RMY5iIxzELnQHiJNBJEzEURCBJEVN0SaCCKLBYj2Oefj6iHgoe9fnhsN+VN3SkMAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M309,410.57s-6.16-24.13-13.92-36c-6.29-9.64-15-28.75-15-28.75l4.33-21.7,1.45,21.6c.08,12.29,19.37,38.82,19.37,38.82a7.46,7.46,0,0,0,3.47.71c3.09,0,8.05-1.42,13.81-8.35,9.9-11.82,17.2-27.21,17.2-27.21v4.94c7.05-7.74,24-22.32,24-22.32,8.85.71,16.35,10.13,16.35,10.13,7.86-12.06,12.74-43.87,12.74-43.87,7.39-2,18.27-6,21.29-7.08.95,1.36,1.49,2.19,1.49,2.19h0c-4.48,15-16.38,23.66-16.38,23.66l.64-5.91h0c-4.88,5.48-14.82,23.09-17.33,30.71q-2.81,8.12-6.33,15.9s-.54-12.38-3.44-16.45a7.89,7.89,0,0,0-1.19-1.32,4.44,4.44,0,0,0-1.76-1.22,16,16,0,0,0-7.27-1.86,5.94,5.94,0,0,0-1.92.26h0c-1.65.73-5.72,4.39-9.16,11.12l.81-2.07c-.46,1-.87,1.94-1.24,2.94l-.51,1.1a15.36,15.36,0,0,0-1,3.21c-3.73,10.25-9.89,28.84-9.59,39h0a42.16,42.16,0,0,1-5,4.13c-11.53,8.19-26,13.68-26,13.68m40.84-33.33h0a56.33,56.33,0,0,1-1.55-16.33v.34c-.06,7.82,1.55,16,1.43,16v.42"
                  transform="translate(2.38)"
                />
                <g class="cls3-45">
                  <image
                    class="cls3-33"
                    width="399"
                    height="323"
                    transform="translate(280.61 291.32) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,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"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M466,524.17c-.28-2-.57-4-.87-5.7a5.73,5.73,0,0,1-1,.08c-1.88,0-6.16-.62-11-5.42-1-1-2.11-2.2-3.19-3.29,5.76.9,11.54,1.75,16.38,2.36,0,0,1.85-6.83,4.69-17.71a27.06,27.06,0,0,0,10.85,19.27,34.73,34.73,0,0,0,.58,5.58,16.79,16.79,0,0,0-2.83-.22,23.83,23.83,0,0,0-4.84.52c-2.76.57-6.1,2.55-8.8,4.59m21.84-22.08c3-5.9,6-12,6.19-12.72,0,2.4-3.11,7.67-6.19,12.72M494,489q-.48-3-1.25-5.89A24.92,24.92,0,0,1,494,489m-69.56-8.23a12.19,12.19,0,0,1-1.43-1.61c-2.17-2.94-3.26-7-2.44-8.51a2.52,2.52,0,0,1,2.26-1,4.52,4.52,0,0,1,3.49,1.69l-1.88,9.44m3.78-18.93c-.22-.45-.42-.88-.61-1.29-2.71-6-2.71-10.53-1.9-13.56a2.81,2.81,0,0,1,2.62-2.51,4.21,4.21,0,0,1,2.47.95,3.8,3.8,0,0,1,.58.62l-3.16,15.79m59-3.29c-1.39-9.53.81-24.9.81-24.9a135.41,135.41,0,0,0-.81,24.9"
                  transform="translate(2.38)"
                />
                <g class="cls3-46">
                  <rect
                    class="cls3-30"
                    x="422.22"
                    y="433.38"
                    width="74.38"
                    height="91.32"
                  />
                  <g class="cls3-47">
                    <image
                      class="cls3-33"
                      width="118"
                      height="127"
                      transform="matrix(0.67, 0, 0, -0.73, 420.79, 525.01)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHcAAACLCAYAAABbaQboAAAACXBIWXMAABCbAAAQmwF0iZxLAAABsUlEQVR4Xu3bsa3CUBAAQYwojIQmKJAmSOjsiIyJTIpXMxHSd7Y6v/tPsMzMnChZ1g/nvac4tsvn0/Ox8xh/6Xbf/fMW18s5x2s5TNwwccPEDRM3zLYcZnLDtsk1ujkmN8yZG2Zyw8QNEzfMmRtmcsPEDRM3TNww149htuUwr+UwccPEDXPmhpncMHHDxA0TN8xCFeb6McxrOUzcMHHDLFRhJjdM3DBxw8QNs1CFmdww149hJjdM3DALVZjJDRM3TNwwZ26YyQ0TN0zcMNePYRaqMK/lMHHDxA0TN8xCFWZyw8QNc4kRZnLDLFRhJjdM3DBxw5y5YSY3TNwwccPEDftaqGxUNSY3TNwwccPEDXNDFWZyw8QNEzfMmRtmcsN8+zHM5IaJGyZumG05zOSGiRsmbpgzN8zkhokb5voxzJkb5rUcJm6YuGHihokbZlsOM7lh4oaJG+bH12EmN0zcMHHDxA0TN8wNVZjJDRM3TNwwN1RhJjdM3DBxw/yfG2Zyw8QNEzdM3DBxw2zLYX6fG+a1HCZumDM3zOSGiRsmbpi4YcvMvH49xKFc1w/L+O5U1ht/3zYvinYl6wAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M422.56,505.21s27.41,4.89,43.77,6.94c0,0,16.65-61.19,26.51-109.58l-2.61-4.39s-26.52-3.65-48.6-3.12L420.58,500.24l2,5"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-30"
                  d="M487,631c-10.83-1-56.4-39.89-58.35-41.84s-29.13-18.87-30.15-19.5h0c.91.25,35.77,3.29,35.93,3.29h0s-19.7-9.78-23.31-11.21h0l-20.94-22.13s-1.19-4.39-2.37-10.24c.67-4.86,1.3-9,1.75-11.72a38.11,38.11,0,0,1,2.34-8.52c-1.64,8.44-4,26.93,4.9,34.38,11.58,9.73,57.13,30.4,57.93,30.71a52.28,52.28,0,0,0,9.17,7.68h0a56.26,56.26,0,0,0,6.68,3.84h0a27.76,27.76,0,0,1,4.7,2.94,21.45,21.45,0,0,1,5.23,6.11h0q.27.62.48,1.26c2,6.46,6,34.81,6,34.81m13.79-7.17-.08-.12c1.59-5.18,2.46-8.78,2.46-8.78s-2,2.49-4.47,5.85c-2.87-4.18-8.06-11.77-11.15-16.91-1.2-2-2.65-4.25-4.14-6.59a96.82,96.82,0,0,0-5.81-9.27,35.89,35.89,0,0,1-3.6-7c-.85-3.29-6-29.47-6.6-32.52h0v-.29c-.07-.42-.14-.84-.2-1.25a36.18,36.18,0,0,1,17.55-21.55c-10.43.64-19.37,11.9-19.37,11.9h0S461,530.6,461,529.26c0-.68,2.15-2.92,5-5.09a24.89,24.89,0,0,1,8.8-4.58,23.91,23.91,0,0,1,4.84-.53,17.8,17.8,0,0,1,2.83.22,6.92,6.92,0,0,1,1.27.31S489,553,495.05,572.66s8.63,35.79,8.38,40.58a64.73,64.73,0,0,1-2.62,10.52h0m-56-64.67q-5.47-9.2-10.07-19c-7.92-17-21.15-45.67-21.15-45.67h0l-1.09-.75a3.66,3.66,0,0,1,1.09.75c1.63,2,12.48,22,15.72,30.91,2.42,6.58,9.42,21.93,15.53,33.73m22.7-9.87a2.87,2.87,0,0,0-.07-.5,2.08,2.08,0,0,1,.07.5m-223.6-3c-1.22-10.4-2-19.64-2.65-27.29.64,6.3,1.39,13.43,2.21,20.91.12,2.19.27,4.3.44,6.38m142.71-23c-.93-6.07-1.46-12.4-.58-16.53a54.36,54.36,0,0,1,8.36-18.52h0c7,2.2,14.36,3.91,17.63,5.32-1.16.42-12.09,4.39-15.19,6.22-3.33,2-8.56,13.49-9.83,20.73-.11.67-.24,1.6-.39,2.78m-67.87-60.33c-11.82,0-25.88-1.49-31-4-8.39-4.22.11-23.72.85-25.4a200.69,200.69,0,0,0-9.64,21h0a199.24,199.24,0,0,1,9.61-21l.06-.1a73.94,73.94,0,0,0,9.47,1.35c3,.28,6.59.49,10.71.49,1.52,0,3.11,0,4.77-.09,6.93-.27,12.85-.67,17.23-1,5.21-.43,8.24-.78,8.24-.78s7.74,14,11.5,23h0c-3.76-9-11.5-23-11.5-23s2.59,23.11-2.48,27.11c-2.13,1.67-9.41,2.43-17.83,2.43"
                  transform="translate(2.38)"
                />
                <g class="cls3-48">
                  <rect
                    class="cls3-30"
                    x="243.42"
                    y="433.38"
                    width="261.77"
                    height="198.13"
                  />
                  <g class="cls3-49">
                    <image
                      class="cls3-33"
                      width="389"
                      height="270"
                      transform="matrix(0.69, 0, 0, -0.75, 243.42, 632.54)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAYYAAAEnCAYAAACtwOSuAAAACXBIWXMAABAlAAAQJQEuD214AAAEU0lEQVR4Xu3csU1EMRBAQRs5gh4ogQaogLKoigooidgXXICfhPRzbiY8/fxprdude+89AGCMOcYYT1dfAfBY1vfXz9U3APxD7x8vf/5uYgAghAGAEAYAQhgAiHX/cxIA3C1dAODkKQmAEAYAQhgACGEAIIQBgBAGAEIYAAhhACDWtOEGwMHEAEAIAwAhDACEMAAQwgBACAMAIQwAhDAAEMIAQAgDAOEkBgBhYgAghAGAEAYAQhgACGEAIIQBgBAGAEIYAAhhACCWxWcATmsoAwAHT0kAhDAAEMIAQAgDACEMAIQwABDCAEAIAwBh8xmAsPkMQHhKAiCEAYAQBgBCGAAIYQAghAGAEAYAQhgACGEAIJzEACCcxAAgPCUBEMIAQAgDACEMAIQwABDCAEAIAwBhwQ2AMDEAEMIAQDiJAUCYGAAIYQAghAGAEAYAQhgACAtuAISJAYAQBgBCGAAIYQAgnMQAIEwMAIQwABDCAEAIAwAhDACEkxgAhIkBgBAGAEIYAAhhACCEAYBYY/pfEgC/TAwAhDAAEMIAQNh8BiBMDACEMAAQwgBACAMAIQwAhDAAEGv4vyoABxMDACEMAIQwABBOYgAQJgYAQhgACGEAIIQBgBAGAEIYAAgnMQAIEwMAIQwAhM1nAMLEAEAIAwAhDACEMAAQwgBACAMAYfMZgDAxABAW3AAIEwMAIQwAhDAAEMIAQAgDACEMAIQwABA2nwEIEwMAYfMZgDAxABDCAEAIAwAhDACEMAAQwgBACAMAYfMZgLDgBkB4SgIghAGAEAYAQhgACGEAIIQBgBAGAEIYAAhhACDWtPoMwMHEAEAIAwAhDACEMAAQwgBACAMAIQwAhDAAEMIAQAgDAOEkBgBhYgAghAGAEAYAQhgACGEAIIQBgBAGAEIYAAhhACCWxWcATmsoAwAHT0kAhDAAEMIAQAgDACEMAIQwABDCAEAIAwAhDACEkxgAhJMYAISnJABCGAAIYQAghAGAEAYAQhgACGEAICy4ARAmBgBCGAAIJzEACBMDACEMAIQwABDCAEAIAwBhwQ2AMDEAEMIAQAgDACEMAIQwABBuJQEQJgYAQhgACGEAIIQBgHASA4AwMQAQwgBACAMAIQwAhDAAEE5iABAmBgBCGAAIYQAgbD4DECYGAEIYAAhhACCEAYAQBgDC5jMAYWIAIIQBgBAGAMLmMwBhYgAghAGAEAYAQhgACGEAIGw+AxAmBgBCGAAIYQAghAGAcBIDgDAxABDCAEAIAwAhDACEMAAQTmIAECYGAEIYAAgLbgCEiQGAEAYAQhgACGEAIIQBgBAGAEIYAAgnMQAIEwMAIQwAhJMYAISJAYAQBgBCGAAIYQAghAGAEAYAQhgACCcxAAgLbgCEpyQAQhgACGEAIIQBgBAGAEIYAAhhACCEAYAQBgBiTavPABxMDACEMAAQwgBACAMAsV7fnj+vPgLgccy999U3ADyQGx0FDcE/c489AAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M335.78,407s17,12.48,28.55,15.82c0,0-19.41-2.19-30.72-10.26A55.69,55.69,0,0,1,335.78,407Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-30"
                  d="M369.75,344.59A16.2,16.2,0,0,0,360,354a34.18,34.18,0,0,0-1.26,24.44s-.9-11.46,2.71-20.07A52.72,52.72,0,0,1,369.75,344.59Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-50">
                  <rect
                    class="cls3-30"
                    x="357.86"
                    y="345.15"
                    width="14.3"
                    height="34.06"
                  />
                  <g class="cls3-51">
                    <image
                      class="cls3-33"
                      width="29"
                      height="51"
                      transform="matrix(0.65, 0, 0, -0.71, 356.62, 380.11)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAA4CAYAAAAB8vOKAAAACXBIWXMAABDqAAAQ6gGC0wqYAAAApElEQVRYR+2ZOwrAMAxD7ZKj9GCde6DOPVjv4k79DCWBEkuDoikEg3iKMSHxiAjDyqdWRYbKtTiWtVb3S/O+fe5TSCmmd7wG7CcKqY7p60wrVZ31mAJddeIlkwJRdeKlmOrES+leMikOlE0KRNWJl2J6x+vjCpogne6lDAcyKQ6UTQpE1YmXYjreHFI1ujdVYyKlimKqM5Gc8XFQzMxbVb1FifcEx9ElgRQCyNQAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M363.43,352.23a24.25,24.25,0,0,1,0,13.09c-1.54,5.76-4.68,6.29-4.68,6.29s2.17,1.68,5.6-1.59c4.52-4.3,2.71-21.94,2.71-21.94l-3.61,4.1Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-52">
                  <rect
                    class="cls3-30"
                    x="360.72"
                    y="348.25"
                    width="10.01"
                    height="24.77"
                  />
                  <g class="cls3-53">
                    <image
                      class="cls3-33"
                      width="20"
                      height="37"
                      transform="matrix(0.68, 0, 0, -0.75, 359.29, 374.2)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAApCAYAAAA1bQl+AAAACXBIWXMAABAlAAAQJQEuD214AAAAeklEQVRIS2P8////fwYqAhYY405CFj51BIHKgmkMDAwMDEwE1JEMBr+B8DBkoFLU0NCFVHLiqJcpB4PfhTSMFCqVYrR0IR5VJACqx/Lg9zLtXMg4mmzIBSPQy1R3IdXDkOoGjhawlAOqu5CWYUgdJzLSolvBSEgRKQAAWyolYd3wmOoAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M352.23,368.89s-2.83-10.36-2.15-16.45,7.36-13.08,9.9-15.05h0c.28,0,6,.19,9.15,1.58h0a4.6,4.6,0,0,1,1.76,1.21h0s-8.94,5.6-12.2,9.5-6.5,19.21-6.5,19.21"
                  transform="translate(2.38)"
                />
                <g class="cls3-54">
                  <rect
                    class="cls3-30"
                    x="352.14"
                    y="337.41"
                    width="21.45"
                    height="30.95"
                  />
                  <g class="cls3-55">
                    <image
                      class="cls3-33"
                      width="42"
                      height="47"
                      transform="matrix(0.65, 0, 0, -0.71, 349.28, 371.13)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA0CAYAAAD8H6qwAAAACXBIWXMAABESAAAREgEAwpvaAAAAnklEQVRoQ+2aOw7AIAxDE8RpORDXTYdKpQt0sSpb8puQyGA9wmcgq6qCm4yIaF9VLPRnNOeh7CfG2E6toLmtoeAVlDupjFHBzeSlx2CjaGwUjY2iWUEbd1JBo+Q9qnjXH6oIUAzKndRG0dgoGhtFI2iU/PXkux6NNxMaG0Vjo2hsFI2NopExKvgoIY/sHkVjo2hS5WNBD/pFvyE/lBYXviAK+1bP1q0AAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M356.2,378.42s4.1,3.4,6.87,1.76c0,0-1.08,4.7-4.34,4.7s-2.53-6.46-2.53-6.46Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-56">
                  <rect
                    class="cls3-30"
                    x="357.86"
                    y="379.21"
                    width="7.15"
                    height="6.19"
                  />
                  <g class="cls3-57">
                    <image
                      class="cls3-33"
                      width="16"
                      height="12"
                      transform="matrix(0.68, 0, 0, -0.75, 356.43, 386.57)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAANCAYAAACgu+4kAAAACXBIWXMAABAlAAAQJQEuD214AAAATklEQVQoU2P8////fwYKABMhBYQAC5x1eBUeZViAbRgDAwOyAX/+4VKKFyAM+E2pAb/+4lGGG1AxECn2AuUGkBcGSIFIsQvIM4CR0rwAAKq1GehrOyA6AAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M356.14,386.44a24.58,24.58,0,0,1-6.26-9.2s-5.44,10.45-9,14.44c0,0,8.79-3.53,15.24-5.24"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-30"
                  d="M284,300.8c-.07-.07-7.23-7.34-6.67-14-.26,4.95,5.15,12.35,6.67,14v-.54"
                  transform="translate(2.38)"
                />
                <g class="cls3-58">
                  <rect
                    class="cls3-30"
                    x="279.18"
                    y="286.33"
                    width="7.15"
                    height="13.93"
                  />
                  <g class="cls3-59">
                    <image
                      class="cls3-33"
                      width="16"
                      height="23"
                      transform="matrix(0.68, 0, 0, -0.75, 277.75, 303.42)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAZCAYAAAA4/K6pAAAACXBIWXMAABAlAAAQJQEuD214AAAATklEQVQ4T+2VsQ3AIAwE7yMGYohskqUYhRWYyhQRgo4Cyv/G1sk6uXtFRHCQZ3ewSxpLLW1SCaF/SgMuDN4vAxc+sMACsAAsAAsAdNoLHSmvCyssMtfAAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M284.11,300.8h0c-1.52-1.63-6.93-9-6.67-14a8.19,8.19,0,0,1,.16-1.09s8.4-2.83,15.22-5.71c9.18-2.19,19.23-3,29.64-3.29,4.24.38,7.72,1.1,9.26,2.1,0,0-14.91,1-22.23,2.26s-8.52,4.68-8.52,4.68,14.76,3.41,18.28,5.72c0,0-23,7.57-26.83,8.45a43,43,0,0,1-8.31.88"
                  transform="translate(2.38)"
                />
                <g class="cls3-60">
                  <image
                    class="cls3-33"
                    width="163"
                    height="69"
                    transform="translate(279.41 275.49) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKMAAABLCAYAAAAcezdvAAAACXBIWXMAACBLAAAgSwFrhwW5AAADB0lEQVR4Xu3c23WbQBSF4TNZ9OFKUks6SV+pxOWQB+xoYO432Fn6vweZIJ0DyDuDuMju58fv3S5cMPWa85r05l245PPO+5F5PpiOzIuuR7jmufU8no4vJ70N/vz8+pyrIzX//hlfTn4b/GWnny/+Lk6zwvcyvg0p7vTjmExs92Xen89fbou8woJ0ZsQW0VI/w4x1uPYYrTdr6zFabzbe4+n6H6UXAHchjJBBGCFjC/fq/p6/ZY+f891zdj+z9+05u5/Z0z0ZGSGDMEIGYYQMwggZhBEyNtsvRzulKz576Wju+5JQ5igqeQGyYV2yB2mXo7nuPj7n9YkU1fY5rYv7qqst9vQdsIZ6+hQzUng+gZERMggjZGwtI+rohfBRqb1DyzqM9hitRxojI2QQRsggjJARuVHCVzqN02r0PEKspvR8TE9Nyez3qseK7boPIyNkEEbIIIyQQRghgzBCRuSrqk8esfbUrMCR8RMYGSGDMEIGYYSM6F07CnemPH2H0Eqj2zb6+xmtN1uzDZO+N313Te3ra/T0vKtGQc/vqQ+7acggjJBBGCGDMEIGYYQMwggZhBEyCl87mKXnHNtdNf+rnvN/PTX3YWSEjPAWspb/MKnrSmZz+szoYVbfJ9fDbE6f2h5mc/qs2KbamkaMjJBBGCGDMEIGYYSM6Kmd15yeUyV31JQ/TYef2485u/eY47zHQ1vlMRV/dbnHYdVx3Wi9WVuPWoyMkEEYIYMwQgZhhAzCCBmEETIq/7xJTPn0Suiumh49y7mr5j0wMkIGYYQMwggZhBEyCCNkbPuyI7r6o0YXmapfL3eqCqfqXG8IGK03a+uRr69/L196auZrudGCkREyCCNkEEbIIIyQ8aZ/LHRk2WZra5707PoyMkIGYYQMwggZhBEytuLn1NQpdLP6z7i5HmZz+tT2MGu7LJCyel3M6vvM6GE2r08nRkbIIIyQ0XGjRM+5Pvf1GK+Jzw2X07d3Pfep65Hexrr6ET3v72HtzRplo/WMjJBBGCGDMEKG2/eWvTqwzl+366CcqRMW5AAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M415,294s-.23-.93-.69-2.49a84.78,84.78,0,0,0-11-23.48A60.18,60.18,0,0,1,415,294m-59.53-40.81a5.17,5.17,0,0,1-.88-.44s.3.17.88.44"
                  transform="translate(2.38)"
                />
                <g class="cls3-61">
                  <rect
                    class="cls3-30"
                    x="356.43"
                    y="252.29"
                    width="60.08"
                    height="41.79"
                  />
                  <g class="cls3-62">
                    <image
                      class="cls3-33"
                      width="97"
                      height="60"
                      transform="matrix(0.67, 0, 0, -0.73, 355, 295.08)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABCCAYAAACsCQM4AAAACXBIWXMAABB0AAAQdAFKfdo/AAAAvklEQVR4Xu3RsRGAMBDAsIdj/52YLIyQCnAh1e58rLXW8KdjZubcVXzDiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIMCLCiAgjIoyIuGbm3kW87wHSngVEBzk5oAAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M415,294s-.23-.93-.69-2.49l-.8.3c-3.58-5.09-13-17.48-20.94-19.84,0,0-16.41,4-42.54,4.46-9.21.17-18.5.07-27.52.33-2.46-.22-5.19-.33-8-.33-7.53,0-15.31.81-18.84,2.43-.89.4-1.85.82-2.85,1.24a63.63,63.63,0,0,0-15.22,5.7s20.71-23.86,40.35-29.33a113,113,0,0,1,29.67-4c4.35,0,6.95.26,6.95.26h0a5.17,5.17,0,0,0,.88.44c3.21,1.53,15.11,6.58,32.23,6.58,2.47,0,5-.1,7.72-.33a59.34,59.34,0,0,1,7.86,8.64,84.52,84.52,0,0,1,11,23.48c.46,1.56.69,2.49.69,2.49h0"
                  transform="translate(2.38)"
                />
                <g class="cls3-63">
                  <image
                    class="cls3-33"
                    width="405"
                    height="117"
                    transform="translate(280.03 252.29) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZUAAACACAYAAADDN/SnAAAACXBIWXMAACCaAAAgmgEqxj5tAAAEgElEQVR4Xu3dUW7iSBQF0MfIq+r9zIZmL7M+5iOqHgjYuIpLxTTnfLRaMvV8gURXFcCc/v7177kunGrD5sEtpzoNr61d5717kx3r7jr9/mf98NDBbcOP0c2620HRx6c5DY5YXXS687+7h/s9WPv4OR04efzx2XmTq4M7hjWjeat2Lxx7Xvc/eQ9HXeq68YWrx2lgyMaS/c9rh5vHZ+egnTerurrpP8v3g1cN84TveVJzZ7v3uCbuy8y5Vc/Pfre5VV2/E13ne7e5W175ezr7Z7zqufmvevyPMLd51fzLuX+t3goAOi193QUA6+xUAIhRKgDEKBUAYpQKADFKBYAYpQJAjFIBICb8OZVXfj76WT2fD616z8zNrOyj+dbMyl3Vn/3I2ba8a+5LyfuQzpjMtubImW+z2akAEKNUAIhRKgDEKBUAYpZz9EUbAD6ZnQoAMUoFgBilAkCMUgEgRqkAEKNUAIhRKgDELHX2ORUAMuxUAIhRKgDEKBUAYpQKADFKBYCYjasUj3yF5ax3kh0525be3DMz92armpdvJNsjM7KP5j5yti0zcl8auQ+zMo5kW5PO/NpsdioAxCgVAGKUCgAxSgWAGKUCQMySf2cBAJ/KTgWAGKUCQIxSASBGqQAQo1QAiFEqAMQoFQBiNq5SDAB97FQAiFEqAMQoFQBilAoAMcv6oZ98Af/R113+ZLbmUcZ7ZuU+craq/nxHzrZlVu6RzLOyXRrJuSV5H2Qbc5vNTgWAGKUCQIxSASBmif55jfdy77nv+fPt5frZ66p+Zu3sdc3o+hnrqp7L/MzaqvHciXXN6Pp3WdfsWG+nAkCMUgEgRqkAELNk37MMwCezUwEgZrFPASDFTgWAGKUCQMykF+p3fGLmyoxMTW+2ZkbGI2erOna+I2drRjN+94rMqWyX0jmTGWUbc5vNTgWAGKUCQIxSASBGqQAQo1QAiFEqAMRMeksxAJ/ATgWAGKUCQIwLSgIQY6cCQIxSASBGqQAQ4y3FAMTYqQAQo1QAiFEqAMQoFQBilAoAMUude9/9NfL9xr3neEZvPtm+9GarmpfvT8vWzMg4mm9GtubIGY+crenNmMx2e247FQBilAoAMS4oCUCMnQoAMUoFgBilAkCMC0oCEGOnAkCMUgEgRqkAEKNUAIhRKgDEePcXADF2KgDEKBUAYpQKADFvd5Xita+jefZ+vNvcqvuzzf3fs7PfbW7T85VNe8/ZM7PZO7uqb765X3rmNq+afzl344X6V//ob+m569/NyFc1llG2L735Pi1bb4Yt6XzJbM2RM6azVWXzVWUz9ma7Pbc/fwEQo1QAiFEqAMQoFQBilAoAMUoFgBilAkCMC0oCEGOnAkDMYqMCQIqdCgAxSgWAGKUCQMzGpe9nvNjyk1dCbnqvytnMyHjkbFU/n2/0/FtS2arG8yUzrDlSttEsa5IZ09mqsvmqshl7s92e204FgBilAkCMUgEgRqkAEKNUAIhRKgDEKBUAYlylGIAYOxUAYpQKADGn89mfvwDIsFMBIEapABDzHyhMnzDSCtOQAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M415,294s-.55-.83-1.49-2.19l.8-.3c.46,1.56.69,2.49.69,2.49h0"
                  transform="translate(2.38)"
                />
                <g class="cls3-64">
                  <image
                    class="cls3-33"
                    width="7"
                    height="10"
                    transform="translate(415.07 290.98) scale(0.4 0.42)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAALCAYAAACzkJeoAAAACXBIWXMAABuHAAAbhwHouLjtAAAAM0lEQVQYV2OMNJ/8n4GRgYEBQqAAJgwR2kuyIBxCooNYGBj+45QkpJPBEZck4///uI0FAIZNBn5+EiOTAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M292.82,280.05c1-.42,2-.84,2.85-1.24,3.53-1.62,11.31-2.43,18.84-2.43,2.76,0,5.49.11,7.95.33-10.41.31-20.46,1.1-29.64,3.29"
                  transform="translate(2.38)"
                />
                <g class="cls3-65">
                  <image
                    class="cls3-33"
                    width="91"
                    height="15"
                    transform="translate(296.86 275.49) scale(0.3 0.35)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFsAAAASCAYAAAA0YaI9AAAACXBIWXMAACTBAAAkwQHmhs4JAAAA1klEQVRYR+2Y0Q3DIBBDfVFm6Tb97GrZocN0JvpDw4UcCojUX34fCbrDjmSQiLDnY0swBOSimWuHE0vVXL8U8zDWlrqV1z5sfbnS/FiCWsY7nWeYs4z0dnoeW0Hn4GN4f162QNBYU1WI1rWec0XtMasHxjxm9cC8R6TXziaisIkobCIKm8jabo0cBzX+eJjx8fzT824/IPLUziaisIkobCIKm4jCJqKwiShsIiuQGr+ZjauY+AZzb/fhrjQjUa/P8U4z63rFjrt+4S98tLOJWEozSylG+AKljBwgME2KggAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M317.53,353.41c-3.31-28.89,3.18-49.61,3.18-49.61,0,9.79,3.51,35.1,3.51,35.1l-6.69,14.49"
                  transform="translate(2.38)"
                />
                <g class="cls3-66">
                  <image
                    class="cls3-33"
                    width="32"
                    height="130"
                    transform="translate(316.37 304.67) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAACKCAYAAADL/Uh8AAAACXBIWXMAAB9fAAAfXwGscuV3AAABAklEQVR4Xu3awQ3CMBBE0QW5FQqhFHqiXkwJOUUvUv6eLflrZuL1Jnm8X989sNbM72jNqfU8WnB2Lar/XEABDlAIA+AAa8aeBPwg8grg/QuhDyG3gAPwDKQAV4ADZEEK8F7QfYCHkAN4C/btFbh9BjgAt2Btu79XoAxwAG5BADwD/E7IFeAZ4AAXGEz6YIGLA/AQcgU4QEdxCvD7gFdg14xw8RB2DnCALEiB3hUH0FOQAs2GPANdyTyA3f4STwGWwGdAA/AMBMAzwAG4BRygXhBA0zEHWIP/47mAAncPIVegXtBcwC0IoAxwAG4BB+AWcADeDctACqyZ+RwtOrMeGw8mfxURTqRG2iJZAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M320.14,465.32c-13.3,0-30.13-1.46-35.14-2.44-7.05-1.37-7.76-4.11-7.76-4.11l1.72-4.39h0a201.11,201.11,0,0,1,9.61-21c-.74,1.68-9.24,21.18-.85,25.39,5.12,2.56,19.14,4.05,31,4.05,8.42,0,15.7-.76,17.82-2.43,5-4,2.49-27.11,2.49-27.11s7.74,14,11.5,23h0s-5.89,6-16.92,8.23a78.91,78.91,0,0,1-13.47.86"
                  transform="translate(2.38)"
                />
                <g class="cls3-67">
                  <image
                    class="cls3-33"
                    width="217"
                    height="90"
                    transform="translate(279.6 433.38) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANkAAABiCAYAAADds3bAAAAACXBIWXMAACBLAAAgSwFrhwW5AAABdklEQVR4Xu3csRECMQxEUR+j/vugDOjpUkQJBMzP3otJd1aWzV3v570HqLwev34B/EfIIDZnTYtQGhGDlnERYkIGMSGD2JzjVAYl20WIGRchJmQQEzKIzTqTQWosF6FlhQ8xZzKIzWoySGkyiAkZxGwXIabJIGbxATFNBjGX0RDTZBAb74Ohpckg5p4MYhYfEDMuQkzIIObFB8Q0GcSEDGIuoyFmhQ8xl9EQ02QQs/iAmHERYpoMYs5kENNkEBs9Bi3jIsRsFyHmTAYxIYOYMxnENBnEZv2hDFK+8QEx4yLEhAxiQgYxIYPY7MfiA0qaDGJefEBMk0FMyCDm/2QQcyaDmHERYpoMYpoMYhYfENNkEHMmg5gvCEPMmQxixkWIGRchJmQQMy5CzOIDYpoMYl58QGyOb+FDSpNBTMggJmQQcxkNMU0GMZfREHMZDbFxTQYtTQYxiw+ICRnEZo2LkNJkEBMyiLmMhpgVPsSMixC71pMPSH0BkfZMAbCEk+gAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M470.29,581.92c-.54-7.48-1.64-22.34-2.43-30a8.08,8.08,0,0,0-.1-.86V551c0-.33-.06-.65-.11-1s-.09-.6-.13-.86h0a5.11,5.11,0,0,0,.13.86c.05.3.08.62.11,1v.12a5.16,5.16,0,0,0,.1.87c.76,6.8,1.61,18,2.15,25.73h0l.29,4.24"
                  transform="translate(2.38)"
                />
                <g class="cls3-68">
                  <rect
                    class="cls3-30"
                    x="469.43"
                    y="549.46"
                    width="2.86"
                    height="32.51"
                  />
                  <g class="cls3-69">
                    <image
                      class="cls3-33"
                      width="12"
                      height="48"
                      transform="matrix(0.68, 0, 0, -0.75, 468, 583.59)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAA1CAYAAAB1AAqCAAAACXBIWXMAABAlAAAQJQEuD214AAAAmUlEQVRIS82W0Q2AIAxEi2EBF3AA95/FAVzAEeqXSiSBexiI90W0l9erTTC4uxvQVCt4K16HfTuyl8s6Z8/aCSZGwYT+hjuD+jkwARuSsRaqEj0ZSlWJMOFDBhGBCdgwMLSLiKEtacIEbMCh/zxWFYEJ/Q14SniXMKE9g7oamIANOHT/XcItYQI2/PnaFTuyQH/hopmFWlGqEwavK3RlDEUqAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M485.8,651.08c-7.77,0-28.9-16.45-35.11-22.79-5.09-5.21-15.1-20.31-22.16-29.22l-1-2.91,10.07,2.92a44.93,44.93,0,0,0-14.5-10.26c-8.14-3.29-30.22-9.54-30.22-9.54h0a65.47,65.47,0,0,1-6.63-7.63c-.85-1.09-1.25-3.9-1.32-7.67,5.26,2.9,11.35,6,13.58,6.27h0c1,.64,28.2,17.55,30.15,19.51s47.52,40.85,58.35,41.83c0,0-4-28.35-6-34.81-.14-.43-.3-.84-.48-1.26,3.67,6.58,6.14,33.93,6.14,33.93s.1-21.59-1.59-28.19a20.48,20.48,0,0,0-1.65-4c1.49,2.36,2.94,4.63,4.14,6.58,3.13,5.14,8.28,12.73,11.15,16.91-2.8,3.92-6,9-7.05,12.81q-2,8.19-3.32,16.58A61.93,61.93,0,0,0,496,637.25c-2.94,7-6.27,12.91-9.07,13.65a4.21,4.21,0,0,1-1,.12m11.28-15.42a.13.13,0,0,1,.05-.11c1.63-4.25,3-8.36,4-11.78l.07.12h0c-1.14,3.67-2.58,7.82-4.17,11.76m-112-22.65a88.37,88.37,0,0,1-13.52-32,70.83,70.83,0,0,1-1-13c0-27.81,10.18-69.59,11.72-72.59,1.81-3.53,12-7.18,12-7.18A54.26,54.26,0,0,0,386,506.69c-.88,4.13-.35,10.46.58,16.53-.92,7.79-2.27,25.55-2.69,37.48-4.53-.88-7.76-1.74-7.76-1.74s3.44,2.07,7.68,4.39a48.76,48.76,0,0,0,.27,8.66c.85,3.07,4.22,6.59,6.27,8.55l-16.53,8.7,4.72,12.06,6.66,11.57h0m43.22-14-.27-.34a3.89,3.89,0,0,1,.27.34m-40.07-2.62c1-4.63,2.21-9.65,3.63-14.26h0c-.84,2.9-2.23,7.9-3.66,14.26m87-6.93a28.41,28.41,0,0,0-4.7-2.94,21.38,21.38,0,0,1,4.7,2.94m2.3-1.41c-3.69-5.32-7.37-10-7.6-10.29-.54-7.77-1.39-18.93-2.15-25.73a8.58,8.58,0,0,0-.1-.87V551c0-.33-.06-.66-.11-1s-.09-.59-.13-.86h0a2.15,2.15,0,0,0-.07-.5h0v-.23c.62,3.05,5.76,29.21,6.6,32.52a35.6,35.6,0,0,0,3.6,7m-43.17-14.37c-.16,0-35-3.08-35.93-3.29,4.22.46,35.78,3.29,35.93,3.29m-30.22-10.88c-2.25,0-5-.09-8.18-.32A104.39,104.39,0,0,1,385,560.82c.17-8.78,1.58-21.16,2.89-30.8,1.18,5.82,2.37,10.22,2.37,10.22l20.94,22.1h0a59.6,59.6,0,0,1-6.94.32"
                  transform="translate(2.38)"
                />
                <g class="cls3-70">
                  <image
                    class="cls3-33"
                    width="383"
                    height="440"
                    transform="translate(372.16 488.14) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,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"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M385.29,613h0l-.06-.11c.92-6.07,2-11.73,3.14-16.61-.83,3.84-1.49,7.41-2,10.27l-.07-.09-.7,4.67c-.18,1.15-.28,1.83-.29,1.89"
                  transform="translate(2.38)"
                />
                <g class="cls3-71">
                  <rect
                    class="cls3-30"
                    x="387.89"
                    y="595.9"
                    width="2.86"
                    height="17.02"
                  />
                  <g class="cls3-72">
                    <image
                      class="cls3-33"
                      width="12"
                      height="26"
                      transform="matrix(0.68, 0, 0, -0.75, 385.03, 615.22)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAdCAYAAACe/43ZAAAACXBIWXMAABAlAAAQJQEuD214AAAAUUlEQVQ4T+3UsQ2AMAwAwQ/KIMzAFCzNEGzBFH4qJEITpyZXufDLnYsqA5bewld9hvO4wEAFJQww2Pa1CYYvzCBjBhkzyPhlUEZfZQVKb+ntBpWVFzYoTTPSAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M385.21,612.9l-6.66-11.57-4.72-12.06,16.53-8.7c.84.8,1.46,1.33,1.62,1.46-1.42,4.61-2.64,9.62-3.63,14.26-1.1,4.88-2.22,10.54-3.14,16.6"
                  transform="translate(2.38)"
                />
                <g class="cls3-73">
                  <image
                    class="cls3-33"
                    width="56"
                    height="87"
                    transform="translate(375.02 580.99) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAABcCAYAAAA743ZSAAAACXBIWXMAAB9fAAAfXwGscuV3AAACrElEQVR4Xu1bW3LkIAxstnzvHGRPs2fJPaJ82NiyjB44rq0g0z8DUiPoES97kvL345OwgUAArSUQMetaX120+Wurr4t9ZVJtvsagr6OPU3sWGwTa4+yWM4+N7+y72gmEZe8HrE8Bafd4Lb/la9mfivVH4aTBUjwGQ/1mZBvNfgdeLDJ8EoQXZDC9wOWUby3/0t7Ls+xgPiuuxTP6SZ/BKXB0pBe4XBb1ncOu53CquLOhWP0ovqV/ZBw9yiJqWn4vvs15wRTlN9NomdctO4nPqN0rd8RLn8EpcHSkF/jDYyKCuo3/pB/vOKmcqz99BqfA0TEFjo70Aufj0jOIfAMRjodrFtJP0SlwdKQXuJxqkR3S2v34boetfqd9ywdc43k7Ozp/XfJgnTCRsUfslq9lf9kUJRxfg2WXHBKfEXukn2qT5Wg8vCCD6QV2/RGC59fq3ObF8GL1jjd9BqfA0fGfHpeiIPjjqSssxkufwSlwdJwv25FbvrZMCKDNXvgy2ex7E9F+p2p2WdH6Udqkz+AUODp+2TkIxM5CIMq7vvhtwdhYAMVX/T0bl7eh8bpVxlFPP0XTCzRfOnkzsAdeLM/fAx7r/IdA3Cvr8lNyuF0r83qPPRJbaZd+iqYX+Og7Gc/f4kRnKvdH+qn1/BkMbVuEedD/VkyBo+OhpwltsUn08ACfqy3eA+kzOAWOjilwdKQXaP+DpHEFOkG7NkkOFF/1R65vHDJmYxwvyKB5mEYPZiDOjfIqovz2FIm9suC2nrKMVW1an57d669Rzj9Fi7HJ0FYv1Qe0Z0tjcV8oW/vSag/RF3DEsWaoHNPGpa1cynxlMT6mwNExBY6O9D++pM/gFDg60gt86L3oHViXTIkeLsC3mfQZTC9wQcE/k6HNjhuPMc0y50lUrhVPQnC/Ad/wdAjQOKwUAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M338.15,728.64c-23,0-53.09-3.43-53.69-5.34-.65-2.2,1.42-6.36,1.76-7-.61.83-5.58,7.67-5.58,11.29,0-3.62,5-10.46,5.58-11.29v-.08h0l-1.72-4.63L282.08,705l.2.51a15.33,15.33,0,0,0,8.37,9c22.23,9.3,62.06,13.48,62.06,13.48a140.48,140.48,0,0,1-14.62.65m-5.31-15.81c-18.84,0-37.89-3.52-40.57-5.62-5-4-18.28-53.36-24.07-69.1s-18.2-55.56-22.29-76.09h0c-.85-7.45-1.7-15-2.47-22.16-1.36-23.12-.35-49.1-.35-49.1s27.39-11.62,40.12-11.62H284c.73,0,1.51.05,2.33.05,12.95,0,35.94-4.24,41-5.65a109.88,109.88,0,0,0,11.26-4.66c.12.1,30.54,22.75,41.55,26-8.91,21.14-16,57.57-14.46,73,2.17,21.72,13,47.5,13,47.5s2.26,66.5-7.86,85.66c-4.76,9-21.34,11.81-38.09,11.81m35.46-63.09s-15.5,20-27.63,28.15-31.63,18-31.63,18,31.67-3.61,41.68-12.6,17.58-33.54,17.58-33.54m-72.64-63.83h0s-6.68-8-21.55-21.41S243.79,532,243.79,532s4.82,9.87,7.14,13.74v.06A82,82,0,0,1,243.74,532s7,21.12,11.92,27.57,23.48,22.87,39.93,26.4m.14.09a198.38,198.38,0,0,1-26-18.64h0a225.34,225.34,0,0,0,25.92,18.52h0m84.61-91.14a51.33,51.33,0,0,1,5.35-10.3,60.19,60.19,0,0,0-5.35,10.3m-141.15,0a2.41,2.41,0,0,1,0-.38,6.59,6.59,0,0,1,2-3.72c6.87-9.79,31.61-31.48,31.61-31.48s.54-2.55,1.63-2.89,4.53-1.85,4.61-1.88h0l-1.72,4.38s.71,2.75,7.77,4.12c5,1,21.83,2.43,35.13,2.43a78.91,78.91,0,0,0,13.47-.86c11.08-2.2,16.92-8.16,16.92-8.16h0a9.72,9.72,0,0,1,3.13-.73,1.73,1.73,0,0,1,1.64.73c.91,1.61,0,4.65,0,4.65l.84.79-.92-.77h0c-1.75.62-30,10.55-42.75,11h-1.66c-13.3,0-33.63-5.71-35-7.58s-1.48-8.16-1.48-8.16c-1.09.34-1.63,2.89-1.63,2.89S248,480.9,241.16,490.69a6.59,6.59,0,0,0-2,3.72,2.41,2.41,0,0,0,0,.38m155.27-6.58a37.82,37.82,0,0,0-2.94-9.06h0s-13.26-1.51-17.58-3.87c6.46,2.61,17.58,3.87,17.58,3.87a37.82,37.82,0,0,1,2.94,9.06h0"
                  transform="translate(2.38)"
                />
                <g class="cls3-74">
                  <rect
                    class="cls3-30"
                    x="240.56"
                    y="455.05"
                    width="155.92"
                    height="273.97"
                  />
                  <g class="cls3-75">
                    <image
                      class="cls3-33"
                      width="233"
                      height="370"
                      transform="matrix(0.68, 0, 0, -0.75, 240.56, 728.55)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOkAAAGTCAYAAADN+TXwAAAACXBIWXMAABAlAAAQJQEuD214AAAFLElEQVR4Xu3csU0rQBBF0R00XVAakRugF3qgNPpYUhLk0Dc4J/sS6dXzZwfP5/v3PUDG18/H338+3v77QaBBpBAnUogTKcSJFOJECnEihbidZz8BvJQlhTiRQpxIIW6P/5RCmiWFOJFCnCcYiLOkECdSiBMpxIkU4kQKcSKFOJFCnEghbsfxLqQ5sIc4H3chTqQQJ1KIEynEiRTiRApxIoU4kUKcr0+BOEsKcSKFOJFCnAN7iLOkECdSiPMEA3GWFOJECnEihTiRQpxIIU6kECdSiHMWCHGWFOJcHEGcJYU4kUKcSCFOpBAnUogTKcSJFOK8k0KcJYU4kUKcA3uIs6QQJ1KIEynEiRTiRApxIoU4F0cQZ0khTqQQJ1KIEynEiRTiHNhDnCWFOO+kEGdJIU6kECdSiBMpxO3xBgNplhTiRApx3kkhzlkgxPm4C3EihTiRQpxIIU6kECdSiBMpxIkU4lwcQZwlhTiRQpxIIc6BPcRZUogTKcR5goE4SwpxIoU4kUKcSCFOpBAnUogTKcSJFOJECnE7To4gzZJCnEghTqQQJ1KIEynEiRTiRApxvpkB4iwpxIkU4kQKcSKFON9gD3GWFOJECnEihTjHDBBnSSFOpBAnUogTKcSJFOJECnHOAiHOkkKcYwaIs6QQJ1KI2+M3R5BmSSFOpBAnUogTKcR5J4U4SwpxIoU4B/YQZ0khTqQQJ1KIEynEiRTiRApxLo4gzpJCnEghTqQQJ1KIEynEObCHOE8wEOfjLsSJFOJECnEihTiRQpxIIU6kECdSiHPMAHGWFOLc7kKcJYU4kUKcSCFOpBAnUogTKcQ5ZoA4SwpxIoU4kUKcs0CIs6QQJ1KIEynEeSeFOEsKcSKFOJFCnEghTqQQJ1KIEynEiRTidsY5A5RZUogTKcSJFOJECnEihTh/qgZxlhTiRApxIoU4kUKcSCHOl2NDnCWFOJFCnEghzsURxFlSiBMpxIkU4kQKcSKFOJFCnLNAiPNOCnE+7kKcSCFOpBAnUogTKcSJFOJECnEihTiRQpyLI4izpBDnwB7iLCnEiRTiRApxIoU4kUKcd1KIs6QQJ1KIEynEiRTiRApxIoU4B/YQZ0khTqQQ5+II4iwpxIkU4kQKcSKFuD0eSiHNkkKcSCHOOynEud2FOB93IU6kECdSiBMpxIkU4jzBQJwlhTiRQpxIIU6kECdSiHO7C3GWFOJECnEihTgXRxBnSSFOpBAnUogTKcSJFOJECnEihTiRQtyOawZIs6QQJ1KIEynEiRTiRApxIoU4kUKcSCHONzNAnCWFOJFCnC/HhjhLCnEihTiRQpxIIc47KcRZUogTKcSJFOJECnEihTiRQpxIIc6BPcRZUohzcQRxlhTiRApxe/zmCNIsKcSJFOJECnEihTjvpBBnSSHO7S7EWVKIEynEiRTiRApxnmAgzpJCnEghTqQQJ1KIEynEiRTi3O5CnCWFOJFCnIsjiLOkECdSiBMpxIkU4kQKcSKFOJFCnEghzjEDxDmwhzgfdyFOpBAnUogTKcSJFOJECnEihTiRQpyLI4izpBAnUohzuwtxlhTiRApxIoU4TzAQZ0khTqQQJ1KIEynEiRTiRApxIoU4t7sQZ0khbseUQpolhTiRQpxIIU6kECdSiBMpxIkU4nwzA8RZUogTKcQ5sIc4SwpxIoU4kUKcSCHOOynEWVKIEynEiRTiRApxIoU4kUKcSCHOgT3EOWaAOB93IU6kECdSiJt77332Q8DLPPYcv9+Fsl9J4AzVBzha8wAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M282.14,705c-1.75-4.78-3.94-10.81-6.34-17.55h0c2.4,6.71,4.59,12.75,6.34,17.55"
                  transform="translate(2.38)"
                />
                <g class="cls3-76">
                  <rect
                    class="cls3-30"
                    x="279.18"
                    y="687.22"
                    width="5.72"
                    height="17.02"
                  />
                  <g class="cls3-77">
                    <image
                      class="cls3-33"
                      width="16"
                      height="27"
                      transform="matrix(0.68, 0, 0, -0.75, 276.32, 707.28)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAeCAYAAAAl+Z4RAAAACXBIWXMAABAlAAAQJQEuD214AAAAWUlEQVQ4T2P8////fwYKABMhBYQAC4yxqvQ0PnVwENZtisKHG8DAiK6UOIAwgEwTKA6DUQOoEI0Uu2DUAJRYIC8aKHbBqAFIscA4GgtkA4oNoDgWGCmsWxkAZa4KTZbLS58AAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M275.8,687.45h0c-8.71-24.4-20.15-57.73-22.87-72.39,2.74,14.69,14.16,48,22.87,72.39"
                  transform="translate(2.38)"
                />
                <g class="cls3-78">
                  <image
                    class="cls3-33"
                    width="72"
                    height="190"
                    transform="translate(254.87 616.98) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAADJCAYAAACAAXQ6AAAACXBIWXMAAB/VAAAf1QHSNaIIAAAB6klEQVR4Xu3bQRECMRAAwYWKG3whAB8IQA4e8BMEUJURQPeb19QGcjlyed4/e/jxeN0uMzNLnbM1I9HJtT7w7wQKAgWBgkBBoCBQECgIFNZsO+kTExQECp7mgwkKAgWBgkBBoODINZigIFAQKAgUlu/oMxMUBAoCBYGCQEGg4Gc+mKAgUHBoH0xQECh49Rx8BwVLLAgUBAoCBYGCQEGgYKMYTFAQKAgUBAoCBYGCQEGgsOwTz0xQECgIFAQKAgWBgkBBoOAyS7CTDpZYECgIFAQKAgWBgkBBoCBQECj4l2tw2ydYYkGg4DwomKAgUBAoCBQECgIFgYJAQaAgUBAoOO4IDsyCJRYECgIFgYJAwaXeYIKCQEGgYCcdTFAQKAgUBAo2isEEBYGCQEGgIFBwoS6YoCBQECgIFAQKAgWBgkDB31+CCQoCBbd9ggkKAgVvVoMJCgIFgYJAwZvVYIKCQEGgIFAQKAgUPIsFExQECgIFgYJAQaAgUPBmNZigIFBY2xo7MkFBoCBQECgIFAQKAgWPGsFf8IIlFgQKAgWBgheHwc98sMSCQMFGMZigIFAQKAgUBAoCBTvpYIKCh9VggoJAQaAgUBAoCBQECgIFgYJr4cEEBYGCQEGgIFBwHhRMUBAorNn7XR/6Z1+SKDpsAH+zSgAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M252.93,614.83v-.06c-1.75-9.71-4.41-30.77-6.93-52.59h0c2.52,21.82,5.18,42.88,6.93,52.59v.06"
                  transform="translate(2.38)"
                />
                <g class="cls3-79">
                  <image
                    class="cls3-33"
                    width="23"
                    height="133"
                    transform="translate(247.72 564.27) scale(0.36 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAACJCAYAAADHRqOTAAAACXBIWXMAAB6aAAAemgH8byj4AAAA2ElEQVRoQ+2YwQnDQAwElaAGUm1qSXXpJJcGBgwJ81jYeR/DIkuyz7fX831G4n514B9y5Ttaxe3kYvDZEeuilkWV53ZL5UjliCrf0yECcuV9WSCVI6o8d7d0iJBcee63Ym4rqnciN7lYcjd55UjlSK5c3S0dfyRX3geKVI7sEdulrYhUjqjyHfF+7ib3csvJK0e6FZHKEVWu/m/p4kJUuVrz3MWl9rmavHIktxUrR1R5xx/pECH7EeviJheDu8krR7q4kPY5UjlSOaJeFd3kseO/M/O4OvQrX/ojKy+nWdQsAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M245.91,561.92a143.21,143.21,0,0,1-2-15.76c.58,5,1.26,10.28,2,15.76"
                  transform="translate(2.38)"
                />
                <g class="cls3-80">
                  <image
                    class="cls3-33"
                    width="9"
                    height="37"
                    transform="translate(246.28 546.36) scale(0.39 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAlCAYAAACQ/8NdAAAACXBIWXMAABwkAAAcJAEy8hyMAAAAVElEQVQ4T92TwQ3AMBDCaMQinbOrZLoskoyAHyiP8rYsxOme+a2tkJEA6TpkxdrQ1IMMKjETgiywATJdhnq38wYqZPo3VF08B5kQVCxe+xZLehN0AMwgDW2bBAMOAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M245.91,562h0c-.77-5.48-1.45-10.76-2-15.76q-.26-3.13-.44-6.39c.77,7.2,1.62,14.72,2.47,22.17"
                  transform="translate(2.38)"
                />
                <g class="cls3-81">
                  <image
                    class="cls3-33"
                    width="10"
                    height="53"
                    transform="translate(244.85 540.55) scale(0.38 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAA2CAYAAAD+ighrAAAACXBIWXMAABzpAAAc6QHh0LjlAAAAZklEQVRIS+WVwQ2AQAgE5wxF+7UKG7QPfPm+MSG5iLwnuwE2MM79SkRtM+ApDQbK+IWiBgPprRVbgfXjqd91SEEPauuFYP0cF4JBum604j/BSJmKVulpBX7hSOmvEMAxgwBGygNwA8DTFOcYC5VjAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M340.15,734.31c-31,0-57.49-1.95-59.23-5.08a2.47,2.47,0,0,1-.28-1.23c0-3.61,5-10.45,5.58-11.28-.34.68-2.41,4.89-1.76,7,.6,1.89,30.71,5.33,53.69,5.33a140.35,140.35,0,0,0,14.62-.65s-39.85-4.18-62.08-13.48a15.32,15.32,0,0,1-8.35-9l-.2-.53h0c-1.75-4.78-3.94-10.81-6.34-17.55-8.71-24.41-20.15-57.75-22.87-72.39h0v-.11h0v-.16h0v-.07c-1.75-9.7-4.41-30.71-6.93-52.59h0c4.08,20.54,16.5,60.32,22.28,76.1s19,65.18,24.07,69.1c2.68,2.1,21.73,5.62,40.57,5.62,16.75,0,33.33-2.77,38.09-11.8,10.12-19.16,7.86-85.66,7.86-85.66s-10.85-25.79-13-47.5c-1.55-15.47,5.54-51.9,14.45-73h0v-.05a60.19,60.19,0,0,1,5.35-10.3c1.68-2.4,3.67-4.51,5.83-5.38h0a37.89,37.89,0,0,1,2.94,9.05s-10.16,3.65-12,7.19c-1.54,3-11.72,44.78-11.72,72.58a71.87,71.87,0,0,0,1,13,88.09,88.09,0,0,0,13.57,32.08l1-6.58,5.51,7.33a219.09,219.09,0,0,0-3.24,25.83c-.08,1.1-.12,2.42-.12,3.93,0,19.13,5.94,67.12,5.94,67.12,2,2.09,2.44,5.67,2.44,8.49a28.49,28.49,0,0,1-.31,4.13,162.21,162.21,0,0,1-56.41,10.48M243.45,539.8c-2.46-22.59-4.34-41.93-4.34-45a2.54,2.54,0,0,1,0-.39,6.66,6.66,0,0,1,2-3.72c6.87-9.78,31.61-31.48,31.61-31.48s.54-2.54,1.63-2.88c0,0,.07,6.21,1.48,8.16s21.69,7.55,35,7.55h1.66c12.77-.5,41-10.42,42.75-11.05h0s-14.18,6.81-16.57,7.91h0a107.91,107.91,0,0,1-11.2,4.65c-5.1,1.4-28.09,5.65-41,5.65-.83,0-1.61,0-2.34-.06h-.9c-12.73,0-40.12,11.63-40.12,11.63s-1,26,.35,49.09"
                  transform="translate(2.38)"
                />
                <g class="cls3-82">
                  <image
                    class="cls3-33"
                    width="463"
                    height="746"
                    transform="translate(240.56 456.09) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,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"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M373.85,475.28c-.49-.2-1-.4-1.39-.62-5.08-2.52-13.64-10.36-16.32-12.88,3.23,2.65,14.1,11.49,17.69,13.49h0"
                  transform="translate(2.38)"
                />
                <g class="cls3-83">
                  <rect
                    class="cls3-30"
                    x="359.29"
                    y="461.24"
                    width="17.16"
                    height="13.93"
                  />
                  <g class="cls3-84">
                    <image
                      class="cls3-33"
                      width="33"
                      height="22"
                      transform="matrix(0.66, 0, 0, -0.72, 356.43, 477.34)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAYCAYAAAB0kZQKAAAACXBIWXMAABCbAAAQmwF0iZxLAAAANElEQVRIS+3OIQIAMAyDwKb//3Om0HOb4TSCtO38lb0VLzgBJ+AEnIATcAJOwAk4ASfgBA7qxAQtiR8L6AAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M380.23,494.84c-11-3.23-41.43-25.88-41.55-26,7.42-3.4,15.61-7.42,16.54-7.9h0l.92.77c2.68,2.52,11.24,10.37,16.32,12.89.44.22.9.42,1.39.61,4.32,2.36,17.58,3.87,17.58,3.87-1.93.62-3.89,2.52-5.83,5.39a51.33,51.33,0,0,0-5.35,10.3h0"
                  transform="translate(2.38)"
                />
                <g class="cls3-85">
                  <image
                    class="cls3-33"
                    width="158"
                    height="94"
                    transform="translate(340.69 459.8) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,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"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M379.8,495.29h.43m5.37-10.8c1.94-2.87,3.9-4.77,5.83-5.39h0c-2.16.87-4.15,3-5.83,5.39m-46.92-15.61h0c2.39-1.09,16.55-7.89,16.55-7.89-.93.47-9.12,4.49-16.54,7.89"
                  transform="translate(2.38)"
                />
                <g class="cls3-86">
                  <image
                    class="cls3-33"
                    width="158"
                    height="94"
                    transform="translate(340.69 459.8) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,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"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M464.79,505.15l-44.21-5.28,21.05-105.19h1.48c2.53,0,8.06,0,14.72.25,10.34.32,23.43,1.09,32.4,2.88h0s-3.69,16.68-8.28,36.92a11.56,11.56,0,0,0-2.12,2.72c3.71-17.18,6.64-31.52,6.64-32.91,0-1.68-24.17-3.19-36.89-3.19-4.24,0-7.2.17-7.56.55-.95,1-3.39,11.25-6.22,24.57l-.45-.43-6.48,32.4.43.4c-3.61,18.78-6.48,35.18-6.24,36.14.44,1.86,27.62,5.38,38.06,5.38,2.16,0,3.61-.15,3.95-.5s1-2.72,2-6.58l.89.8,3.24-13.41c-.06.33-.12.67-.17,1-2.91,12.07-5.27,21.18-6.24,23.45M454.32,398l.22.83,18.3,1.18.83-1c-7.31-.83-19.35-1.05-19.35-1.05m17.64,80L475.09,465c-1,4.19-1.95,8.27-2.86,12.13-.1.26-.19.54-.27.82m3.13-13-1-1c1.06-4.72,2.15-9.61,3.21-14.45a29.74,29.74,0,0,0,.48,3.89c-.9,3.88-1.79,7.75-2.68,11.55"
                  transform="translate(2.38)"
                />
                <g class="cls3-87">
                  <rect
                    class="cls3-30"
                    x="422.22"
                    y="394.68"
                    width="70.09"
                    height="109.9"
                  />
                  <g class="cls3-88">
                    <image
                      class="cls3-33"
                      width="110"
                      height="154"
                      transform="matrix(0.67, 0, 0, -0.73, 420.79, 506.14)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAG8AAACpCAYAAAAldGPJAAAACXBIWXMAABCbAAAQmwF0iZxLAAACLElEQVR4Xu3dy20qURBFUbdFYEgOxHEQgeMgECRnVh71Z+JmCFtaa4T0mB2dW3W70fMyM/NBybJ++Dz7Fu/tsn74+bqffY8XuT2+//03zQsTXth2bM4+B4nQvDDhhW3HplOzR/PChBdm2wzTvDDhhQkv7DDzqDnc8ywsNY7NMOGFCS9MeGGesIRpXpjwwrzPC/OEJWxvnurlmHlhwgsz88I0L0x4Yd7nhWlemIUlTPPCPGEJ07ww4YVZWMK8zwtzbIbZNsM0L8zCEqZ5YcILs7CEueeFWVjCzLwwMy9M88KEF2ZhCdO8MPe8MNtmmGMzzMISpnlhwguzsISZeWHueWFmXpjwwiwsYRaWMMdmmPDChBe2zzz/D0uO5oUJL0x4YcILE16YP4oRpnlhwgvzMjbMzAtzbIYJL0x4YcILs7CEuSqEOTbDhBcmvDC/2wzzi+kwx2aY8MKEF+ZHt2GaFya8MOGFCS/ME5YwT1jCHJthXsaGmXlhjs0wC0uY5oUJL8zCEqZ5YRaWMJf0MMdmmIUlTPPCLCxhmhdm5oW5KoQ5NsMsLGGaFya8MNtmmOaFWVjC3PPCzLwwMy9MeGEWljDNC7OwhGlemPDCXNLDbJthFpYwMy9MeGFmXpiZF+bYDHPPC9O8MOGF2TbDbJthjs0w4YUJL8wfxQjTvDDhhQkv7HDPM/NqNC9MeGHCC/M+L0zzwmybYZoXtszM77Mv8Vau64dlxmvYKsdm2B/RtjHnX3cfxgAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M461.12,500.69c-10.44,0-37.62-3.53-38.06-5.39-.24-.95,2.63-17.36,6.24-36.13l3.3,3c-.8,4.05-1.65,8.34-2.35,12.07a2.12,2.12,0,0,0,.33,1.61,1.79,1.79,0,0,0,1.35.8l13.74,1.1h.13a1.89,1.89,0,0,0,1.82-1.61v-.23l15.89,14.48C462,490,453,489,444.37,488.21c-4.89-.48-15.58-1.53-18.13-1.53a1.57,1.57,0,0,0-.53,0c-.54.39-1.31,4.49-1.15,6.09,0,.46.17.74.37.81,1.7.72,34.24,4.25,36.56,4.49l1.34,2.12.1-.39c.35-1.27,1.87-7,1.15-8.85l2.9,2.65c-1,3.87-1.71,6.27-2,6.59s-1.79.5-4,.5m13-36.75-3.28-3.18,1.45-7.62a2,2,0,0,0-1.47-2.38l-.1,0a75.29,75.29,0,0,0-10.92-.7l-11.08-10.77,4.18.33h.13A1.9,1.9,0,0,0,454.7,438l4.83-25.23a2,2,0,0,0-1.47-2.38l-.1,0a75.66,75.66,0,0,0-11.45-.72h-2.46a1.94,1.94,0,0,0-1.8,1.58c-.71,3.54-2.24,11.15-3.66,18.36l-2.87-2.78c2.83-13.33,5.27-23.54,6.22-24.57.36-.38,3.31-.55,7.56-.55,12.7,0,36.89,1.5,36.89,3.19,0,1.36-2.93,15.72-6.64,32.91A21.18,21.18,0,0,0,477.17,449v.48c-1.06,4.84-2.15,9.73-3.21,14.45m-12.35-48-.47,2.62,17.25,2.19.65-2.57L461.61,416m2.17-4.38h-1.47l-.55,2.66a161.31,161.31,0,0,1,20.31,2.13l.4-2.61a108.09,108.09,0,0,0-18.69-2.2"
                  transform="translate(2.38)"
                />
                <g class="cls3-89">
                  <rect
                    class="cls3-30"
                    x="425.08"
                    y="402.43"
                    width="62.94"
                    height="99.06"
                  />
                  <g class="cls3-90">
                    <image
                      class="cls3-33"
                      width="101"
                      height="138"
                      transform="matrix(0.67, 0, 0, -0.73, 423.65, 502.89)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAACXCAYAAADnES7eAAAACXBIWXMAABB0AAAQdAFKfdo/AAAB20lEQVR4Xu3YsQ3CQBBE0TVyM1RBjzRsIuQE4wj8g/cihJyt5mbvlm3btqFkmZm5nX3FNQwmymCiDCZqff+wAlxjWT7/LzFRBhO1H2XfvuJnDk6yfTAmc5GDyUhMlI6Jsi5HSUyUjomylUVJTJSOiTKYKEdZlPKPkpgoHRPlSSZKYqJ0TJStLEpionRMlMFEGUyUe0yUxETZyqLcY6IkJkrHRNnKoiQmSsdESUyUjomSmCiDiVL+UZ5koiQmSsdEWZejJCZKx0TZyqIcZVEGE6VjoiQmyj0mSmKidEyUe0yUxETpmChbWZTERBlMlMFE6ZgoiYlyj4mSmCgdEyUxUTomyutylMRE6ZgoW1mUxEQZTJTyj7IuR0lMlI6Jsi5HSUyUjomSmCgdEyUxUQYTZTBROiZKYqLcY6K8LkdJTJSOibKVRUlMlI6Jkpgog4lyj4nSMVGOsij3mCiJidIxUbayKImJ0jFRtrIoiYkymCjlHyUxUco/SmKidEyUJ5koiYnSMVG2siiJidIxURITZTBR7jFROibKURblHhMlMVE6JspWFiUxUTomymCirMtREhOl/KMkJkrHRElMlI6J8iQTJTFROibKVhYlMVEGE7XOzHNm5nE/+ZK/egEBeG5j2/IezgAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M481.87,513h0A27.1,27.1,0,0,1,471,493.75h0a46.8,46.8,0,0,1,0-12.4c.05-.35.11-.69.17-1l.75-3.11c.08-.29.17-.56.27-.82a19.07,19.07,0,0,1,2.06-4.29c.55-.87,1.92-2.33,3.29-4,1.67-2.06,3.33-4.45,3.48-6.5a21,21,0,0,1-1.27-2.45,30.3,30.3,0,0,1-2-6.44,29.44,29.44,0,0,1-.48-3.87v-.48a21.27,21.27,0,0,1,2.55-11.27,11.51,11.51,0,0,1,2.12-2.71,5.49,5.49,0,0,1,1.41-1,7.46,7.46,0,0,1,2.76-.78h.36a4,4,0,0,1,1.6.28h0s-2.2,15.36-.81,24.89h0c.93,6.43,3.81,17.55,5.51,24.6.51,1.94.93,3.91,1.25,5.89a2.81,2.81,0,0,1,0,.41h0c-.13.73-3.18,6.82-6.19,12.71s-6,11.64-6,11.64"
                  transform="translate(2.38)"
                />
                <g class="cls3-91">
                  <rect
                    class="cls3-30"
                    x="472.29"
                    y="433.38"
                    width="24.31"
                    height="80.48"
                  />
                  <g class="cls3-92">
                    <image
                      class="cls3-33"
                      width="42"
                      height="114"
                      transform="matrix(0.65, 0, 0, -0.71, 470.86, 514.13)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAB9CAYAAADUSPEUAAAACXBIWXMAABESAAAREgEAwpvaAAABG0lEQVR4Xu2ZyQkCQRQFe8S0BKMwSKMQDKw9CC4X51JgF1SdRujDo/5/s+A255xjbbYxxjjsnVqF4+vqfv1x7A+cLl8/NUYLSqMJ+i7T4jcpodHFlTZ6mozSfBhdW6nGqCZoZaLRBK31NJqgtZ5GY7QXZxrNjhaURrOjtZ6mHaURGl1caaOnyShNRmk0tyeh0bWFZhSnMtFoRp9RmspEoxm9xqgmaKOn6Q8xmnaURhO0MtFogtZ6Gk3QWk9TmWgyStN3PU07SpNRmp71NJqglYmmMtEUlKbW02iMat7wNUY1O6oJqhl9ZaLR7KgmaKOnqfU0wtFnlEFjVNP6Rk+jMaoJqhl9rafRjH6bc972Dv2Z8xjPoDvn1kCzow+dZU8kw0r7hwAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M309,695.92s19.52-9.77,31.63-18,27.63-28.15,27.63-28.15-7.58,24.54-17.58,33.54S309,695.92,309,695.92"
                  transform="translate(2.38)"
                />
                <g class="cls3-93">
                  <image
                    class="cls3-33"
                    width="176"
                    height="128"
                    transform="translate(310.65 648.66) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAACMCAYAAADcDyOIAAAACXBIWXMAACBLAAAgSwFrhwW5AAAB90lEQVR4Xu3dQY3DUBBEwXE0NAJsKYTPUlgeoRIg8ULw1U+qOvvYGvWf7zjH6/l3DgT9fn6Ox9VDcGcCTNrOaBB0mcCkrflLmQlM2qrAlJnApO1pBBNmApMmwKS5yCBtT/klTIUgTYBJ04FJswcmTYUgTYBJE2DSdGDSTGDSvA9MmglMmosM0kxg0gSYNGs00mwhSFMhSBNg0nxaijSHONJUCNLcxJFmApMmwKQJMGk7Ps1DmD0waSoEadZopJnApOnApJnApAkwab7QTpotBGneByZNByZNgEkTYNJ8F4I0E5g0WwjSTGDSXGSQZgKT5nVK0lQI0lQI0gSYNAEmzVUyaQ5xpAkwafu9egJuzCGONAEmTYBJc4gjzR6YNG+jkbYzFml0OcSRJsCkCTBp1mik+T4waSoEaQJMmg5MmglMmqtk0gSYNBWCtB2LYMJsIUhTIUgTYNJUCNKs0UhTIUgTYNJUCNIc4khTIUgTYNL8VzJpftRJmgpBmgCTJsCk2QOTZgKTZgKTZgKT5j8ySDOBSfM6JWkOcaSpEKR5mYc0FYI0FYI0ASZNhSDNBCbNRQZpKgRp9sCk6cCkqRCkmcCkCTBp1mik6cCkqRCkCTBpAkyaDkyaCUyaAJNmD0ya/8ggzbfRSLOFIG1n5n31ENzVcfpJBmH/c6deBVUkupEAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M454.75,575h0a33.53,33.53,0,0,1-4-5.25c-1.69-2.75-3.73-6.47-5.88-10.63,5.37,9.14,9.94,15.89,9.94,15.89"
                  transform="translate(2.38)"
                />
                <g class="cls3-94">
                  <rect
                    class="cls3-30"
                    x="446.54"
                    y="558.75"
                    width="10.01"
                    height="15.48"
                  />
                  <g class="cls3-95">
                    <image
                      class="cls3-33"
                      width="20"
                      height="26"
                      transform="matrix(0.68, 0, 0, -0.75, 445.11, 576.52)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAdCAYAAACqhkzFAAAACXBIWXMAABAlAAAQJQEuD214AAAAN0lEQVRIS+3MsQ0AMAzDMKfI/y+7JwSBOnQwZ0Fl23roTMFWhlyGXIZchlyGXIbc/8OWVFO0cQGbtgQ5dzMJMgAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M454.74,575c-.8-.37-46.33-21-57.93-30.71-8.89-7.46-6.54-25.95-4.9-34.39a22.67,22.67,0,0,1,8.44-10.71c4-2.55,13.21-4.68,13.21-4.68h0s13.23,28.66,21.15,45.67c3,6.58,6.73,13.24,10.07,19,2.15,4.17,4.19,7.88,5.88,10.64a33.45,33.45,0,0,0,4,5.24"
                  transform="translate(2.38)"
                />
                <g class="cls3-96">
                  <image
                    class="cls3-33"
                    width="199"
                    height="220"
                    transform="translate(389.32 493.95) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMcAAADwCAYAAAC0enDTAAAACXBIWXMAACBzAAAgcwGUMTyCAAAC2UlEQVR4Xu3cwW2DQBRF0SH66SEFpP8eXIcLcA9ZBK8tzRUFcM7a26sHeOB4Pf/OBXz4+f0+vq5+BHclDgjigCAOCLOW+3HYsRwQxAFBHBDEAUEcEMQBYTzJhT3LAWEMB+xZDgjigCAOCOKAIA4I4oDgUS4EywFBHBDEAUEcEJzKhWA5IIgDgssqCJYDgjggiAOCOCCIA4I4IIgDgjggiAOCOCA4PgLBO+QQXFZBEAcEcUAQBwRxQBAHBHFAEAcEcUBwfASC5YAgDggOHkKwHBDEAUEcEMQBQRwQ/AkIwXJAEAcEcUAQBwRxQBAHBHFAEAcEcUDwPgcEywFBHBAcPIQgDgguqyCIA4I4IIgDgjggiAOCOCCIA4I4IIgDgiPrEJytguCyCoI4IIgDgjggiAOCOCCIA4I4IMzpT0DYshwQxAFBHBDEAWGWY7mwZTkgiAOCOCCIA4LXZCFYDgjigCAOCL5bBcFyQBAHBHFAcM8BwXJAEAeEWf9XP4F7shwQxAFBHBDEAUEcEMQBQRwQxAFBHBDEAUEcEMQBQRwQfNQNguWAIA4I3iGHYDkgiAOCp1UQLAcEcUAQBwRxQHBDDsFyQBAHBHFAEAcEBw8hWA4I4oAgDgjigCAOCOKAIA4I/ueA4FQuBJdVEMQBwWUVBMsBQRwQxAFBHBDEAUEcEMQBQRwQxAFBHBDEAUEcELzsBMGpXAguqyCIA4I4IIgDgjggiAOCR7kQLAcEcUAQB4Q53XPAluWAIA4I4oAgDgjigCAOCOKAIA4IPrAAwXJAEAcEcUAQBwRvAkKwHBDEAUEcEGZ5FRC2LAcEcUAQBwRxQBAHBHFA8D4HBMsBQRwQnMqFYDkgiAOCp1UQLAcEcUAQBwRxQBAHBHFAEAcEx0cg+PoIBJdVEMQBQRwQxAFBHBDEAUEcEMQBQRwQxh/ksGc5IPjAAgTLAWHWWo+rH8EdHac7cthyWQXhDZwoOsLMBq1qAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M467.17,546.92l-1.84-9.74h0s.61,2.25,1.84,9.74h0"
                  transform="translate(2.38)"
                />
                <g class="cls3-97">
                  <rect
                    class="cls3-30"
                    x="468"
                    y="537.08"
                    width="1.43"
                    height="9.29"
                  />
                  <g class="cls3-98">
                    <image
                      class="cls3-33"
                      width="8"
                      height="17"
                      transform="matrix(0.68, 0, 0, -0.75, 466.57, 548.17)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAATCAYAAACtHkzTAAAACXBIWXMAABAlAAAQJQEuD214AAAAQUlEQVQoU2P8////fwY8gAmfJAMDAwMLjHH3PAMDw///DP8Z/jP8//ePQdUEIkXQhFEFQ0gBI6EEw8LAwMCITwEACgERIsXGlbIAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M467.17,546.92c-1.23-7.49-1.84-9.74-1.84-9.74s8.95-11.31,19.39-11.81a36.14,36.14,0,0,0-17.55,21.55"
                  transform="translate(2.38)"
                />
                <g class="cls3-99">
                  <image
                    class="cls3-33"
                    width="59"
                    height="61"
                    transform="translate(466.57 524.7) scale(0.35 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAABDCAYAAAAiVH0fAAAACXBIWXMAAB9fAAAfXwGscuV3AAABRklEQVRoQ+2bOW7DMBREx4HufwUfw3UOlXpScMEXzc1wN5wHGBL/QvmBYhEifryef0SGJID8IUAQINM1FdRcyjKFwNSb71E6yNrDMG+cszwj9qLMyzwv8B5HiLfPyd/91kviBwdhWVWu+lojbJt8rbdx24RihtysJs6Ftr7k47jkQ3+sjfc1zxpK107sqJW1rCqWVcWyqlhWFcuqYllVLKuKZVU5SvYanXj0aPPh5GNa04uv8rvj2Xdua45a2aNkr9to9F7uxD6pnfX3Yrvv8GKvHLWyllXFsqpYVhXLqmJZVSyrimVV2TqW2fnzcadmNv7m2aNx23vUylpWlett4+2cF61iq8286h/FPpm/EztqZS2rimVVsawqllXFsqpYVhXLqmJZVW6ni4XRyd2sdlYzy++Ov50XSP8a9NuJS/Jg+/NGYf4Bmk3fwolSb+gAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M472.83,400l-18.3-1.18-.22-.83s12,.22,19.35,1.1l-.83,1"
                  transform="translate(2.38)"
                />
                <g class="cls3-100">
                  <image
                    class="cls3-33"
                    width="59"
                    height="10"
                    transform="translate(458.64 397.78) scale(0.28 0.35)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAAANCAYAAAAXBhYDAAAACXBIWXMAACdeAAAnXgHPwViOAAAAqElEQVRIS+2Wuw3EMAxD+YyscovcijewUkSyZCMJrjbMwoBJ6teR7+dnkiTiQSAJRP/jknPg9klXS754AF1o3QvNx+J+Db3QpWd97qWyAz6rciL3yNnoUMA6d/+vXPD24g9trgk8zat40ua+f2rtnl4T+9hVsY9dFfvYVbGPXRVHxA2G6IGQdQ7n0puuub6GpOwTqPUXP/pr7zEGvXtn3m41zJ5y13o4AZeDHYReNW5hAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M462.21,518.35s6.1-6.38,6.79-7.12,2-16.78,2-16.78l-4.67,17.7L450,509.79s3.73,5.75,12.26,8.56Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-101">
                  <rect
                    class="cls3-30"
                    x="452.27"
                    y="495.29"
                    width="21.45"
                    height="23.22"
                  />
                  <g class="cls3-102">
                    <image
                      class="cls3-33"
                      width="37"
                      height="36"
                      transform="matrix(0.66, 0, 0, -0.72, 450.83, 520.14)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAnCAYAAACIVoEIAAAACXBIWXMAABCbAAAQmwF0iZxLAAAAjElEQVRYR+2YsQ6AMAhErfrdxvjh4tYwKDLBG+5NDDeQ6xWaDjOzhcVY/xQd7LO6zm9VBcc5S7ZTd3OyvDuzKVLedXwRm6vd8b0om3BOcbqCO9UdKgfcqUhVDNwpZSpGcyqLFnIW5HuK7lQkq0UjIQs9U5yu6E5Fslp0+7JoIWfRSMiCDDpyJAzi7/ADsPpSMju/dS4AAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M485.06,425.25l3.67-15.09h.58a39.55,39.55,0,0,1-3.66,15.41l-.59-.32Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-103">
                  <rect
                    class="cls3-30"
                    x="488.02"
                    y="410.16"
                    width="4.29"
                    height="15.48"
                  />
                  <g class="cls3-104">
                    <image
                      class="cls3-33"
                      width="12"
                      height="25"
                      transform="matrix(0.68, 0, 0, -0.75, 485.16, 427.19)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAcCAYAAABVo158AAAACXBIWXMAABAlAAAQJQEuD214AAAAdElEQVQ4T2P8////fwYSABMhBeiABcZod16IU1Hl3ng4m3wb/jESpxdJAyM+dXBAnLFIAG7Df9KdRLIG4vxAiZMGnQ0kh9J/mttAsh+IDSXiVCEB8p1EsqdJD1YivYOwgYlEDf8YiHMSI6klHwsDA5FGQwEA42ofbbaCMqEAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M380.38,339.38s2.09-21.42,0-33.58-8.65-25.46-8.65-25.46,13.41,5.49,16.3,11.12-1.44,24.78-2.16,31.36-5.49,16.52-5.49,16.52"
                  transform="translate(2.38)"
                />
                <g class="cls3-105">
                  <image
                    class="cls3-33"
                    width="59"
                    height="155"
                    transform="translate(373.59 281.45) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAACkCAYAAAApFVYlAAAACXBIWXMAAB9fAAAfXwGscuV3AAABc0lEQVR4Xu2cyxFCMQzEDOMK6YTeaIDGCCXkLknnXHbWWTt5n8f79TkjYTVKZ2ZnPHJXpHWetwUk9oisVTmbWCqJpbJzSmMkiaWimqA6CFBJLBXVtYzLWVMa78zvtgZDZUxF5Wxiqaj27Hoaj66MRXWsclYlVpXGMmdF1nZTQUUVUKonAqoyTiyVAoqKqowTSyWxVFb0XGv2iNS6ytgzUticFU2Lrgs3VRknlooqoFzOioyVOVufhaLas7UeKgUUFZWzpTGV9iyVyphKaUxF5qzIWlVAqcSqAkrlrEpsaUzFNVScfn7FJLFUaj1Umo2puIaKAgpKYqmoWs+KDj2lMRbZUCHatKoyVoktjakklopsNr6tANFPOagklooqjVXOqsSqDgKuoaKbCigqsb0aREUltnGRSod3KomlohJb66GiEqvqs6qbClcZi6pYdrtoEqvasyqxqoByOSsyVuZsrQeK6hsBl7OiLVtAYdmZ+d4WUfgDtj9iuTSQgZsAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M295.66,585.93c-16.45-3.52-35.05-19.95-39.93-26.4S243.81,532,243.81,532a82.76,82.76,0,0,0,7.17,13.8c2.32,3.88,6.43,11.26,18.72,21.61a198.36,198.36,0,0,0,26,18.55h0"
                  transform="translate(2.38)"
                />
                <g class="cls3-106">
                  <image
                    class="cls3-33"
                    width="155"
                    height="149"
                    transform="translate(246.28 531.07) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAACiCAYAAABWFL/pAAAACXBIWXMAACBLAAAgSwFrhwW5AAACHUlEQVR4Xu3dsQ3CQBBE0TPaYqiIZoiQaIaKKOcowYn50Xsx4WjWe2eL43n/7AV/9v4+jtvZj+AqwkZm1jJFaWg2MqPXqGg2MsJGRtjI2EbJaDYysxUbEc1GZrZqI6LZyAgbGWEj426UzCwLAhFjlIywkXE3SkazkRE2MrONUSKajYywkXGDQEazkXHORsY2SsYYJTOKjYpmI+Pog4xmI+Pog4wFgYwxSkazkXGDQMYYJSNsZISNjLCRcV1Fxg0CGc1GRrORsSCQETYywkbGn26QsSCQMUbJCBsZYSPj5UkyXgsnY4ySETYyxigZh7pkvM9GxtEHGQsCGQsCGQsCGWOUjG2UjDFKxhglI2xkhI2MZzYymo2Mow8yxigZX8ST8cxGxjMbGc1GRtjI2EbJCBsZRx9kPLORETYyvq4iY0EgY4ySETYy7kbJaDYyFgQymo2MsJGxIJARNjIWBDLuRsloNjK2UTLCRsYYJaPZyDhnI+Pog4wxSsYYJWMbJeOZjYxmI2NBIGNBIKPZyGg2MhYEMsYoGWEjI2xkZntmI6LZyAgbGRfxZDQbGWEj4waBjGYj4yKejGYjM8vf8hHRbGQ8s5HRbGSEjcxsCwIRNwhkjFEywkZG2Mj4BoGMZiMjbGSEjYywkXERT8YNAhnfjZJxzkbGgkDGgkBGs5ERNjI+5SOj2cgIGxlhI+O6ioxmIzOWUSqz1nqd/Qiu8APFUWf+cQFTXgAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M295.66,585.93a225.34,225.34,0,0,1-25.92-18.52h0c-2.64-2.28-5.2-4.67-7.53-7.13A93.9,93.9,0,0,1,251,545.8v0c-2.32-3.86-7.14-13.75-7.14-13.75s15.36,19.14,30.22,32.52,21.55,21.41,21.55,21.41"
                  transform="translate(2.38)"
                />
                <g class="cls3-107">
                  <image
                    class="cls3-33"
                    width="155"
                    height="149"
                    transform="translate(246.28 531.07) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJsAAACiCAYAAABWFL/pAAAACXBIWXMAACBLAAAgSwFrhwW5AAATA0lEQVR4Xu2d0ZnruA1G/51vykoLqSDVpJ40kRLSEfIgWxZFEDgQKc/srs+DrBUPAZqioLHnavaP//zzf6YOdshtMPdoL8TSozkN1tJ4cScruD2Guli7iXGncdCveC587NUMhkffsyRHNf3rv//448s1MRVXqvhWcHsqfSuuRCd9ZqGF/NRCu8yrr7PYHGgua15iAqlZaCiYuCedqtqdXEtkh63TkLPUq5xUhdfiabHRiFLNler+VSp5Kq4UzmRrIU/SwKOdn1T8uXtGjTZTXtnoyMIL4HQ0iPmrqxrtS1ebowx7gXCSUs+6nYjwpPYk1+JhsdGIElxSP0A8gukPBQBm+dhhy6n4FXeWPlde2T58WES82OiFEHqnxsC9+xZ6neT+8LKOmxig7FA3OQ/22gVY85ICpuix2DLtiO+iCEjSRS/uNHcLvR87bDlV/z7akfjjGlc213cOJlcT5Z2fkWqAS1bHgkZlyNA9NSTnwV67AGteUqD3VV9ABypjQpIuenGnv2ZVuxk6nO5aHHf8dr8KcP3xovTD8ytv7me1vIMV3JZuJkfWcRMznsbrDWHa+6uaHf8joL+NFpIcXmKQpPWeNPe9WolrieywdRpylnqVkyp6Le4S/OoDhTzA/bmf1Sp9K65EZ9L2DcD1aOcnFX9udmvkmdrFlvsblQsgkOZunzlTVY32pavNUYa9QDhJqWfdTkTlpIpei40EKpsfcpwIDWEBcZ65DwXMZ5aPHbacil9xZ2G5XouN+Yl3agzcu6vaddgla+0mBig71E3Og712Ada8pLAp6qSksvkhryQacsmLO81Vtfuxw5ZT9e+jHQkf17bYXN85mFxNlHf+2FqDXbLWbmKAsjN0Tw3JebDXLsCal5QJD/zM9uHDGr6qKxXpSNJFL+7017yF3gwdTlf4Bx0HhweVjWZ/wv333UKrebqZHFnHTQxQdobuqSGMefEWeolK381lt1FrXmKQpIte3Gnqe7US1xLZYes05Cz1KidV9FoMpcmnq6SKP1fVKn0rrkRn0vYNwPVo5ycVf252a1Qyvdy8slUugEC6+3u1qapG+9LV5ijDXiCcpNSzbieiclJFr8VUmni6Sqr7V4nzzH0oYD6zfOyw5VT8ijtLJVfron8W7oc/HQ3GcHdVuw67ZK3dxABlh7qhd/FDAXJFpyg5/xvfr/9AIV3wLeySl/wscnJT5Qby+LnR0vrV3mdm+7+ozG9/dPwMAjzD+RvJjTsZZ6eXrB4emFIaTwrc00KD52EUz122dJzAC6am48v1YOdKomveXFWjKe/ld4xihw6n89Bqjg4OnkEIqfgVt4f35uaG8S7BFZWs9TFDt224paotBMxKQ/7Vx4cPi7j8DEJwwfdc8pJOc80FZiI5fWG45R+6JO52Xt+xdP4fFCtbJXrFPVP5NpybG8a7BF5+XdAkTyp+7rZG7o+p9I3dS88g5Kva3N0Q6kmpS4cWkr/JDaDsQHdtVbPmJQV4dGp2Hm6hslWizzD3CTSm6vvkUXKjpeLnbm5QKpFyFz6DYO0edEH+DeoBxqGM58nf5AZQdqA7+wm0xZqXFODRqdk5uN/7f9AAt3p3VjXxLoGXD2HQeRjz1DA5xsqQOvI3N2higwmeQXhizt6I3LiTcXbjQ7N9EwOUHbjQZqvaKZp3cAzw6NSMwP8svJTokjdX1WjKGfIcufFW6HA6D63m6KB7+NKjfD4Vt4f35uaG8S7BFZWs9TFDt224paotBMxKCvo0GpyDnkte0mmuucBMJKcvDLf2q44H1O28vmPp/EtDN1hsC6IjPl/gxuRua+T+mEpf7j5NVNk+fFhButjyEmrubgj1pNSlQwvJ3+QGUHagu/YWas1LCvDo1OwE7qLnRq8y9wk0pur75FFyo6Xi525uUCqRuGuHbfgoX76qzd0NoR5gHMp4nvxNbgBlB7qzn0BbrHlJAR6dmh3XfR38jmLhPFRsvPmqRtNeJY+fGy2tX+19Zrb/i8r8DrI6h8+Hho/y5at63Vu9wji78aHlb3IDKDtD97TQ6Nyic2vewTHAo1Mzwg7bJ+7PbKVEl7y5qkZTzpDnyI23QofTeWg1Rwdx7sNigz0k1dwe3pubG8a7BFdUstbHDN224ZaqthAwKyF22B7pKltwDnoueUmnueYCM5GcvjDc2q86HlC38/qOpfMvldzxc6NDKu6Zz28LYnK3NXJ/TKUvd+2wPdNUtnxVm7sbQj0pdenQQvI3uQGUHeiurWrWvKQAj07NDnUf3oXnRq8y96Egpur75FFyo6Xi525uUCqRuGuHrcde2fJVbe5uCPUA41DG8+RvcgMoO9D9e1Q15+DhUPq70Q8fVnHfYmsW+Z230DXkWXOjpeLnbm5QKpEGblzAhge/9mN0NVTGuohxSuPjyd/kBlB2oHvL92owN/Ho1Iywwzbiq5TokjdX1WjKGfIcudFS9YvQ8J2HVnN0cCL381E+uhouJEq7WLcDMd4luKKStT5m6LYNf86qFnQ8NZl3cHAIP111zUs6zTW/CTaRHms/gT6gLlhA/kILoO7AW/h01Znf9NsCX86vC5rkScXP3dbI/TGVvty1w5YQ/Hs2c3dDTl7YLYlJU4Ykl651OwDorqhqdt5bELNRgLfjuNXr86avPn5JVQvIQ+RGS8XP3dygVCJx1w5bSv4MAo1HPSl1w1pE89BLFyg70F1R1V5Y85ICPDo1O67rHExi3lDZ5r7qeAd51txoqfi5mxuUSqSBS9cUSBU+8EICSOIeYBzKeB566QJlB7p/zq86OHbYVrmhsn344DNebHTxNt7cLZSmnCHPkRstVb8IDd95qHRGBydy+3y3Juw1gH8Gpd4T412C+0Sy1scN0L3lFnoZejHzPHbYXsGvbDQeO3srmt9EZaG1rP0E+oC6nTdYaDSexF3q6fLTVWd4TavnMd4lmNH8uqBJnlT83G2N3B9T6ctdO2yv0j/wQuNRT0rdSqgYEAkoO9BdW9WseUkBXnAN+lAXe5u44NPob6pq5SZstFT83M0NSiUSd1dUNen8wAuNRz0pdcfN1YUGZKDsQPfvUdWcgzTmYYImK9vcVx3vIM+aGy0VP3dzg1KJNHDpmqKpTlfia7HhAJnAGYcynodeukDZge7sVx0t1rykAI9OzQg7bFfwLYkv9OZAPAgruFeZiXptImt+zRZfn/GJSQ6bs3f+jwB6TThX4vA2mgbDVCMZ6mLtJgYoO0P31JCsBnvtApC0gMFCG8IsysV/Fh53wj80/xB22F6CdqWe1LjJOs4OhIddqGvNy5jBApj8gPDhA2f8xwCHpOv6QMWVJENdrN3EAGVn6NaCVOxa7DOVvubsRTCrAqtshbzvu4VeS2SHrdOQs9Tr70thNxRT3JO42w/VJ1gA/h8DHJKmOlBxJclQF9s3gJM3XGghFb9a1VpqfSu2OXsRvsX6jvlOI2TtB3BVu+iFU3Yx5hDqSYWrfvgfLWmgA9Rl1zI/ia4Wn5f+jwEOSVqnJnJi8UjINenCRAKfurQZpOSrW+KrTPXTVjTav892Ju+/AJbEnL3fQ/X2WbNdaAi6Lg1ZG1A7e/CfhcfR56qaA/Uk5G7zCESpVmKAIin1Kimh9KDijsmj5IZ0/JNZS6hGYr45e/dSyVP5xwjugfCwC3Jt91LdkLUBNc8D/yw8jk4LxswghwB3m0cgSijeTsUNqIWp2SvIM+bGk69kKYWtLRVXor45e/cC8thrJ7S7xoENUvIyJUnGdUPWBtRGXl/ZaEDxgoFjDj2nAcTc5hGIEoo3R5/g9pST5OPLjSPsNwgfPiwgWGyVVVtxJepXCp2rlKsa8A9uaCehKil3ibpUt7HVHU2DPQi8drHRgOLnEcecWVk/QG1UNXsFLCOzfM05mITL/2SW19o0B+7EIGfW3nbBAlE6xAM+dWkzSLlL1EWe6qetaLRsfv0ZhClYEnP2fg8/8NsCCl2XhqwNqBHvu88b95qrag6ON+wKYm7vB4hSrcSYu9uThKqk5KtHWnWJ5n1zo+XlT3wavZ40Ys2UVajkWVTVKkGQa3xdGrI2oEa90zMIcS9aMGhy7EnI3eYRiBKKt0PdxKNhNmr2CvKMudHS+hf/sEzFlahvzt69gDz22gntrnFgg5S8TEmScd2QtQE17KlwG6UFAycfek4DiLnNIxAlFG+OPsHtKSfJx5cbLb3f/xWjlIorUb+y9lzKCw34Bze0k1CVlLxMSZJx3cZWdzQN9qB40lBlo+fxrkFmXOvFqcWv2StYmtEN5hwsJH2qaLF9+LCCr2yJzn2vxq6ImUK33R2AKB3iAZ+6tBmk3CXqIk/PSRo3heRGy9i/sbKxQZqz93tY9L3ajaQZg4XWATXsqVXDxTZX1RyoJyF3m0cgSrUSAxRJqVdJuUvURV5MHiI3WmL/psrGBvn+qlbJ8wNVDYV4LbRUN2RtQA176tXxn8xqzCADTU49CbnbPAJRQvF2qJt41u1EIGkpecbcaMn98RPxdLa65oF/OmzOXnTIpeQB+fCeQ/vie/ax5iXGuE7fs4Q17MlX/b9iRINOe9cW2jaPQJRQvDn6BLennCQfX260MD/5mY0FecH8ytpzKS804B/c0E5CVVLyMiVJxnUbW93RNNiDwkkb5ej+t930PM4M0kYNgGu9OLX4YKIXMxs/7z88YYhIbf+wTGMG3dwmNsjCBeIr9GqwbmcMdWkzSLlL1EWenpM0bqodSAD+QVn01QdIqqPF/PfyA191FGEZmUU17ClXX3/FqDGDblnEJ9STkLtdsECUaiUGKJJSr5Jyl6iLPE2ettxoAf5JWVTZPnzIWbDYwArXT9xCK3l+4BaKQryqWqobsjaghj1l6ta6/cmsxpyqxRvUk5C7zSMQJRRvh7qJZ91OBJKWkmfMjRbgO8qpsoEgDcw3Z+9eQJ7DCgntrnFgg5S7RF2qG7I2oIY9Zeqr9YsWDJx86DkNIOY2j0CUULzV/EDKEvn4cqMF+APl4tNVEvUra8+lvNCAf3BDu2tsD1RS7hJ1qW5jKxn+mMJJi0O2rewDwg2DJFzrxanFr9kruD/jXAa3dxAyf7qKRmSHkoaTcnNVC6HNIOUuURd5ek7SuCk8MGD6pLn/IYlWtgaQVEeL+e/lB77qKMIyMsvXKtWhp6DuxA+80IjUk5C7XbBAlGolBiiSUq+ScpeoizxNnrbcaAF+o/h+sbKBpDpazJ+nkucHqhoNQdelIWsDathTpo5bx4uNJqeehNxtHoEooXg71E0863YikPSg4o7Jo+RGC/CBIpUr24cP1yksNrZ8f+Ut9FCOQrtrHNgg5Q5ybfdS3ZC1ATXsKVPjVn+x0eRDz2kAMbd5BKKE4q2mlrJmryDPmBstwAfKE1jZWMTK2nMpLzTgH9zQ7hrbA5WUu0RdqtvYSoY/pnDS4pB5wu/uyKAPfzPjpPlwrrMitjl7q1gRcS7G7FJxOHXKlkRb2VzbOVgZGb5qU2PDup0x1LXU2KhI1EXec3qonAkPstUR0SjBXePQ0D6k3PWw6LDDxMKc8OLhgMCniRsCQu2Yu9tDY5YvxuQgHd8I2v/Q+KpsNCP1pN1Nu5QnEvhAkSQZVCsSdZHHp8en2hn4Fy/O4AOCHbYEbs7R5omz5mOqREOcQgwjwlR33z5pF5/ab2O2xUZ7UE/iFzm9bKEmibtLPSQ9qLgzVC9FMC6gSHK9QWWzw5bgm7w/BdQh63Z8DEVLwzSc3OGswJh3V7U5KlVtM79GPbrDw8hOAx3FRFWDPd9EP5qfH188gksjBoqkoedUNhpxgDUvY8oLDfjU7YoLveI86BuWnMRD3lvVaIAn9aom4d8gfPgwj//32dIDacOtrM26Npp0R8Qq8QgujY92Crz8uVGaROJ3lF91Cx1QkaiLPP2+W2ijsN8WeAe6R/lA6gfcXMnarGujSasiwiiu5hw0d/cSvH9vxj+z8cj8Iv9UtRA6PT7VzsBvlMAHoZpH+YD/gJtztHnirPmYKtEQpxDDiDDV3bdP2sXn2ifQI82fOaWLuINe5PSyHWjuYRgSF5cJqXLUg5se1UsRZFt8Me2P8kFf81NKaSPGCy3J3i20ymoegE4EXeG6varNMV/VpPI/C3ca6Cgmqhrs+Sb60fz8+OIRXBoxUCRxT8+/z5ZZI6x5GVNeaMCnbldcBj5Iyd+w5CQe8t6qRgM8WVPVJOmra142yDWszbo2mnRHxCrxCC6Nj3ai3gPwz8IH0Iv8V1W1ARWJusj7hVWtUa5/ges1fX43+uFtwMUGrogbWJt1bTRpVUQYxdWcg+bu3gzLVH8GQeJ3lM8tNIROj0+1M/AbpXILDTi4oLJVIq8jzpqPqTVyP+UUYvZE3P2zGu3is+4T6JHtUT7u84ucXrbW7YwBiqTFHn3DkmTQE/ckxx10Hg4VJAOKJO5JnZtUNj9yJR+jjejGp4uyO9/xiUGc3OGswJh3V7U57qlq0lbZ/p1JOzR2uaqFh36QSzXiZuIRXBoxUCRxT3Ld/wM1apQSYL93QAAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M269.7,567.41c-12.29-10.34-16.4-17.73-18.72-21.61a93.9,93.9,0,0,0,11.19,14.48c2.33,2.46,4.89,4.85,7.53,7.13"
                  transform="translate(2.38)"
                />
                <g class="cls3-108">
                  <image
                    class="cls3-33"
                    width="134"
                    height="112"
                    transform="translate(253.47 544.83) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,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"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M392,582.08h0c.54-1.8.86-2.79.87-2.8h0l-.87,2.8"
                  transform="translate(2.38)"
                />
                <g class="cls3-109">
                  <rect
                    class="cls3-30"
                    x="393.61"
                    y="578.88"
                    width="1.43"
                    height="3.09"
                  />
                  <g class="cls3-110">
                    <image
                      class="cls3-33"
                      width="8"
                      height="8"
                      transform="matrix(0.68, 0, 0, -0.75, 392.18, 584.83)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAACXBIWXMAABAlAAAQJQEuD214AAAAOUlEQVQYV2P8////fwY8gAmfJIqCu+chGKcCXICgAhY4C+5WRhQFxJuAy6+M////P4BDjoGBgYEBAB6cDiS8p9IwAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M392,582.08h0c.29-.94.59-1.87.9-2.77,0,0-.33,1-.87,2.81m-1.65-1.5c-2-2-5.42-5.48-6.27-8.54-.32-1.1-.37-4.32-.27-8.66L385,564c.07,3.75.47,6.53,1.32,7.68a66.2,66.2,0,0,0,6.63,7.62l-2.52,1.32"
                  transform="translate(2.38)"
                />
                <g class="cls3-111">
                  <image
                    class="cls3-33"
                    width="30"
                    height="52"
                    transform="translate(385.03 563.59) scale(0.35 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAA5CAYAAAAhmZssAAAACXBIWXMAAB9fAAAfXwGscuV3AAAAj0lEQVRYR+2XwQ2AQAgEl8v2bCf2YxWWoyXwgnnAvEkme4DBuK/3E4B1Iqsp4WQFVay4DUzs0E51D5jYUItlQWYsMdfj3eMu5onBPRZy63FPjYlNuc2MFhVXoBjbYy4x8/kgE0Mt5hLPE2+P25h3V1sxLPE88cBDIHaqm8DE2J8EdmVie4w9NTdckp6sqIIf7vkHXTmeCcoAAAAASUVORK5CYII="
                  />
                </g>
                <image
                  class="cls3-33"
                  width="3"
                  height="3"
                  transform="translate(395.04 578.88) scale(0.48 0.52)"
                  xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAAECAYAAABLLYUHAAAACXBIWXMAABbqAAAW6gHljkMQAAAAJUlEQVQIW03KsREAEAAEsLyzvk2sY57XKKRO9jrVggkCDJ/0FbgTXAgSsea01wAAAABJRU5ErkJggg=="
                />
                <path
                  class="cls3-30"
                  d="M392,582.05c-.16-.13-.78-.66-1.62-1.46l2.52-1.31h0c-.31.9-.61,1.83-.9,2.77"
                  transform="translate(2.38)"
                />
                <g class="cls3-112">
                  <image
                    class="cls3-33"
                    width="10"
                    height="10"
                    transform="translate(392.18 578.88) scale(0.38 0.42)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAALCAYAAABGbhwYAAAACXBIWXMAABzpAAAc6QHh0LjlAAAAUElEQVQYV62Qyw2AMAxDn1GXZBW2Y7G6lxLR34EK315iOZF1nbcBwGBjKgI4ByVJvHfhwYBQ5WO0zPW/MfUDMdd+Yl9A1LM+1mr545P0uccC5aMQrY+1g+0AAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M412.47,493.7l-.47-.22h.1l.37.26"
                  transform="translate(2.38)"
                />
                <g class="cls3-113">
                  <rect
                    class="cls3-30"
                    x="413.64"
                    y="492.2"
                    width="1.43"
                    height="1.55"
                  />
                  <g class="cls3-114">
                    <image
                      class="cls3-33"
                      width="8"
                      height="5"
                      transform="matrix(0.68, 0, 0, -0.75, 412.21, 495.91)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAACXBIWXMAABAlAAAQJQEuD214AAAAL0lEQVQIW2P8////fwY8gAmfJIqCkxuvM5zceB1DAQuchcMmRkJuYGFgYGDEpwAA6r4OqK/Q49gAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M387.77,530.12c-.43-2.2-.86-4.5-1.23-6.88.14-1.17.28-2.11.39-2.77,1.27-7.24,6.5-18.77,9.83-20.73,3.15-1.85,14-5.81,15.19-6.22l.47.22,1.09.74s-16.67,2-20.7,11c0,0-.44,1.67-1,4.34a38.74,38.74,0,0,0-2.35,8.51c-.44,2.69-1.07,6.86-1.74,11.73"
                  transform="translate(2.38)"
                />
                <g class="cls3-115">
                  <image
                    class="cls3-33"
                    width="82"
                    height="98"
                    transform="translate(387.89 492.98) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABoCAYAAABizadQAAAACXBIWXMAAB/VAAAf1QHSNaIIAAABS0lEQVR4Xu3bsW0DMRQFQdL4HbkXdeICnLoT9aKeqBIowBvOxIoW78Q7+byff6+z+JfHz/f+un2IzwgZmbX27TN8wCIjY48Ni4z4joxYZETIyLiyGxYZETIiZETIyBynTcIiI0JGhIx41o5YZETIiB92IxYZETIiZMTvkRGLjLghj1hkZJZ30RJuyCOztpSFcWU3HDYRISNCRoSMCBkRMjLbs3bCIiN+j4z4GS3i0o4IGREyImREyIhTO2KRESEj/tQQsciIkBGndsQLAhGXdsSlHbHIiJARISNCRoSMjNcjGxYZETLihjxikRGvrEQsMjLnmGTBIiNCRoSMCBkRMiJkRMiIZ+2IR8SISzviTYuIRUYcNhGLjDi1IxYZETIiZMR9ZMRhE5njH20SviMjQkaEjHjWjlhkRMiIkBEhIw6biEVGZq31e/sQd28xHg2wi4WXHQAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M384.93,560.88l-1-.2c.42-11.92,1.77-29.69,2.69-37.47.37,2.38.8,4.72,1.23,6.87-1.31,9.65-2.72,21.94-2.89,30.8"
                  transform="translate(2.38)"
                />
                <g class="cls3-116">
                  <image
                    class="cls3-33"
                    width="14"
                    height="90"
                    transform="translate(385.03 525.76) scale(0.37 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAABaCAYAAACIV2cwAAAACXBIWXMAAB2uAAAdrgHrADpwAAAAyElEQVRYR+XYwQkDMQxE0XFQozmnltS0pTkNZDE8gYOJzv6MRrKM8Hi/rhmIGqsTN/FYHbgLBiuxZF3R9JLCTFMTSfa4H+Q+7m8He2SQi8OKDDbasdtj0duYpDIs1cpU0Dhvh1dVU20ooiQr7gcLb1xDUavqYzXQZAUleTq4OI12mOAPUmXwLzyOc1LFqWooYm1c8SCwlDUqSSnZWJCMa3g85+lgkD3ubweDvFq7oq4rrMgg7zmsuB/ku8q/Kz5WhiWV5Lk69C0+GYYMVSgPQJoAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M391.91,509.84c.53-2.67,1-4.34,1-4.34,4-9,20.68-11.05,20.68-11.05h0s-9.24,2.13-13.21,4.67A22.65,22.65,0,0,0,392,509.84"
                  transform="translate(2.38)"
                />
                <g class="cls3-117">
                  <image
                    class="cls3-33"
                    width="66"
                    height="45"
                    transform="translate(393.61 493.75) scale(0.35 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAxCAYAAABu4n+HAAAACXBIWXMAAB9fAAAfXwGscuV3AAAAoElEQVRoQ+3ZsXHDQBAEwYXq8zeZCQNRRJKBKbgMgN02rK29x+NwvV+/f2M/nx74FmfXp0e+g0ZEEDmbs3LTiMeZ03KbRjwEEUHEGRGNyNGHm0ZEEBFEBBGvz2hEbKhybCNuRiMOy2hEBBFBRBARRI7fGjeLmRiNnF06sWnEQxARRHx0xWImRiOCyLlcsbfZWT6MRgQR94hoRAQRQUQQ+Qee2gio9CfmUgAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M470.61,586.45h0l-.07-1a4.48,4.48,0,0,0,.07,1m-.1-1.46-.22-3.07c0,.62.1,1.19.14,1.71V585"
                  transform="translate(2.38)"
                />
                <g class="cls3-118">
                  <rect
                    class="cls3-30"
                    x="472.29"
                    y="581.97"
                    width="1.43"
                    height="4.64"
                  />
                  <g class="cls3-119">
                    <image
                      class="cls3-33"
                      width="8"
                      height="10"
                      transform="matrix(0.68, 0, 0, -0.75, 470.86, 587.85)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAALCAYAAABCm8wlAAAACXBIWXMAABAlAAAQJQEuD214AAAANElEQVQYV2P8////fwY8gAmfJIqCM1vv4leACyAU4HAKkgkEFWAHcAW4PEu8CbjcwEgoJAFrLBBl2vNodQAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M483.46,597.21c-2-3.15-4.1-6.43-5.81-9.28a98.24,98.24,0,0,1,5.81,9.28m-2.85-1.71h0a21.71,21.71,0,0,0-5.21-6.16,17.39,17.39,0,0,1,5.26,6.16"
                  transform="translate(2.38)"
                />
                <g class="cls3-120">
                  <image
                    class="cls3-33"
                    width="27"
                    height="28"
                    transform="translate(476.58 586.61) scale(0.36 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAeCAYAAADdGWXmAAAACXBIWXMAAB6aAAAemgH8byj4AAAAaElEQVRIS93WwQnAMAxDUbl4lY7aRbpSB0pHyMW8Q3QWfGQ+JPU+3wpKr9SuM5ZrV5gMhTW8YjqQ1g518hmpjRRGBbHLpCBUfXzG5abRZRTW7E8QrX45Fl4GWdbGc2H0PcM2JveuNJUfxKwGjIJJtNIAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M470.51,585h0V583.6c0-.52-.08-1.1-.14-1.71l-.29-4.25h0c.17,2.37.32,4.39.42,6V585"
                  transform="translate(2.38)"
                />
                <g class="cls3-121">
                  <image
                    class="cls3-33"
                    width="4"
                    height="16"
                    transform="translate(472.29 578.72) scale(0.44 0.39)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAPCAYAAADDNm69AAAACXBIWXMAABjpAAAY6QESljQqAAAAPUlEQVQIW4WNQQ0AIBDDOjITuEYKJtAFXxgk9HfN0lNvY7JhxIEJYynEtchGITDZ0NX4RR03VjnV4y3UXSwf9QNlgDf9XgAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M486.71,629.48s-2.47-27.35-6.14-33.94a17.35,17.35,0,0,0-5.26-6.15,21.38,21.38,0,0,0-4.7-2.94h0c0-.32,0-.65-.07-1v-1.85c-.1-1.52-.25-3.58-.42-5.94.23.29,3.91,5,7.6,10.28,1.71,2.86,3.8,6.13,5.81,9.28a20.47,20.47,0,0,1,1.7,4c1.69,6.58,1.59,28.2,1.59,28.2"
                  transform="translate(2.38)"
                />
                <g class="cls3-122">
                  <image
                    class="cls3-33"
                    width="52"
                    height="137"
                    transform="translate(472.29 578.45) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADQAAACRCAYAAACMqZu2AAAACXBIWXMAAB9fAAAfXwGscuV3AAABX0lEQVR4Xu3auREDMQxDUcrDhtyXS3FLrm1dwqbYN0Cs5A9IiDrO9/O7BtLrbsHTxAHtuVvxMO2MhbQYj+eQGAp1KFpLjQkjOmR1kAik7UOdFNLFpRwHtHOskuN6CEw5bJjjQoED4lIOdAiLOc+hXpKEq0DpasqlazWk1UyyaAa8aPQcwlK7JRevTgrp4hzqG2u6OKA9x2LiQsGyZ0Ag7m67w2m6xPOQRdSSSxc3KXCxzTnEhUKB0sXdKYAphx0fvB7qPhSuOpQuziHuPOSVHGaQV3JgKGBAXChwQIudHkCHroZCtvr6kK5urOnqtJ0ur+S0UACBsOm0oZAuDmjnsmqOCwWu5Dggb2O1cHqNlS8OiAuFOpQu0CHLINEhzKKWXLq8krNwQCCvh7h/21woaEBeD2EGebHN9RBXcl4oaH99uB7iSo4D4l7wuNhuKKSrQOnigLjYBh265n236En6A4xgDQwzcosfAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M434.44,573.61l-23.31-11.2c3.61,1.41,23.31,11.2,23.31,11.2"
                  transform="translate(2.38)"
                />
                <g class="cls3-123">
                  <image
                    class="cls3-33"
                    width="71"
                    height="34"
                    transform="translate(412.58 561.85) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAAAlCAYAAAAQjPROAAAACXBIWXMAACBLAAAgSwFrhwW5AAAAzklEQVRoQ+3ZwQ2CQBQG4f8Z+i/FGuzHIvCkbmCZEEHgMN9Bk30EyGQPgvW4P8ckSar5TLPUrNRk/j1o+tVbmM/nJ0t91jrD6bx7SHOF3rxq6cyz8926xymJcdCQcWFSyeLsX+ia7y1/4D25c4BxgHGAcYBxgHGAcYBxgHGAcYBxgHHAsPY57oTnvp/tda/uHGAcYBxgHGAcYBxgHGAcMGTc+lNpT+2/aufflzsHGAcYBxgHGAcYBxgHGAcYB6x+TbrVXq8uj1TjpR4fruUFnXwSvv0zXr8AAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M434.44,573.61h0c-.15,0-31.71-2.88-35.93-3.3h0c-2.23-.23-8.32-3.36-13.58-6.27v-3.11A104.39,104.39,0,0,0,396,562.45c3.19.23,5.93.32,8.18.32a59.6,59.6,0,0,0,6.94-.32h0l23.31,11.2h0m-50.62-10.22c-4.24-2.37-7.68-4.39-7.68-4.39s3.23.86,7.76,1.73c0,1-.06,1.85-.08,2.7"
                  transform="translate(2.38)"
                />
                <g class="cls3-124">
                  <image
                    class="cls3-33"
                    width="175"
                    height="45"
                    transform="translate(379.53 558.75) scale(0.32 0.36)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALAAAAAzCAYAAAA3k4IoAAAACXBIWXMAACLpAAAi6QE3ea5wAAACh0lEQVR4Xu2dS1LkMBBEyxO+yFyJc8wVuMlcZpZzqmZBq0O2JWWFbGgS3ls0pipLPzLU/kCz/H39f4sWy+MlE94Et5qdeGkebiObL9tYm2Uwrnte1NeHu5mMplAFOx0sm1kc05tkQ9VodxtZDmXHteiNbbfGVbwcDJZ09+12DVui9pCOfQ+qIiLi5c/vR/DXIQtgBAYGazAwWLO2T4CPlJOOnr4+U8m2+RNQ65ZFra/Kf1fYgcGatX99vEfpenlVV9PSZuqVZjav6mo+qg1Vr/IRWvOssUdozTi/qvI9GX1GE6F1Kl+jtCpfo7Qq3+IKixRUjcrXKK3KFzK6jCYir4vgFALMWaXdP+Kd4Uz9bG2mLmJ+3LO5wjPmqzQqH3F935naCnZgsAYDgzUYGKxZ5ZOJq++KL6HbbGky48loZjjT7ux8n0lmvhnNJ8AODNY07kLsAsvhoHOl2KtrBLtXmq0+Mu3uBK05DevU3O6JURvd39dUfd9ZHi+7uCrutL+JddrorfEjrPoO4Y9BfetnNIp3YAcGazAwWIOBwRoMDNZgYLAGA4M1GBiswcBgDQYGazAwWIOBwRr9FxkR/cfRs7Wzddn8bK7wleZ7plblClf3PVs3indgBwZrMDBYg4HBmsYHm1xxcjLbxuwJVc3ZNq4c+yjegrHn4++wA4M1GBiswcBgDQYGazAwWIOBwZr1uk+mqG93XNXmZ8HYXWEHBmu+zQdc15y9pV7I1GQ0EVqn8jVKq/I1SqvyhYwuo4nI6yLYgcEcHiUfuHLso3gLxp6Pv8MODNZgYLAGA4M1GBiswcBgzXqL+KdEDtTXqmefR5W21H9fGGmyqL5gzHK7sXTgC6cQYM0bFcUi93QPtSUAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M384.93,564l-1.11-.62c0-.85,0-1.75.08-2.69l1,.19V564"
                  transform="translate(2.38)"
                />
                <g class="cls3-125">
                  <image
                    class="cls3-33"
                    width="6"
                    height="10"
                    transform="translate(385.03 560.71) scale(0.41 0.41)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAKCAYAAACXDi8zAAAACXBIWXMAABrCAAAawgGdlvnxAAAANklEQVQIW2NsST7ynwEKGBkZ4ICFkQGJhwRYUMSR2EwYSglJsDD8Z8AKWFCcguwqrI5iJMdyACQ6A9L8R+jRAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M428.43,599.08l-.13-.16.13.15V599m-.28-.42a38.83,38.83,0,0,0-5.6-5.92c-2.28-1.65-29.67-13.38-29.67-13.38h0s24.58,8.77,30.72,14.25a46,46,0,0,1,4.55,5.09"
                  transform="translate(2.38)"
                />
                <g class="cls3-126">
                  <rect
                    class="cls3-30"
                    x="395.04"
                    y="578.88"
                    width="35.76"
                    height="20.13"
                  />
                  <g class="cls3-127">
                    <image
                      class="cls3-33"
                      width="62"
                      height="30"
                      transform="matrix(0.66, 0, 0, -0.72, 393.61, 600.8)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAAhCAYAAACBQRgKAAAACXBIWXMAABCbAAAQmwF0iZxLAAAAj0lEQVRoQ+2ZyxGAIBBDg2Mh9mAVlm0FVmAt8QAre5DxTvJOhPCZx5VCktCiAMAa6b7agER9CYIkamDPQJuP96rjiGy574u51KH375n5nFgTd0WH1OX78LUP2I8NI5ZhMzkWV8PialhcDYurYXE1LK6GxdWwuBoWV8PialhcDYurYXE1LK5GUf4mPn8WTskDoSdTAHDs8HAAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M437.62,599.08l-10.07-2.92,1,2.91-.13-.15a3.89,3.89,0,0,0-.27-.34,46,46,0,0,0-4.55-5.09c-6.14-5.48-30.72-14.26-30.72-14.26s22.1,6.29,30.22,9.54A45,45,0,0,1,437.6,599"
                  transform="translate(2.38)"
                />
                <g class="cls3-128">
                  <image
                    class="cls3-33"
                    width="134"
                    height="59"
                    transform="translate(396.04 578.88) scale(0.32 0.36)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIYAAABDCAYAAABZXH2WAAAACXBIWXMAACJyAAAicgHSbRshAAAC3UlEQVR4Xu2cQVLkMAxFlamcjCvNAeYQs5vjcZHMKmnF+Y5lxQYK3ltAt60vy10fxzGB5d+f980ONtteL/cvZpsLubBrtuO9+XCnPbJf0m3F9/2lq8dpz+MV/cfLc86tmMOlZv+2iPL5LvWI+V4/rfIzerWfaj269+hzu5pBTevrUhWdY84Rv/++LetiS0X0DFVKa6SM5qVqR86gXrPvidVW5rqq+nMqrka5uuCXAQgwBkgwBkgwBkgwBkhWcQPVTVQTjfMozYg8mRxmMd13qJkVAyRr/m74nsyZREbz2YysuX2OMYZIzawYIMEYIFlPa8iTE9eINnt63ZPbx2R1d+2ej55PJCarK9pZMUCCMUCCMUCCMUCydm9QImS1Wd0osuNHdIENX9eYJYM3wqwYIFn7LTaSrM1nEzkb7GHGPGfmZMWACuvph0P9oNy1eyLaSJ6dXp2Kyeru2j0zx8zmyeqKdlYMkGAMkGAMkGAMkGAMkHzyOcYMZtzfj6a8LRhR69h5s2KABGOABGOABGOABGOABGOABGOAhCe4PNnxI7paTEQbIXuMURn/ixxwZWd1x4ycZvPyjkL9Tr2/Vi4lIMEYIMEYIFlP73ovRZGNUyRGEdG1NnS9ughPtDutust21V+LqVF7nK+SY9r/xxhFdiv15DP0ZPJkay7JjG2W13m4lIAEY4DkvMfwa1DtmlQjom3lzOrMdEyvLhLv2Yrvd/TOrTdnJF5R0bFigARjgGTa//kclUcRjfOMmKdZPk8krhXT6q+RqZkVAyQYAyQYAyQYAyRf5HmMmexbrdHznJG33BaOzG3Wk58VAyQYAyQYAyQYAyQ8qNNTk9kz7U6r7rJd9ddiatSOO3lQJ0cmT7bmkszYZnmdh0sJSDAGSDAGSH7AyedH0drxPmFmbjOVv/63q720dtQ1srqSbJ6IrnUXcTdeK6Zn/LK/pW3138ClBCTLttVucOEnw4oBkv/fJQJ8ml1HVQAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M339.29,393.07a44.43,44.43,0,0,0,3.3-3.55,26,26,0,0,1-1.69,2.19h0a21.22,21.22,0,0,1-1.61,1.39m9-32.15a36.51,36.51,0,0,1,.61-6.85c.32-.86.62-1.66.89-2.4a40.06,40.06,0,0,0-1.5,9.25"
                  transform="translate(2.38)"
                />
                <g class="cls3-129">
                  <rect
                    class="cls3-30"
                    x="342.12"
                    y="351.35"
                    width="10.01"
                    height="41.79"
                  />
                  <g class="cls3-130">
                    <image
                      class="cls3-33"
                      width="20"
                      height="60"
                      transform="matrix(0.68, 0, 0, -0.75, 340.69, 394.38)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAABCCAYAAABXXvbnAAAACXBIWXMAABAlAAAQJQEuD214AAAAfUlEQVRYR+3YuwmAQBCE4Vm5yuzG2DqM7cbW1kQvvFNmBOHmiwyWnxUfiJGZCaGpN/BWuQ+2eWnNda3HDuCDDeXBesqqKyPf0EHegMF6YyOjMfacfEMHeQ7yBgz65cBzkOcgz0GegzwHef8P+suB5yBvwGCo/x8WAJqH+HIC5P8PhxO5SfYAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M339.28,393.08c-.29-10.18,5.88-28.77,9.6-39a36.48,36.48,0,0,0-.61,6.84,57,57,0,0,0,1.61,16.33,132.28,132.28,0,0,1-7.29,12.28,44.43,44.43,0,0,1-3.3,3.55h0"
                  transform="translate(2.38)"
                />
                <g class="cls3-131">
                  <image
                    class="cls3-33"
                    width="35"
                    height="104"
                    transform="translate(340.69 353.83) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACMAAABuCAYAAACtH6rrAAAACXBIWXMAAB9fAAAfXwGscuV3AAAAwklEQVRoQ+3asQ2EMBAF0TXanBKohS7ovxHTgEfOrB/Mix2MVuxxcDee+5sV4todOKmrYgaTNRljiDGkc3YpbDLGEGOIMcQYYgwxhhhDjCHGEGOIMcQY0tP3M2tdNXZnjkmbjNfMkjHEGBIV42qTqBjvTcQY4moTY0jUNeOHHvFnQWIMiVrtqMkYQ4whxhBjiDHEGGIMMYYYQ4whPlESn5uI72eIMSQqpoervWYMiYrxzzzEGGIMMYb4HZh0Vb27Q6f8sAESveRUcm8AAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M340.9,391.68c.6-.7,1.16-1.43,1.69-2.19h0a132.28,132.28,0,0,0,7.29-12.28h0c-1.48,6.73-6.41,12.07-9,14.44h0"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-30"
                  d="M349.77,351.67c.19-.65.39-1.29.62-1.92l.44-.87c-.29.75-.65,1.69-1.06,2.79"
                  transform="translate(2.38)"
                />
                <g class="cls3-132">
                  <rect
                    class="cls3-30"
                    x="352.14"
                    y="348.25"
                    width="1.43"
                    height="3.09"
                  />
                  <g class="cls3-133">
                    <image
                      class="cls3-33"
                      width="8"
                      height="8"
                      transform="matrix(0.68, 0, 0, -0.75, 350.71, 354.19)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAJCAYAAAAPU20uAAAACXBIWXMAABAlAAAQJQEuD214AAAAO0lEQVQYV2P8////fwY8gAmfJAMDAwMLjNFjnwMXLDk4Bc4maAJBBSwIJiNWBQRNIKiA8f///wfwKQAAmI4Kz9GroksAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M350.39,349.75c.37-1,.78-2,1.24-2.94,0,0-.3.76-.8,2.07l-.44.87"
                  transform="translate(2.38)"
                />
                <g class="cls3-134">
                  <image
                    class="cls3-33"
                    width="7"
                    height="11"
                    transform="translate(352.14 346.7) scale(0.4 0.42)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAMCAYAAACulacQAAAACXBIWXMAABuHAAAbhwHouLjtAAAAL0lEQVQYV2OU54/8z4ADMOGSoEyShYGBEackIZ04HUsrB7EwMDA44pJk/P8ft4MALOEF5JZ+45cAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M380.72,605.68s2.94,7.33,3.4,8.11,3.4,2.05,3.4,2.05-.92,22.29-.6,36.77c.27,12.9,7.41,58.13,7.41,58.13s-4.87-42.55-5.73-59.61,3.15-37.29,3.15-37.29l-5.51-7.34-1,6.58-4.53-7.37Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-135">
                  <rect
                    class="cls3-30"
                    x="382.17"
                    y="605.19"
                    width="14.3"
                    height="105.25"
                  />
                  <g class="cls3-136">
                    <image
                      class="cls3-33"
                      width="29"
                      height="146"
                      transform="matrix(0.66, 0, 0, -0.72, 380.81, 711.06)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAACfCAYAAAAF69LcAAAACXBIWXMAABDDAAAQwwHmNsGNAAABh0lEQVR4Xu3cwU3DQBCF4V1EYdRBCVyohQslUAeVZTnhXKJBQuP3HdbvFFkj/XozL7OJLXmutdbIaj7/fvp4/awK/6X3r7eH158eXj1Zh9M1Z1XXqjt0EGhO10xPlXaak3YqoDkmdyqgxmlV1iu8e017AfQWdIpnKtq7UZCCUBykfWYadIpnmjN6h45ge22QyI/t5Eayy2EYpzltONPk95TsXgIlRxuZ6ZXeU3VtpFNlT5mkU5teFKSqrFfaqYASp1VVs3B7CZTM1DjNibQXL3wzUwHNMblTAa2qmqWdCqhxmhNxinevCFLy/+mG7U2m10KTd8xwkER7SXp3Wg45HVD0XAZAbzkmdkqWA3pSXJX1ipwydqbJ9JLdS6DkaCMzxekl0KqqWTvOtKpqlnYqoEGndvdeQTpDO7aXQMlMjdOc9mmv3r05p6S9OL3GqYDmmNypgBqnVVmvtNMcVC/8nPaZqYUm74Li9Ir27pPeZJAOaJCp0xu0SoI011rffxU162XmXxo0xg8kUZBdl6e/SAAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M495.92,637.32c.24-.57.48-1.1.71-1.75-.23.6-.47,1.18-.71,1.75"
                  transform="translate(2.38)"
                />
                <g class="cls3-137">
                  <rect
                    class="cls3-30"
                    x="498.03"
                    y="636.14"
                    width="1.43"
                    height="1.55"
                  />
                  <g class="cls3-138">
                    <image
                      class="cls3-33"
                      width="8"
                      height="6"
                      transform="matrix(0.68, 0, 0, -0.75, 496.6, 639.06)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAACXBIWXMAABAlAAAQJQEuD214AAAAOUlEQVQIW2P8////fwY8gAmfJIqCa0c+MVw78glDAQuM8Z8Bu01wBQz//2FVwEjIkSwMDAwH8SkAAFj9Ed+VUZoLAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M500.72,623.69l-2-2.92c2.41-3.36,4.47-5.85,4.47-5.85s-.87,3.59-2.46,8.78"
                  transform="translate(2.38)"
                />
                <g class="cls3-139">
                  <image
                    class="cls3-33"
                    width="16"
                    height="25"
                    transform="translate(500.89 614.68) scale(0.37 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAYAAAC+aNwHAAAACXBIWXMAAB2uAAAdrgHrADpwAAAAV0lEQVQ4T92TwQ3AMAwCoWKVrJlFslJ2ajewH/eIUt4YYYO95n4F8HSEDrHdcUpgB1gg0v0rwBTCxqXAG/IUsABOAQvEp1fARcIOsMD5HvzgFyJpdKQKH1l5A2vYA1h9AAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M488.31,650.15q1.28-8.37,3.32-16.57c1-3.8,4.28-8.9,7.05-12.81l2,2.92c-1,3.42-2.4,7.53-4,11.77v.11c-.23.6-.47,1.18-.71,1.75a61.6,61.6,0,0,1-7.61,12.83"
                  transform="translate(2.38)"
                />
                <g class="cls3-140">
                  <image
                    class="cls3-33"
                    width="39"
                    height="80"
                    transform="translate(489.45 619.68) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACcAAABVCAYAAADKSf3/AAAACXBIWXMAAB9fAAAfXwGscuV3AAAA6klEQVRoQ+3YsRHDQAhEUdDQmHtyI67LzbiDcwnMkNwL2Jjgz64WJOXn/T2BqjKym7mmpxu4qTqwcxU0nMu2hRirXN905yJd7+hVYsfq+obHisPBbbULAafKP3PdyD3RztmFgDfJxjrWHv6p7FhlPvtCwGxwpoG3tRK+X3SsNBy951yy2E/DuegLUedx8egf1vb5kuHottJw9Jsw7hxsnQ3nouGFsGOF2XDnXDR9CSfM55KFXgiYTY91P6pnoguBO7fP3Ew03P4rmYo+X7ZzLpre1l3CQ9VZ52baCzFVRcarG7qliohfN3RLf9EfCGnSRL8oAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M394.37,710.69s-3.52,5.73-15.66,10.27a155.4,155.4,0,0,1-26,7.09s10.16-.83,25-3.57,18.87-8.26,18.87-8.26,0-3.86-2.25-5.48Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-141">
                  <rect
                    class="cls3-30"
                    x="355"
                    y="710.44"
                    width="44.34"
                    height="17.02"
                  />
                  <g class="cls3-142">
                    <image
                      class="cls3-33"
                      width="73"
                      height="27"
                      transform="matrix(0.67, 0, 0, -0.73, 353.57, 730.36)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAAAeCAYAAACLz4iQAAAACXBIWXMAABB0AAAQdAFKfdo/AAAAo0lEQVRoQ+3asQ3CQBBE0VkbQWEU4jqogDoohNJgHVjsJbA3Of9FlnzR19gWEpGZKXRCkpbZKRxOn4v79dGd+wu35/bzXoXKYFydCvVa6xJfEMrE82ZiUSZCmQhlqjrvhVAdFmUilIlQJkKZCGUaXz1CtUadC6E6/NYzjRmdWVSHUCbeUSYWZao6QagWizLxjjKxKBOhTMF/D6ZCOhYVk4OQtAM0fRkDKEBGFgAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M306.55,404.58s-3.68-21.11-9.07-30.21-15.1-29.78-15.1-29.78l-1.68-5.21s-.32-27.53,3.33-38.58c0,0-10.34,25.47-8.13,44.78l3.43.58s6.79,16.22,14.68,27.72,12.46,30.71,12.46,30.71Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-143">
                  <rect
                    class="cls3-30"
                    x="276.32"
                    y="300.26"
                    width="32.9"
                    height="103.7"
                  />
                  <g class="cls3-144">
                    <image
                      class="cls3-33"
                      width="58"
                      height="144"
                      transform="matrix(0.66, 0, 0, -0.72, 274.89, 405.03)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAACeCAYAAACM9HLuAAAACXBIWXMAABDDAAAQwwHmNsGNAAABHklEQVR4Xu3SMW7CQBBA0TX4silzIMocJAfDmwZLYBHoH/81Xs2OZX3Jy5xzDtuyH06vtjTrflgujxenOcd5buO8XW/PbazzOs7bdphfx/ps73be58ed/+bPvrHev3d3f5x//3wd+x6bXt5iilUVqypWVayqWFWxqmJVxaqKVRWrKlZVrKpYVbGqYlXFqopVFasqVlWsqlhVsapiVcWqilUVqypWVayqWFWxqmJVxaqKVRWrKlZVrKpYVbGqYlXFqopVFasqVlWsqlhVsapiVcWqilUVqypWVayqWFWxqmJVxaqKVRWrKlZVrKpYVbGqYlXFqopVFasqVlWsqlhVsapiVcWqilUVqypW9VGx6xjj992SYplzvtthfNRv/Ad+5mT6yYnARgAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M279.41,294.38s-1.55-4.67,2.09-10.54,28.55-28.95,42.72-33.29a137,137,0,0,1,28.91-5.09s-19.2-1.09-33.23,5.09-42.38,30.51-43.18,34.61,2.7,9.22,2.7,9.22Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-145">
                  <rect
                    class="cls3-30"
                    x="277.75"
                    y="244.54"
                    width="77.24"
                    height="49.53"
                  />
                  <g class="cls3-146">
                    <image
                      class="cls3-33"
                      width="122"
                      height="72"
                      transform="matrix(0.67, 0, 0, -0.72, 276.56, 295.52)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAABPCAYAAAAk7tH6AAAACXBIWXMAABCbAAAQmwF0iZxLAAABRklEQVR4Xu3UMZLCMBAF0S8VpyXhRKR7zB2ClQ0GGcfr7pd4ACGEu6BVVUVn1pKkH63SOVyWod3HtSotlVZJT6XVb9p4/u9x7c/j2l/nsdeyT6/azpt1z302r832G2fr6zxbd7zf+5795fuu75vM+/dg3Kud+/b1LLPPez/bOs/Pcvu5flaOv2gMQ0MYGsLQEIaGMDSEoSEMDWFoCENDGBrC0BCGhjA0hKEhDA1haAhDQxgawtAQhoYwNIShIQwNYWgIQ0MYGsLQEIaGMDSEoSEMDWFoCENDGBrC0BCGhjA0hKEhDA1haAhDQxgawtAQhoYwNIShIQwNYWgIQ0MYGsLQEIaGMDSEoSEMDWFoCENDGBrC0BCGhjA0hKEhDA1haAhDQxgawtAQhoYwNIShIQwNYWiIVlV1tEj/WkuSyzLo3PzrhngAoruwnKRn7yEAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M272.72,459.18S247,485.33,243.81,493.45s3.32,76.78,3.32,76.78-8.78-67.82-8-75.89,33.6-35.2,33.6-35.2Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-147">
                  <rect
                    class="cls3-30"
                    x="240.56"
                    y="459.69"
                    width="34.33"
                    height="111.45"
                  />
                  <g class="cls3-148">
                    <image
                      class="cls3-33"
                      width="58"
                      height="155"
                      transform="matrix(0.66, 0, 0, -0.72, 239.13, 570.94)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAACqCAYAAAATHzdVAAAACXBIWXMAABDDAAAQwwHmNsGNAAABOklEQVR4Xu3SQU6DUBRAUaAszO04dEEO3Ycbg++g1LS10bGn9ySEl59HyA3MY4wx2ebLsPy2pVkvw/x+vi9jTKexT8vYp3XfzvO+T6dxXMfZeX58thzz+j1vV7v73fPbzflyzOvY7t77c/fm/Oq9bx+vD2Of6ssWqypWVayqWFWxqmJVxaqKVRWrKlZVrKpYVbGqYlXFqopVFasqVlWsqlhVsapiVcWqilUVqypWVayqWFWxqmJVxaqKVRWrKlZVrKpYVbGqYlXFqopVFasqVlWsqlhVsapiVcWqilUVqypWVayqWFWxqmJVxaqKVRWrKlZVrKpYVbGqYlXFqopVFasqVlWsqlhVsapiVcWqilUVqypWVayqWFWxqmJVxaqKVRWreqrYeYzx+dfSP/dyGeYxxi97lqf6jb8AF6xwSwN8oyEAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M453,439.27h-.11l-4.63-.37-9.24-9c1.42-7.28,3-15,3.71-18.57a1.54,1.54,0,0,1,1.45-1.28h2.38a76,76,0,0,1,11.47.71,1.61,1.61,0,0,1,1.32,1.8c0,.06,0,.11,0,.16L454.46,438a1.53,1.53,0,0,1-1.47,1.3m-1.61-4.19c-.54,0-1.09.85-.61,1.82a5,5,0,0,0,1.45,1.63c1.1-.54,2.33-2.36,1.58-3.12a.62.62,0,0,0-.45-.21c-.48,0-.9.66-.9.66s-.53-.78-1.07-.78"
                  transform="translate(2.38)"
                />
                <g class="cls3-149">
                  <rect
                    class="cls3-30"
                    x="440.82"
                    y="410.16"
                    width="20.02"
                    height="29.41"
                  />
                  <g class="cls3-150">
                    <image
                      class="cls3-33"
                      width="37"
                      height="44"
                      transform="matrix(0.66, 0, 0, -0.72, 439.39, 440.87)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAwCAYAAACWhbMrAAAACXBIWXMAABCbAAAQmwF0iZxLAAAAiklEQVRYR+2ZsQ2AMAwEE8RK7MGo7MFQpgKJJlwDXPFXJZKL1/tlR0qvqmou+vRU8Qfzedj2Udm7rMv97naqiZKldEop6mqfaTDInRpVfYzSKaWoBJ2SoFPiFCWvBIpSVIYnJSOBkkxRlKLSPkpEUZSiEnRKdh8lmaLEKUpEUZIpilKUcs1049faAT6PJGM4F0fiAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M453,439.65h-.13l-4.18-.33-.43-.42,4.63.37H453a1.54,1.54,0,0,0,1.47-1.31l4.86-25.2a1.64,1.64,0,0,0-1.18-1.93H458a74.55,74.55,0,0,0-11.47-.7h-2.39a1.53,1.53,0,0,0-1.45,1.27c-.73,3.55-2.29,11.3-3.71,18.57l-.31-.3c1.42-7.22,3-14.83,3.66-18.36a1.94,1.94,0,0,1,1.8-1.58h2.46a77,77,0,0,1,11.45.71,2,2,0,0,1,1.59,2.29.5.5,0,0,0,0,.12l-4.83,25.22a1.89,1.89,0,0,1-1.82,1.61"
                  transform="translate(2.38)"
                />
                <g class="cls3-151">
                  <rect
                    class="cls3-30"
                    x="440.82"
                    y="410.16"
                    width="21.45"
                    height="29.41"
                  />
                  <g class="cls3-152">
                    <image
                      class="cls3-33"
                      width="37"
                      height="44"
                      transform="matrix(0.66, 0, 0, -0.72, 439.39, 440.87)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAwCAYAAACWhbMrAAAACXBIWXMAABCbAAAQmwF0iZxLAAAAh0lEQVRYR+2ZsQ2AMBDEEsS6zICYIQM/FaSDaxAu7OqLFKeL8016VVVj0Ze3E3+wXsM+no59z7HNmd1UA5mFbAoZ6r4+0O3ZVAyyKWQo91SKoqcYKmU6BZIK2RQylMszxeWZYlMpyFCuhBRFT0GGUvQURU+xqRRfX4pOpehUCjIUUvRO/Fo7ASd2HWx4eZaPAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M445.8,477.4h-.11L432,476.31a1.52,1.52,0,0,1-1.1-.65,1.74,1.74,0,0,1-.26-1.3c.69-3.66,1.52-7.87,2.32-11.86l12,11-.18.24s-.53-.78-1.07-.78-1.09.83-.6,1.81a4.76,4.76,0,0,0,1.45,1.63,3.77,3.77,0,0,0,1.63-1.78l1.21,1.09-.08.44a1.58,1.58,0,0,1-1.48,1.3"
                  transform="translate(2.38)"
                />
                <g class="cls3-153">
                  <rect
                    class="cls3-30"
                    x="432.24"
                    y="462.78"
                    width="17.16"
                    height="15.48"
                  />
                  <g class="cls3-154">
                    <image
                      class="cls3-33"
                      width="33"
                      height="24"
                      transform="matrix(0.66, 0, 0, -0.72, 430.81, 478.8)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAaCAYAAAA5WTUBAAAACXBIWXMAABCbAAAQmwF0iZxLAAAAZElEQVRIS2P8////f4aBBYxMhFTQA7DAGEdu4FNGHWCjgV18cIXEQCaMQRESg8IRiOgYwPgYDQkYGBQhMeoIGBgtrGBgUDhiNIvCwGjChIFB4YjRhAkD8JAYyJQ5KEKCcTB0fgCsoRYzHYmpCAAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M445.8,477.79h-.13l-13.74-1.1a1.79,1.79,0,0,1-1.35-.8,2.12,2.12,0,0,1-.33-1.61c.7-3.72,1.55-8,2.35-12.07l.32.28c-.8,4-1.63,8.2-2.32,11.85a1.76,1.76,0,0,0,.26,1.31,1.52,1.52,0,0,0,1.1.65l13.73,1.09h.11a1.57,1.57,0,0,0,1.48-1.29l.08-.44.31.29v.23a1.88,1.88,0,0,1-1.82,1.6"
                  transform="translate(2.38)"
                />
                <g class="cls3-155">
                  <rect
                    class="cls3-30"
                    x="432.24"
                    y="462.78"
                    width="17.16"
                    height="15.48"
                  />
                  <g class="cls3-154">
                    <image
                      class="cls3-33"
                      width="33"
                      height="25"
                      transform="matrix(0.66, 0, 0, -0.72, 430.81, 479.53)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAcCAYAAADvANYcAAAACXBIWXMAABCbAAAQmwF0iZxLAAAAbklEQVRIS+2XsQ3AIAwEbcSmbJBB2CCzmuqJaKBJ4i/+KpBcnN4vITwiwnLxcpr4g4pDv3dj73K19T4lMndCsQ5JAAqJp5iJzVQSgCIJSQAKCb0dYCaRGQVFEhQSKiZQMYE6AZzhB1bNzE9TXzMAhpgUPImjayMAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M470.48,460.49l-10.34-10a73.61,73.61,0,0,1,10.48.7,1.62,1.62,0,0,1,1.26,1.86s0,.05,0,.08l-1.41,7.38"
                  transform="translate(2.38)"
                />
                <g class="cls3-156">
                  <rect
                    class="cls3-30"
                    x="462.28"
                    y="450.4"
                    width="11.44"
                    height="9.29"
                  />
                  <g class="cls3-157">
                    <image
                      class="cls3-33"
                      width="24"
                      height="18"
                      transform="matrix(0.68, 0, 0, -0.75, 460.85, 462.24)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAACXBIWXMAABAlAAAQJQEuD214AAAAXUlEQVQ4T2P8////fwYaAiZCCigFLAwMDAx7LhNSRjxw0UXlszAwMDDQMpDoE0RD2gdD3wJIHBBSRQGgkw9o6AX6+ICWkUAfH9DQA8PAB4y0rtFYGBgYDhJSRAkAAFJNFOhDrTx1AAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M470.79,460.8l-.31-.31,1.41-7.38a1.64,1.64,0,0,0-1.18-1.93h-.07a73.61,73.61,0,0,0-10.48-.7l-.39-.39a75.3,75.3,0,0,1,10.92.71,2,2,0,0,1,1.59,2.28s0,.08,0,.12l-1.45,7.61"
                  transform="translate(2.38)"
                />
                <g class="cls3-158">
                  <rect
                    class="cls3-30"
                    x="462.28"
                    y="450.4"
                    width="12.87"
                    height="10.84"
                  />
                  <g class="cls3-159">
                    <image
                      class="cls3-33"
                      width="24"
                      height="18"
                      transform="matrix(0.68, 0, 0, -0.75, 460.85, 462.24)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAUCAYAAACXtf2DAAAACXBIWXMAABAlAAAQJQEuD214AAAAVElEQVQ4T2P8////fwYaAiZCCigFLDBG+0x8ykgDlekINtwCBhoFFP2CiEYeoL0PRi0gCGhuASIV0SgZjfqAIBj6FtC8LGKkdY3GwsDAcJCQIkoAAJbeEeePtr62AAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M482.07,416.4a161.31,161.31,0,0,0-20.31-2.13l.55-2.61h1.47a107.75,107.75,0,0,1,18.67,2.2l-.4,2.61"
                  transform="translate(2.38)"
                />
                <g class="cls3-160">
                  <rect
                    class="cls3-30"
                    x="465.14"
                    y="411.71"
                    width="20.02"
                    height="4.64"
                  />
                  <g class="cls3-161">
                    <image
                      class="cls3-33"
                      width="37"
                      height="10"
                      transform="matrix(0.66, 0, 0, -0.72, 462.28, 417.5)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAALCAYAAAD4OERFAAAACXBIWXMAABCbAAAQmwF0iZxLAAAAPklEQVQ4T2P8////f4bBBRiZCKkYCMACYyw5hE8ZbUGMHSp/UIbUoHQUPPoGU3IflCE16ihiwaB0FONgLNEBJM8MEZV1dYQAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <polyline
                  class="cls3-30"
                  points="480.77 420.7 463.52 418.55 463.99 415.93 481.41 418.12 480.77 420.7"
                />
                <g class="cls3-162">
                  <rect
                    class="cls3-30"
                    x="463.71"
                    y="416.36"
                    width="18.59"
                    height="4.64"
                  />
                  <g class="cls3-163">
                    <image
                      class="cls3-33"
                      width="33"
                      height="10"
                      transform="matrix(0.66, 0, 0, -0.72, 462.28, 422.13)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAALCAYAAADx0+Q/AAAACXBIWXMAABCbAAAQmwF0iZxLAAAAQUlEQVQ4T2P8////f4aBBYxMhFTQA7DAGMuP4FNGXRBpg8ofXCExkCljUITEoHAEIjrwqaIxGGQhMYBBwTgYSkwAYcsPEvun/98AAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M452.23,438.52a4.83,4.83,0,0,1-1.45-1.62c-.48-1,.07-1.82.61-1.82s1.07.78,1.07.78.42-.66.9-.66a.62.62,0,0,1,.45.21c.75.76-.48,2.58-1.58,3.11"
                  transform="translate(2.38)"
                />
                <g class="cls3-164">
                  <rect
                    class="cls3-30"
                    x="452.27"
                    y="434.93"
                    width="4.29"
                    height="3.09"
                  />
                  <g class="cls3-165">
                    <image
                      class="cls3-33"
                      width="12"
                      height="9"
                      transform="matrix(0.68, 0, 0, -0.75, 450.83, 440.07)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAACXBIWXMAABAlAAAQJQEuD214AAAAOklEQVQYV2P8////fwYSABMhBeiABcbo34RPGQNDoR+EJtkGkjXAnUSs10m2gWQNCCfhU4UEGEmNOAB99g0OnHWs4wAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M444.52,476.37a4.76,4.76,0,0,1-1.45-1.63c-.49-1,.06-1.81.6-1.81s1.07.78,1.07.78l.18-.24,1.23,1.09a3.75,3.75,0,0,1-1.63,1.79"
                  transform="translate(2.38)"
                />
                <g class="cls3-166">
                  <rect
                    class="cls3-30"
                    x="445.11"
                    y="473.62"
                    width="2.86"
                    height="3.09"
                  />
                  <g class="cls3-167">
                    <image
                      class="cls3-33"
                      width="12"
                      height="8"
                      transform="matrix(0.68, 0, 0, -0.75, 443.68, 478.02)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAJCAYAAAAGuM1UAAAACXBIWXMAABAlAAAQJQEuD214AAAANElEQVQYV2P8////fwYSABMhBeiABcaYtw+3oiQnBJt8GxiI9AnJNtBeA+P///8PEFKEDAAKxArNIbLFHgAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M462.79,499.34l-1-1.59h-.08c-.34,0-34.86-3.76-36.54-4.46,0,0-.09-.06-.14-.46a15.8,15.8,0,0,1,1-5.75h.29c3.55,0,36,3.29,37.35,3.8,1,.39,0,5.26-.82,8.49"
                  transform="translate(2.38)"
                />
                <g class="cls3-168">
                  <rect
                    class="cls3-30"
                    x="426.52"
                    y="487.55"
                    width="40.05"
                    height="12.38"
                  />
                  <g class="cls3-169">
                    <image
                      class="cls3-33"
                      width="66"
                      height="20"
                      transform="matrix(0.66, 0, 0, -0.72, 425.08, 500.64)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAWCAYAAAB0S0oJAAAACXBIWXMAABCbAAAQmwF0iZxLAAAAc0lEQVRYR+3VsQ2AMBBDUQcxCCuwAaOzASuwiWlMKJBIz/1XRdFVlnNptq3amiRNo6kq5vtwnB9TP7Mu7zsaEb0R1RcFjQiCiP40qr8NGhHPsqQRkPg+OxoR7IigEUEQwbIMGhEEEQQRBBHN9j4a+rlNki4i7hIrlU4JngAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M462.92,500.23l-1.34-2.12c-2.31-.24-34.86-3.77-36.56-4.48-.2-.08-.32-.35-.37-.82-.16-1.6.61-5.7,1.16-6.08a1.14,1.14,0,0,1,.52,0c2.52,0,13.21,1,18.13,1.52,8.6.86,17.61,1.87,19.14,2.2l.61.56c.73,1.82-.8,7.57-1.15,8.85l-.1.38M426.3,487.08h-.25a15.8,15.8,0,0,0-1,5.75c0,.4.14.45.14.46,1.68.7,36.2,4.38,36.54,4.46h.08l1,1.59c.86-3.23,1.78-8.1.82-8.49-1.33-.52-33.8-3.8-37.35-3.8"
                  transform="translate(2.38)"
                />
                <g class="cls3-170">
                  <rect
                    class="cls3-30"
                    x="426.52"
                    y="486"
                    width="40.05"
                    height="13.93"
                  />
                  <g class="cls3-171">
                    <image
                      class="cls3-33"
                      width="66"
                      height="22"
                      transform="matrix(0.66, 0, 0, -0.72, 425.08, 502.1)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAYCAYAAABOQSt5AAAACXBIWXMAABCbAAAQmwF0iZxLAAAAdUlEQVRYR+3YsQ2AMAxEUQexJgswEAswqCn4BKUJPf6vAsnV6ZIoaZmZUVuLiFi+pqpYn4/jnI39z76N/z2I6gvEpQGDgEHAIPBulrOpAmwEeiOqV8JGwCDgZgkbAe8asBEwCBgEDAIen7AR8K6B5nP+/Zx/ASa7EzDXgGgQAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <polyline
                  class="cls3-30"
                  points="477.46 464.98 477.46 464.97 477.46 464.97 477.46 464.98"
                />
                <g class="cls3-172">
                  <rect
                    class="cls3-30"
                    x="476.58"
                    y="464.34"
                    width="1.43"
                    height="1.55"
                  />
                  <g class="cls3-173">
                    <image
                      class="cls3-33"
                      width="8"
                      height="4"
                      transform="matrix(0.68, 0, 0, -0.75, 475.15, 467.3)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAACXBIWXMAABAlAAAQJQEuD214AAAAJUlEQVQIW2P8////fwY8gAmfJIqCHMPlWBUwErKChYGBgRGfAgD5CQlIY6RarAAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M468,494.45l-.89-.8c1.72-6.67,4.29-17.65,7-29.67l1,1h0L472,477.92a27.44,27.44,0,0,0-.75,3.1L468,494.44M429.3,459.2l-.43-.4,6.48-32.41.45.44c-2.11,9.87-4.42,21.53-6.5,32.37"
                  transform="translate(2.38)"
                />
                <g class="cls3-174">
                  <image
                    class="cls3-33"
                    width="138"
                    height="185"
                    transform="translate(430.81 426.07) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,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"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M467.07,493.65l-2.9-2.66a.9.9,0,0,0-.44-.5l-.17-.06L447.67,476l4.78-25a2.15,2.15,0,0,0-.31-1.57,1.75,1.75,0,0,0-1.26-.83,75.66,75.66,0,0,0-11.45-.72H437a1.92,1.92,0,0,0-1.79,1.58c-.53,2.61-1.52,7.5-2.58,12.81l-3.3-3c2.08-10.84,4.39-22.47,6.5-32.37l2.87,2.79c-.45,2.24-.88,4.47-1.26,6.5a2.14,2.14,0,0,0,.33,1.62,1.85,1.85,0,0,0,1.35.79l9.56.77,11.08,10.77h-3a1.94,1.94,0,0,0-1.8,1.58c-.93,4.62-3.28,16.28-4.92,24.88a2.12,2.12,0,0,0,.33,1.61,1.83,1.83,0,0,0,1.35.79l13.74,1.1h.13a1.9,1.9,0,0,0,1.82-1.62l3.38-17.64,3.28,3.18c-2.71,12.06-5.28,23-7,29.61"
                  transform="translate(2.38)"
                />
                <g class="cls3-175">
                  <image
                    class="cls3-33"
                    width="134"
                    height="182"
                    transform="translate(430.81 426.08) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,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"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M471.2,481a27.6,27.6,0,0,1,.75-3.11L471.2,481"
                  transform="translate(2.38)"
                />
                <g class="cls3-176">
                  <image
                    class="cls3-33"
                    width="5"
                    height="9"
                    transform="translate(472.29 477.14) scale(0.42 0.42)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAJCAYAAAD6reaeAAAACXBIWXMAABokAAAaJAFVr1UEAAAAJElEQVQIW2P8v2X7fwYYgLKYGLAAFgZGbIJYRLFqJ95M4rUDADXGBINuhZEFAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M448.21,438.89l-9.07-.73a1.48,1.48,0,0,1-1.1-.65,1.79,1.79,0,0,1-.27-1.3c.38-2,.8-4.1,1.23-6.29l9.24,9"
                  transform="translate(2.38)"
                />
                <g class="cls3-177">
                  <image
                    class="cls3-33"
                    width="34"
                    height="27"
                    transform="translate(439.39 428.74) scale(0.35 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAACXBIWXMAAB9fAAAfXwGscuV3AAAAk0lEQVRYR+2XSw6AMAhEgfT+F/MK3qVuNKl8jCTazoK3c5g0E4qt8rb3TgP3p7FA5JWMP/BdoqmdftE6sVFyOjvaC90GWQRMkBZ1fDYwHakgGtwg0ese4fmf1oj8uB1ZBUwQmAOtpSbzR2C2poJoYIYVpiMVRCPpD12P7BqOLplh/eJmjgDaGhAqiAYmCPfwr3suBwSfEv1xHeRmAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M448.65,439.27l-9.56-.77a1.85,1.85,0,0,1-1.35-.79,2.14,2.14,0,0,1-.33-1.62c.38-2,.81-4.26,1.26-6.51l.31.3c-.43,2.19-.85,4.32-1.23,6.29a1.8,1.8,0,0,0,.27,1.3,1.47,1.47,0,0,0,1.13.7l9.07.73.43.42"
                  transform="translate(2.38)"
                />
                <g class="cls3-178">
                  <image
                    class="cls3-33"
                    width="36"
                    height="29"
                    transform="translate(439.39 428.74) scale(0.35 0.38)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAgCAYAAAB6kdqOAAAACXBIWXMAAB9fAAAfXwGscuV3AAAAjklEQVRYR+2XSw6AIAxEB8P9L+IBXHsy3IgWAg4rLMm8hZ8ymJemITHsR0oA8F6AdN8zxXsjY/cWa53MUza5/LjBGRGBRebirkMSYkiIISFGdHYM+euQhBiLCNWT3pr80Yyt9/aY+iId+hEJMXRSMyTEGBKqzze2zuby63tDQjOREENCDHf/9hHAyUIzuQBWrBhrJSjuHQAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M447.36,475.67l-1.21-1.09a1.17,1.17,0,0,0-.06-1.34.6.6,0,0,0-.44-.2,1.08,1.08,0,0,0-.73.42l-12-11c1.06-5.39,2.07-10.36,2.6-13a1.57,1.57,0,0,1,1.46-1.27h2.36a74.68,74.68,0,0,1,11.48.71,1.48,1.48,0,0,1,1,.68,1.68,1.68,0,0,1,.24,1.26l-4.73,24.82"
                  transform="translate(2.38)"
                />
                <g class="cls3-179">
                  <image
                    class="cls3-33"
                    width="59"
                    height="75"
                    transform="translate(435.1 447.68) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADsAAABQCAYAAACnFg0qAAAACXBIWXMAAB9fAAAfXwGscuV3AAABjklEQVR4Xu2cXXLDIAyERccX6/1fe4MehDzEpHaMJGS7nbLabyZ5YBFmLRN+PJPy9V2riMjze099fQW1XltKXVOrx0tc6dNHX3pS1k9U62HVjWhn+1TEMYvGj1nrlmhEYorotz6aKi+FSkyqzC6RcTc7qTJLs6jQ7FXunDE0vLZ6/IrZ/wrNosJFBSpL6CdwclJllmZRoVlUUpkdW1QUUY8oVS0as+3IqPbeeU1by1NllmZRmcKst1EfPSiYwuxd0CwqqbZ4Y4sKEFI9xjSLysvsmYm7aRpn2zt7rV7stnyfWa+1qOb1/K+0tTznY5wBzrOopFoupsoszaJCs6ikMptqUcF5FpVUZhevwghtJGgv8+7U3kdd5AViqszSLCqxMasNhqaJol+J87TGwBv5VIuKVI8xzaISMmudT1/BatO7nnMuviNkdnZoFhWaRYVmUUllNtWBG3c9qNAsKgezV3Y2VqzXphc7Eq+VN+14BmWdFzVdjDpa/LY3Ud2L3dYx2l5E5LMjQ1Kq9d9FYDwAf484DHTTrUwAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M447.67,476l-.31-.29,4.73-24.82a1.68,1.68,0,0,0-.24-1.26,1.45,1.45,0,0,0-1-.68,74.68,74.68,0,0,0-11.48-.71H437a1.54,1.54,0,0,0-1.45,1.27c-.54,2.65-1.55,7.62-2.61,13l-.32-.28c1.06-5.31,2-10.2,2.58-12.81a1.92,1.92,0,0,1,1.79-1.58h2.46a75.66,75.66,0,0,1,11.45.72,1.75,1.75,0,0,1,1.26.83,2.15,2.15,0,0,1,.31,1.57l-4.78,25"
                  transform="translate(2.38)"
                />
                <g class="cls3-180">
                  <image
                    class="cls3-33"
                    width="61"
                    height="76"
                    transform="translate(435.1 447.87) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAABRCAYAAABhVK7IAAAACXBIWXMAAB9fAAAfXwGscuV3AAABOUlEQVR4Xu2cYQ6CMAxGO+P9D+MFPNr8IRNWVzYwJMj73h83WkqeM5EOY3o8c7ZsZmbvl2lseR7OwTrnE185x+c052VcnRzkuJi/ZlUjOOdmQO6pl3FBmCttwKVGrrSkKUiaAlJaNycUJE1B0hTUcFBYle59CNJgTi+eGmOf0xovj63V8Me00hQkTSFuOJLVG8p+3qIUK3kpGLfmvZyo9lKgzDvXRK60pClImoKkKSCltRtKQdIUkNLaGKSgrywKkqZwSulo0380XnIiTil9NJKmIGkKSGk1HBSQ0uqyKEiawj5p3+a0fsO0BV9rtHYUS8F4mu+T/nMkTQEprZsTCpKmIGkKkqaAlNbG4Ai9h2d74733vle35Ph5q2vdLH0FJE1BXdYhjOxp/RqLcoO846VPSMpffwJ2fV6SfDZT/HeD6AAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M465.58,479.66h-.1l-13.73-1.09a1.59,1.59,0,0,1-1.39-1.75,1.23,1.23,0,0,1,0-.19c1.64-8.59,4-20.26,4.94-24.87a1.53,1.53,0,0,1,1.45-1.27h3.37l10.34,10-3.42,17.88a1.57,1.57,0,0,1-1.48,1.31m-1.49-4.25h0c-.54,0-1.1.85-.6,1.82a4.78,4.78,0,0,0,1.45,1.64c1.09-.54,2.32-2.36,1.57-3.13a.62.62,0,0,0-.45-.21c-.49,0-.9.66-.9.66s-.54-.78-1.07-.78"
                  transform="translate(2.38)"
                />
                <g class="cls3-181">
                  <image
                    class="cls3-33"
                    width="62"
                    height="79"
                    transform="translate(452.27 450.96) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAABUCAYAAADaroR4AAAACXBIWXMAAB9fAAAfXwGscuV3AAABeElEQVR4Xu2cQRLCIBAEweL/P/MFPgYvwSIRdpdEPdjTB8swQJyCALta5vuj1rRRXy/v1En5SNtdzrRBfzNt9rncvow2t3eJAdZ46S9yms70JS13749tItpq+YrWyrEjLuM0Sv8skMCOONZ4SdC5jh1xGach4zSwxkuOhlZnQiFLO26j3r1G266nzbbqCh5xGaexy8CkNM92nNUij3+0TXRZsDQlG70K/wo2OlMGhoaM08AaL784LHjap/uztFZedlerrb+pNd2IsK5o2KmONa4DDA2scWyQgh1xGaeBNY7dx7Wq08Aa/8pPOvvynqtxdrS/oz7SsCMu4zSwxvfflkZXD2s1Ouqrq87Z1cy7Z6uzadiTG3aqyziNj/8UZKa3Ol7blObrVPSEF9GxIy7jNGSchozTULKRhqIzGjJOo3gRkxf1jOpciaisOtEoLqKXsMMrd/lFjs7KszW6OtipjjWufZwG1jg2SNEzTkPGaWCN52r9J+Ef8wQFWHB91zsDqAAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M465.59,480.06h-.13L451.72,479a1.77,1.77,0,0,1-1.35-.79,2.12,2.12,0,0,1-.33-1.61c1.64-8.6,4-20.26,4.92-24.88a1.92,1.92,0,0,1,1.8-1.57h3l.39.38H456.8a1.53,1.53,0,0,0-1.45,1.27c-.94,4.61-3.3,16.28-4.94,24.87a1.63,1.63,0,0,0,1.19,1.91l.18,0,13.73,1.09h.1a1.55,1.55,0,0,0,1.48-1.3l3.42-17.88.31.31-3.38,17.65a1.89,1.89,0,0,1-1.82,1.61"
                  transform="translate(2.38)"
                />
                <g class="cls3-182">
                  <image
                    class="cls3-33"
                    width="64"
                    height="81"
                    transform="translate(452.27 449.41) scale(0.35 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABWCAYAAAB/5pBYAAAACXBIWXMAAB9fAAAfXwGscuV3AAABo0lEQVR4Xu2bwVLDMAxE1538/4Gf4Mofpoc2oKiy11xXuwdA0rNhdoRrZSbj++c8AeD19a3z9u0vTkwMb3EonDFOa9jvvK2NuSre+Zvf+cg80FztDTgGI8TVvgNsAAPUZQMYoK72Bhxo/jnoDhh43Y2vRohX55wbqOsXM9tjFuf1MRf3m9VjfOVYDNz3aN8BNoAB6mpvwDHiKbg67fIpNzuN8l5XbXVCsdOLMTvrs95M+w6wAQxQlw1ggLpsAAPU5afCDFCXDWCAumwAA9Tlh6IMUFd7A3wRYoC6bAAD1PVhADsTxiaT47iu2iPnduoVw+K8hzuAAeqyAQxQl2cBBqirvQGeBRigLhvAAHXZAAD1lLKaTlZTSV6/2m+3tsOwWhUPd4ANsAEMUJdvggxQlw1ggLpsAAPUZQMYoC4/FGWAuh4APppgNV3GHIur5sr7VvXZlFvlVtNuFccc4A6wAe0NaD8NHr8/DdRvjV0O/fetsUu7b3fNajvMTg012/5fwAYwQF02gAHqam9A+3tA+w6wAQxQlw1ggLraG3Bg4ItBynoCgs1a84qZ7LsAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M446.19,474.58l-1.23-1.1a1.12,1.12,0,0,1,.73-.42.69.69,0,0,1,.44.2,1.17,1.17,0,0,1,.06,1.34"
                  transform="translate(2.38)"
                />
                <g class="cls3-183">
                  <image
                    class="cls3-33"
                    width="7"
                    height="7"
                    transform="translate(446.54 472.07) scale(0.4 0.44)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAYAAAA1BOUGAAAACXBIWXMAABuHAAAbhwHouLjtAAAAKklEQVQIW2Pce+H/fwYY+I9CMTAx4AEsDIx4JPHI4TeWfEkWBgaGg7gkAfcmBmIO1+UZAAAAAElFTkSuQmCC"
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M464.94,478.91a4.78,4.78,0,0,1-1.45-1.64c-.5-1,.06-1.82.6-1.82h0c.53,0,1.07.78,1.07.78s.41-.66.9-.66a.62.62,0,0,1,.45.21c.75.77-.48,2.59-1.57,3.13"
                  transform="translate(2.38)"
                />
                <g class="cls3-184">
                  <image
                    class="cls3-33"
                    width="16"
                    height="14"
                    transform="translate(465.35 475.17) scale(0.34 0.37)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAACBLAAAgSwFrhwW5AAAAW0lEQVQ4T2Pccuz/fwYoQLAQAEPsPwMDshATA4WAhYGRkBL8gGIXUGwAC4U+oNwFA28AIhr/MzCgRCkstaCLoQUaiguwBSgjFnFkPsVeGHgDGP9jy4IkAIpdAAB4KQ+bnw7a0QAAAABJRU5ErkJggg=="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M464.17,491l-.61-.56.17.06a.9.9,0,0,1,.44.5"
                  transform="translate(2.38)"
                />
                <g class="cls3-185">
                  <image
                    class="cls3-33"
                    width="5"
                    height="6"
                    transform="translate(465.49 489.11) scale(0.29 0.32)"
                    xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAHCAYAAADAp4fuAAAACXBIWXMAACbBAAAmwQFynQtOAAAAIElEQVQIW2Ncteb///8MUABlMDFgAcQLMiKZCAfEawcArP0IXOqr9EIAAAAASUVORK5CYII="
                  />
                </g>
                <path
                  class="cls3-30"
                  d="M480.44,377.11a2,2,0,0,1-.49-.06c-2.83-.8-1.07-12.63-2.12-23.68s-1-25.39,8.2-25.83h.26c6.59,0,12.51,11.79,9.93,27.35-2.46,15-12.36,22.22-15.78,22.22m7.42-37.84c-3,0-5.3,1.73-6.7,5.06-2.37,5.63-1.44,14.51,1,17.29a4.25,4.25,0,0,0,3.18,1.47,4.74,4.74,0,0,0,1.35-.2c2.4-.7,5.39-3.42,6.62-8.94.94-4.19.09-9.6-2-12.57a4.27,4.27,0,0,0-3.11-2.11h-.38"
                  transform="translate(2.38)"
                />
                <g class="cls3-186">
                  <rect
                    class="cls3-30"
                    x="479.44"
                    y="328.13"
                    width="21.45"
                    height="49.53"
                  />
                  <g class="cls3-187">
                    <image
                      class="cls3-33"
                      width="42"
                      height="71"
                      transform="matrix(0.65, 0, 0, -0.71, 476.58, 377.7)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAABOCAYAAABWpoQXAAAACXBIWXMAABESAAAREgEAwpvaAAABmElEQVRoQ+2bOxLCMAxEZYaSY1Bw/9NQcAx60xBgAk70XdkJr2MItnYlWUlmKLXWSn1TiIiO06fb9d6+FMT5cmp+d6RsmPn8HSjzx0jegSKCq2XtiiYfgeoXQXBYu6AXYpvJsZywNWrA19FAsTtxFHhS5B1Pwgx+OypcAAWuRo3r4wI1YmumJZyFCxwFN9uMEWe90bHVjNgQpD4XfTOBhW3QUbUQY+0/yZv1E0wD2o4yF0CBr1HlPvhAlfCbSYuTAUJHkxqONj/rWe77Ikx9Hrxm6kBErqOCPUHvRwX13wA76w0G5KZeAK+ZlBRH8a9APReNwNfRQLEBNRrTlLoRSuQojMeANyVgh6TwmylZSL6jzH07egpdbmaGo8LTgChEJPamxAC/mZYIcHAOI/V9oHM0QVSgo741z5v17iLk/Gc9C8GeoKdQO1hHDXtgAzXAPEeVR42j+J3N+glHB+dsrUYbAMXlOSrsiW9HhQugGHHWBztpLK28GhVi6/olnIXv0NHgGsc1kxG9o+BSKSP9BaPvnD8ZZjI9AJGaW+z8uz4jAAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M485.35,362.58a3.71,3.71,0,0,1-2.85-1.33c-2.36-2.67-3.24-11.29-.93-16.78.93-2.19,2.77-4.79,6.28-4.79h.39A3.82,3.82,0,0,1,491,341.6c2,2.87,2.8,8.12,1.9,12.18-1,4.39-3.46,7.77-6.32,8.6a4.14,4.14,0,0,1-1.26.19m-1.52-14.26a2.06,2.06,0,0,0-1.43.68,2.28,2.28,0,0,0-.67,1.7c0,2.72,3.71,6.41,3.87,6.58l.09.09h.12c.19-.07,4.62-1.62,5.49-4.94a3,3,0,0,0-.38-2.83,2.32,2.32,0,0,0-1.74-.8h-.37a4,4,0,0,0-2.38,1.85c-.34-.66-1.15-2-2.26-2.26h-.34m2,8.5c-.58-.58-3.64-3.83-3.64-6.12a1.8,1.8,0,0,1,.52-1.36,1.67,1.67,0,0,1,1.15-.56h.25c1.24.27,2.13,2.34,2.14,2.37l.17.41.2-.39a4,4,0,0,1,2.29-2h.3a2,2,0,0,1,1.43.65,2.65,2.65,0,0,1,.27,2.4c-.72,2.79-4.38,4.31-5.08,4.58"
                  transform="translate(2.38)"
                />
                <g class="cls3-188">
                  <rect
                    class="cls3-30"
                    x="482.3"
                    y="338.97"
                    width="14.3"
                    height="23.22"
                  />
                  <g class="cls3-189">
                    <image
                      class="cls3-33"
                      width="29"
                      height="36"
                      transform="matrix(0.65, 0, 0, -0.7, 479.71, 364.51)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAnCAYAAADzckPEAAAACXBIWXMAABESAAAREgEAwpvaAAAAyklEQVRYR+WYSw6DMAxE4yob7kZP296NpVkBaZGTIdiMEG8VgZEz9uQjRFU1XYu8WhER5GXw+U61uG7e47B7lreh7F5GsSW9sLOUnlKSFj2t4Fx6Sk8xpT+cd3nfkjlZlbuU94+Oyd5UaYliviiUYh80ASpGKW/oNiiGkFWpFRBBqFILSlKKkfyXDAClvM9JWt97g8wFuNffYNjNwVkxoLQAiQE4ltQJ30M8JWjy5CUDzPAYtjEx9/bSOsT9ldpQkgrjR0dOIc2sMwM0TSVwLJCtugAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M485.37,363a4.18,4.18,0,0,1-3.18-1.47c-2.45-2.77-3.38-11.66-1-17.28,1.4-3.29,3.71-5.06,6.7-5.06h.38a4.24,4.24,0,0,1,3.11,2.11c2,3,2.91,8.38,2,12.57-1.23,5.48-4.22,8.23-6.62,8.93a4.74,4.74,0,0,1-1.35.2m2.48-23.36c-3.51,0-5.35,2.59-6.28,4.79-2.31,5.49-1.43,14.11.93,16.78a3.71,3.71,0,0,0,2.85,1.33,4.14,4.14,0,0,0,1.26-.19c2.86-.83,5.34-4.21,6.32-8.59.9-4.07.09-9.32-1.9-12.19a3.82,3.82,0,0,0-2.79-1.92h-.39"
                  transform="translate(2.38)"
                />
                <g class="cls3-190">
                  <rect
                    class="cls3-30"
                    x="480.87"
                    y="338.97"
                    width="15.73"
                    height="23.22"
                  />
                  <g class="cls3-191">
                    <image
                      class="cls3-33"
                      width="29"
                      height="37"
                      transform="matrix(0.65, 0, 0, -0.7, 479.7, 363.7)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAApCAYAAADJeCK0AAAACXBIWXMAABESAAAREgEAwpvaAAAAwUlEQVRYR+WYvQ7CMAyEbdSBl0YI8dAdzURokBubxM5R+KYiRTrupxnKIiI0Fz5ZJzJYng+3+9o6NwjT9XIuv4ooESuHc3iJTmwW0ilEdNOpQWD8kE79TivGlt7/ygwkc6R43/jwDx/YaYW9jf4htTBS+5V4a7T8imhguCaQCx8iCh6SzGsVEu//iLYvh6RxOdcbOzL/hR/o2uk0li8cUi9GamCnKZ3q4/SvtxfFTLJTHUinEFFGfF1ZKG1B+0DifQAXEx55t/BcUwAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M456.32,373.68a11.5,11.5,0,0,1-9.11-4.61,11,11,0,0,1-1.64-3.68c4.52-11.76,3.32-19.89.93-24.28a17.16,17.16,0,0,1,5.15-7.88,12.57,12.57,0,0,1,7.65-3c8.05,0,14.1,10.62,10.45,30.18-1.65,8.88-7.59,13.28-13.38,13.28m2.16-34.34a7.34,7.34,0,0,0-5.38,2.84,16.47,16.47,0,0,0-3.71,11.75c.4,4.51,2,7.92,4.6,9.58a6.32,6.32,0,0,0,3.49,1.1,6.57,6.57,0,0,0,2.69-.58c4.84-2.19,7.33-10.54,6.34-16.61-.81-4.93-3.66-7.86-7.81-8h-.22"
                  transform="translate(2.38)"
                />
                <g class="cls3-192">
                  <rect
                    class="cls3-30"
                    x="447.97"
                    y="329.68"
                    width="27.17"
                    height="43.33"
                  />
                  <g class="cls3-193">
                    <image
                      class="cls3-33"
                      width="49"
                      height="62"
                      transform="matrix(0.67, 0, 0, -0.73, 446.54, 375.27)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAABECAYAAADDRGZtAAAACXBIWXMAABB0AAAQdAFKfdo/AAACLUlEQVRoQ+1aMXLDMAyDe9n6jY59RJ/eZ3ToM7qrS5LatESCtCTLumLKBRYJigJPzmVJKSVcGwsAvFhPXQW3x4fvrx/tOT+0PqdF4coUEvD2/pqlbqiBRqI9iBXSW7gW8w6ukGiS2sKVNfOZfYPIbgFdOyDxV0hp0QjCiYK2HRlBtMUVsOqISBhNVFv4k9Mnl320TK6jcGVdPbNT4jTOJ1zC7khN4VHRREGc2aNJGgqXyJs9mqSF8Gpmjyah1mmcL+be7A2ScJwzpsCEd61c9aXdonZY45y7T3QmU0jFJC1iFrDyyP/UQhfhRpfGnVrO41XuyCiiyYLOMTu1xsf1MTu1xuLOMDu1xuIcMVHL7NQa7XtHvAL8Zo+I3nF8zIUsaua7Fr9bPMfHVDugcPupFQzUR3h5cpG3X4vrINzwinhnLzw1mOgc8h0ZSThZ1CGzdxeucC6zny88aPZzhdsbu8azkHNFA5Rw7mitcAHhEoWjNaBwo6gJ71rVd6x2PCA8tXyJDOGuWIAZT8B+Q8xyRBI3dyymb2oFk7QQLqFPrWiSFsKNorZmjwbqJjxidpdpG4omj5dt9mgSN3csJvlz0LEkTWIKTGP2Sa8o0R2p3YHi996p5U5+QLTGEX8BfGCgqQVduOGRE6cWDgmX6Di1EBdOFNXO7C1Etzc7uguXCJod/YXXMTviSRoJl1Buv8EknYRLrAopJBlQdA4z3rXuuEgHJJaU0qf10OD4AIBf9pWFFoBu2JQAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M466.25,390.76c-1.53-1.95-2.19-11.57,1.12-14.36,4.75-4,11.08.71,8.31,11.17C474.31,392.69,468.63,393.81,466.25,390.76Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-194">
                  <rect
                    class="cls3-30"
                    x="466.57"
                    y="373.01"
                    width="14.3"
                    height="21.67"
                  />
                  <g class="cls3-195">
                    <image
                      class="cls3-33"
                      width="29"
                      height="32"
                      transform="matrix(0.66, 0, 0, -0.72, 465.14, 394.83)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB0AAAAjCAYAAABo4wHSAAAACXBIWXMAABCbAAAQmwF0iZxLAAABFklEQVRIS92WMRLCMAwEz0w6vkHFK3g6z6DgGdQRVYgjyzo5cQjDVR5Lo/NKHidJRATfVTqxjD00TIvn4+XlxZX3TRIu13ORMmCrlIm5r9Ruapks9oy4EjeditQo2CEMHXuRAMTmw8ia2jsSE3YIAYBYe2dTASctzHqRVgsArkkfUqAowuLF+m9Ja3GldlIW1/uGOGmDSarlKm0itU2SawjUSCsFShM2U1suqWnidgKIfN4OfvAlI6vNZw25oY9pGgFehMURam9GmhVkpCyu10rZRQIWRcwCAZMmUvN7ujepntnvksI2cSiBZlLMJiyu9zP5pOy/yMtxpN7eBpOggaV1pBsVI+2sgx/8vL07K4nInSV11u0N2LDb6qBeSl0AAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M457.48,364.07a6,6,0,0,1-3.26-1c-2.43-1.58-4-4.86-4.37-9.21a16.13,16.13,0,0,1,3.59-11.32,6.88,6.88,0,0,1,5-2.68h.21c5.37.22,6.92,4.87,7.37,7.62,1,5.88-1.42,14-6,16.06a6.12,6.12,0,0,1-2.52.55m-2.87-13-.48.35,3.66,5.82,6.05-7.43-.44-.42-5.5,6.83-3.25-5.15"
                  transform="translate(2.38)"
                />
                <g class="cls3-196">
                  <rect
                    class="cls3-30"
                    x="452.27"
                    y="338.97"
                    width="17.16"
                    height="24.77"
                  />
                  <g class="cls3-197">
                    <image
                      class="cls3-33"
                      width="33"
                      height="36"
                      transform="matrix(0.66, 0, 0, -0.72, 450.83, 365.3)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAnCAYAAACBvSFyAAAACXBIWXMAABCbAAAQmwF0iZxLAAABJklEQVRYR82YSw7CMAxEHcSGsyFOy4qLsQ0LSptO0sxYdUrfqlIsP8d1vynnnO2/pAuLOILr7+D5en8PsC9VnxJZB2D9cb9VIXMRc3CwlMZbVUS0UMu3FGHpMClyrsFsVj1o50hxOmyMVIhZd2KvlK1jvomiCKfQTIjRcvZnAqExmhRZzwRCkziltBOdoIUYKdI5HcFCnLmC9R2zhCZl63o+fTDpui5FtgeTJXFKU0wn4qTIyR5gJdG7Juvt23a0tHN5mokzES1FmqdjtBSZi+iKg6VI3YloIeuqNV/5o6U83/ZLjQqTujqh4pXuLmKAsAV5qQmQCjG+z0AhId1Ig7M9wNKYnQs5yMdPA69UyOn7Ft0r3Fgfe3WwfBOxV4coRdIZ/t59AND1ikKr+Vy7AAAAAElFTkSuQmCC"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M457.48,364.57a6.48,6.48,0,0,1-3.49-1.1c-2.57-1.67-4.2-5.08-4.6-9.59a16.44,16.44,0,0,1,3.71-11.74,7.37,7.37,0,0,1,5.38-2.87h.22c4.15.18,7,3.11,7.81,8,1,6.07-1.5,14.46-6.34,16.61a6.57,6.57,0,0,1-2.69.58m1-24.73a6.92,6.92,0,0,0-5,2.68,16.16,16.16,0,0,0-3.59,11.37c.38,4.38,1.94,7.67,4.37,9.2a5.89,5.89,0,0,0,3.26,1,6.12,6.12,0,0,0,2.52-.55c4.63-2.06,7.05-10.18,6-16.06-.45-2.75-2-7.4-7.37-7.62h-.21"
                  transform="translate(2.38)"
                />
                <g class="cls3-198">
                  <rect
                    class="cls3-30"
                    x="450.83"
                    y="338.97"
                    width="18.59"
                    height="24.77"
                  />
                  <g class="cls3-199">
                    <image
                      class="cls3-33"
                      width="33"
                      height="38"
                      transform="matrix(0.66, 0, 0, -0.72, 449.4, 366.77)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAqCAYAAAA9IzKsAAAACXBIWXMAABCbAAAQmwF0iZxLAAABPUlEQVRYR82YwRLCIAxEF8eLH+04Xvxkr3hRtAtkkwFq92SHdF8SUuk05Zwz/qt0UhF76Pz5cX88+1GyV2l7qeIzcLteymVJgoNsxaGWvkmYgXOh7NfoxFpgK/5Yg1kyVpWpdUflLD0T0iQO5Zh6JqTJOJSlOxGFqnX2Q9WJIBBwxGjP7WBKQzhiNJSlt0OaBKF2J/pBW41DWaITs4H1UAKjg6nWnX6xwVTrTijL3g5pEoO2N+N4BxhkJbMqZxnbMRlo3F8f5R/Nhub+Hfof862ZUFb7RRdroayShLT4hQ4AAVQF+F75J0P7b9sLK1VD/5PEADgIZXUH09QglKWTmAwE4BjMHaDsebADrGS7vnJjO1IzwKUglOU+OzYahLL2fzoa8eufDuWHFYPpgLLGBzMKbfinI3zHPEOmvl4v3Bh1a+GvyqUAAAAASUVORK5CYII="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M433.57,322.65c-7.78,0-12.84-3.12-14.1-6.38-1.59-4,3.85-14.4,17.65-21.34-1.25,1.45-4.87,6-4,9.16.37,1.41,1.54,2.37,3.48,2.85a9.13,9.13,0,0,0,2,.23c4.58,0,10.35-3.29,16.41-6.65a79.19,79.19,0,0,1,12.35-6c12-4.05,19.82-4.39,19.9-4.39h.83c9.93,2.71,13.75,7.07,13.75,7.07h-.34c-16.33,0-26.87,8.23-46.41,19.1-8.39,4.67-15.68,6.38-21.46,6.38M446.44,291a70.5,70.5,0,0,1,11.26-2.38A80.83,80.83,0,0,0,446.44,291m33-2.8c-2.59-.26-5.7-.45-9.21-.45-1.39,0-2.84,0-4.34.1,1.68-.09,3.31-.14,4.86-.14a74.33,74.33,0,0,1,8.69.49"
                  transform="translate(2.38)"
                />
                <g class="cls3-200">
                  <rect
                    class="cls3-30"
                    x="419.36"
                    y="287.88"
                    width="84.4"
                    height="34.06"
                  />
                  <g class="cls3-201">
                    <image
                      class="cls3-33"
                      width="130"
                      height="52"
                      transform="matrix(0.66, 0, 0, -0.72, 419.87, 324.08)"
                      xlinkHref="data:image/png;base64,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"
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M408,399.6a11.62,11.62,0,0,1-3.26-.46c-9.06-2.73-11.87-17.19-5.81-35.87,5.18-16,23.46-28.08,36.26-28.08,3.92,0,7.33,1.1,9.67,3.64a11.17,11.17,0,0,1,1.58,2.2c2.39,4.39,3.59,12.52-.93,24.28-.48,1.23-1,2.48-1.6,3.79-6.42,13.93-23.83,30.45-35.89,30.45m19.56-56.24c-4.23,0-8.95,1.89-13.24,5.4-6.78,5.53-11,13.93-11,21.87,0,5.21,2.13,9.53,5.68,11.57a10.15,10.15,0,0,0,5.14,1.34c3.38,0,7.17-1.46,11.08-4.33,8.59-6.26,14.33-18,13.1-26.66a9.86,9.86,0,0,0-7.06-8.65,12.36,12.36,0,0,0-3.72-.54"
                  transform="translate(2.38)"
                />
                <g class="cls3-202">
                  <rect
                    class="cls3-30"
                    x="395.04"
                    y="334.32"
                    width="57.22"
                    height="65.01"
                  />
                  <g class="cls3-203">
                    <image
                      class="cls3-33"
                      width="93"
                      height="90"
                      transform="matrix(0.67, 0, 0, -0.73, 393.61, 400.83)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF4AAABjCAYAAAASNrcdAAAACXBIWXMAABB0AAAQdAFKfdo/AAAJ9ElEQVR4Xu1cW7YjKQ4M+tRGem3z35uZNczOeh85HyAQeiGwfW1fWx958hEpUCgQln2rynVdF772k1YA4K8V6muPsT908r///ttvXuKMr4lLPWW4AVN3+NmnLLH//PO3+6wTX+oKwIWrnaGflTISYOGAggtgT+i89ARwn+P8U1KgjRGPRlhAbKEnQLk4zTCInRMgfcqxPs3+jNPC9DlIqdeGYsucABdn+Kzn1lifk4Lv5vokm0rNqNXz1ujVf1I+4Nf/vk9MCh936P7k8wOUP22ug7B5s6TjSf1XuP4kqv+/v/iwGr8g1klARaBd79f/eFX93vovSo0MlhPhJ2DG7ZUhf1XNY+l0v7eJUiODtQjLl6H+xo19wG/cB0SpqcdtYhe47rPQE9yhD3jvIhR2rlJxS2INnMSe7AN09MrQO6Yg7Fzpfp7YbLmaEwDg4z6OJjpXq+YSylsFWRzDFnqCj/g4GjZQgFZRrMSIMBtXEWjX+2UoXlVaQK9iRqlBP0YqyhA7Y7M4nQBcHrH5fUCn+7n2/a7mSSZqfLXL0Ei0fD1F2z7y9T+7AUuf3pwmn09W/qJzvabr1fI9IXa84eO6z0JP8PZ9wCC+MHW0eXhBrFSklZgk1sBJ7MkGTEdPQM9Igd25NmUVlQAeXE5FVrJ8YrPlak4AgLfrA0TnKpZnaUH0BGh1ZFXkB2sRli9XHVvoCbb7ABohEtC9TXycdJZnaecXV+ItZWggbilDbn3fKEN8Tho3xrp3CoxSU89MdWzsA3THU9E+sdlypROAy07qzj6gZ3WbmV+S1Wu0a4fY0oJQCeA+ciraIzZfhrL7gPTpzWny2aM8M/dLMiCpjtLOL3G/e8ir6ITY8YaP6z4LPcHTP44aDdRJsMBOGVqpSBG2mFOEk1hZhjL7AB09AZ2kwGigZI5XwXJcu1+aJ5UA7iOnIitZPrEaB4Y9KUOu0MRYk88+e9++39U8yZw/76imS8B6WXJFoDRcV75eltnl66vMUurBPlHoCe7aB3hm/nkHEBPLsam6WNr5C/YBnCBefngCJNYVGrRPz1TnCsTqMImFHNBRx+YGDHPsPWIrIsYRVo11Yx8Qmepc6/kJsVawPrEozadKAB/LChYCuUvsXhmiBAA46AN8W3SuqyAsYnM4ELY0/7+wD4hMda6ApQ4e7EIdiWA1DtgtQ+t9QGOXxBo4iZVlKNoHIlOdaz2XkztRET1ZBctx7X5pnlQC5jlJnxI3UFliD4S2LEO2bXeueRVxIvbKUCe2NFxPAPcRlyGNQ0esiT0QWqEnmFaBZ6pzXRE7sFkVaWKB2aeFo2MBJQB3/ziaIXbFB6dYlqHIwh9CcsRawW4SK3CSmH6+uQ/AHHuP2IqIcYS1xvJslJoaWVvWJ+oY1K/VYRFrBesTi9J8qgTMc5qvJWGPFVpk3+9qnmS6xhemnosroj6MlmUWVxFo11LRlso0DoQtzf+P9wHrFR5Z+GfaV6EESMLOlmWWWIld44Dd+j+XCgunsd6cVnFaNnWugKOO0u5f9YkXBIXiqSNL7HgjEyw9YXNqatmv/3Kt+HFmhBaZ0bkG6ihscpeFq+/TcVcda2KtYDlh85zqfK+n9QGRmb9AWUHQUB0nylCWWAifaxXpOQGzTwtHxwJKAJ7UB9jm/hCSXp6lDXjRk11irWA3iTVwAJ9tO9/cB4Ynj4+B9eL0zPwhxHcULM/SPLgJoDc8wgb1t5QhqbZ8GUoKDRYfFSt5i8z5a+F6hzuqzxLLszCc+DgqKV4Ta+MqAu1azml4SZWr0vw/5OOob6LUwHU0aNtQx8E+IH3mcDOxErvGAb0Msf8VKSU0Fxeb+UOIuzwhg5A5d9RR2v1L+9QqsgjLliuIN3yc9CkTAJyUIblWfPt+ZfAkiztXcP1K9diqihSNwny+eR8QrnDMY1nm/u3kevmOO+t6Z+wTB/V/BBvjCOsRC8w+LRwdCygBWGzA1avkwzPzFygvAcMxx2G6o4Pg9w1caWNd2meO2Ow+ERBr4KoPetLOt/sA3xKdqxWsxoFhZ5yljhF+J6w0D24C6A2PsCxOY32cTyxKw6oEaB+WJTrXtTp8nFSir471PoA+ar6+27iKQLu+UWil+TfLkG9O52otu2yw9MQhFlawmN7sYx/sA7OPLG6ek8SucYDVB0TmdK5ZYmcNeOpwiWU0DB8jLF6GCkqL1U8qhaznny9DNwutyNnYZnSue+rI4uhoEjv5OClDeWKtZOWJ5Vfo2Ehonk0/dteAsipaEbtS0biTKUP0Zvd5UIZmwh4vtMh0A1UYTdeuiujJDg7THR0Ev2/gShvrOiX2cUKLLG6gWHQ5Fc2Ty6ojDpb7kEllc2IJGDh0xJqwLE5jfZxv3+9qnmSic3WWJZWfQPn1+kTR0fKVJUCuJnRE3ycK8/nkPiAy8XFyUe8O6n+2LtrLl9+n2VjBYnqzj32wAc8+sjg7zsiMGl+vOAl0nAhrI14Xf2OXWH6Fjk0Ty2gYPsas8/V/JuuW+i9XlWfGl2R5dfAE3FKGMjg6emVIpsAiFoX5POwDdspVZMvOdTxbEBvsAxA+c8Sugh13MmWI3uw+D8pQFkfYyJKd64Y6DvYB6XMPN+5PxIrZE26+xsP7AM+M31yzKhphuupg0XlBzMFaY1nBenMyiJ18yKSyObEEWEkdbxhxOrjI1N9OAlEQlooqNlTHh34cjcwknpsdrKWiitbBMh8HZSgmNl+G1ivYGPtgH5A+PFsST3amooFShLWZve7HUZ6Adv/SPjUfcxI8SxNPtqcijfUScEsZyuDo6AlIr2ADVzCeJD6ORvb9ruZJtq14sr3lW4+hot+gD5hwxVK+jbXsmHhu+eULWBObCDvcgOsb9MTGjbE5btwHZp989nKE/iz450qR3YV4shMV8TNF2Ihu8ukTa401nsb7BPpxxlkCGnLg9b+gNI1QCny7K/FkfhCWiio2IhalebthA4bwaeHo6K1gMase5yS0Msfp2UOI52YHa6mookNi1T5AKJ2sHLH5MpRZwXRnRTrwA8STnalooCbCCiP2hfuAyH6MeLI9FWmsIrZHfl6GsjiAj+2NpX1a9uPEk+2pqB5DYh/8cVTjgJWAInsa8dzyKgLsYJmPF/o4GtlLEE+WUZEO1k5WtgzJzfC0DMnUxbS/GPFkkYr4GtBKtIlFaT5v2AcgfFo4Oq7qO/D9ruZp9pKKJ/OW76wqv/4rRf9wHxDZSxPPzduARVERCRioibAf6wN8exviySxlA7oma8IcYjtb5/Xfw0X2dsSTFXa0SZFK3C1DfFXZq2BVhiJ7W+K5eWUouw9MPu7cB3j2K4gn2ytDiQ22M3vWB0T2q4gn48QCszL5GhiEPaYPiOxXEk8mC8AgJV+GMvuAxGY22HIl/3ng1+5r/wexPQBrYWa4iQAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M387.66,372.77c-.72-6.21-9,1.62-15.56-1.7-3.68-1.86-4.39-4.45-5.42-4.45-1.39,0-2.45,6.94.73,11.58C374.07,388,388.78,382.59,387.66,372.77Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-204">
                  <rect
                    class="cls3-30"
                    x="366.44"
                    y="366.83"
                    width="24.31"
                    height="21.67"
                  />
                  <g class="cls3-205">
                    <image
                      class="cls3-33"
                      width="42"
                      height="34"
                      transform="matrix(0.65, 0, 0, -0.7, 365.09, 389.5)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAAmCAYAAABdw2IeAAAACXBIWXMAABE5AAAROQEb2ZNGAAACRElEQVRYR9VYy3UDIQwc+bmR1JZ7ikkJKS2NKAfEImCkZe34s3PwA0srZqVBYIuqKt4bUgeXzOvdcK2Dn+9fKABFSbTaqM6fjc+vj+m7jayIQBRG0L6Dn7+KdsNG9gKBihF0pD3hNn4N7Z4sLIsD6T7DryN9zg0mkC6DCkAEUAhUFQJxmw6D73MyPMmAkhIngUDPxf5Y2lyz6El3pAY9o7PXpx5DO5eBG2OYi2WbbcJHScRl9rIFjhcebQIVhVo+H92nG1mRsL8ChKRbfLPt9OmKW2l3MkDSX+esxrb1OMdI0w226RGw0tZM+g1UkL6A2LP/1Poo2S6YFHvWsnLJ4N9aXy8D1AC2YXw2htI233Hh+dmOVBqnVY6BywAtOIa5l4jqAR1HcXT2tWJOOPPdICgd5jdXwLQoEG29FpEvmQNomxBznx5B7gZJ6SLboMP9OK27lM85DkN/KJhjntVgIRRHT3qpOmSOQLTz3UDsYR2DBacWyMLixortxY70aYZYBvZ2oms6BoKFtzjJy5E4DEnrMpLiglm0/XLe36cZyBUx2dW1vDra4qN0iuMkkvVphumKuFIiputiOygZAaLWx5D8UuALdfOhtCGpG+IwLP9S6G01h5YNcXbNs7ra+hjOedzWQ2Hur31pdstqeoaOvsf6NMOsWXP0GkpLh2BhI320v/r5iJ0/OYykVp+1hcu49ml3ai3H4amdMgv0JfOlvev+msRhvgxXOPjs0mCktJsN5NRajjM/yyBn+pv+6ifvjlP12T+XSK+io/84vgAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M407.6,328.18c-8.4,4.51-12.32,15.05-11,17.67s16.05-6,19.54-12.46-1.41-9-8.58-5.22Z"
                  transform="translate(2.38)"
                />
                <g class="cls3-206">
                  <rect
                    class="cls3-30"
                    x="397.9"
                    y="323.48"
                    width="24.31"
                    height="24.77"
                  />
                  <g class="cls3-207">
                    <image
                      class="cls3-33"
                      width="45"
                      height="36"
                      transform="matrix(0.66, 0, 0, -0.72, 395.04, 349.93)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAnCAYAAACbgcH8AAAACXBIWXMAABCbAAAQmwF0iZxLAAACQUlEQVRYR9VYUbLiMAyTyrvInm3/32H2f8+2N6n3I7bjJDUtkPKKOsNAxo0VVREBiojgs8Blr+KK+LI3f//8u1f3I/j9/WtzfKlvuFlwRbjSCxYQohf09Zpw0jcuECmUVwikWcK18Nkb8QZiJSAgKNEmVOWvo/i2p8lqExEwWOUK9IPSi1MyTxMCoY5KVbw+hZ+h39pDFa26BsWpy3DriNe/m3y1B9UeUok0itvFqnjxflv/Doz2oCooieJxGWqdVdAt7lzrNKQrKfHNKGJk0WkeFKcSbXIep5EP6cEhJVYAQh2VquCguNUPkdkubhY20oOt4ihEi23KZ0oki3EDnxyZzdd41mRF51nq4iQuLtnAJ0TmaA9vsqEgug0ZfF/G79RPjMzcHgwKdgep9jkQKwPFo5EpYf5QfwSffmCKkdengmrij7azSaw/mvNmQzye88mPgDJ1myK10SoD1bF+Qs5nCOlBmH9TxY1+SITaZKv+tZzfJ232YJhKFR0U9yZl6jYV5uV8BidNEDe/jYGUgOo5J4sNDxopERA79QdzPsMXOpS0LucGb6OKtk3QNdF6t85ObkN2cz7DQNpg5IG4YYKCsqV4afl0zndH3Qwp6Yjyn0h8fKykQqOXI9PSSRea4RBpA/0KiriXdyIQ1TpHIzPDQ6QN1feBvm6u1yKz3cAZniJtKKap1pkTmfD6DC+RjjgjMjN89oFpFmbmfIbppA0zcj7DaaQjns35DG8hbXg05zO8lbThaM6n98s9x18T/A+nvmLAu/LDZgAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-30"
                  d="M437.13,294.66c.23-.26.37-.42.41-.45h.07a70.67,70.67,0,0,1,8.81-3.16,57.63,57.63,0,0,0-9.29,3.66m50.93-4.83a57.53,57.53,0,0,0-8.61-1.62,71.4,71.4,0,0,1,7.82,1.1l1.83.44h-1m-30.38-1.22c2.86-.4,5.61-.64,8.22-.76-2.51.13-5.18.38-8.05.74h-.2"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-30"
                  d="M414.19,383.05a9.75,9.75,0,0,1-4.92-1.28c-3.45-2-5.42-6-5.43-11.13,0-7.79,4.13-16,10.8-21.47a21.06,21.06,0,0,1,12.95-5.32,12.53,12.53,0,0,1,3.6.51,9.44,9.44,0,0,1,6.7,8.26c1.25,8.52-4.39,20-12.85,26.14-3.86,2.81-7.56,4.23-10.85,4.23m3.43-31a3.74,3.74,0,0,0-.94.13c-4.24,1.1-6,7.29-5,17.55v.29H412c.39,0,9.71-.08,15.63-4.39,2.5-1.8,3.5-4.28,2.5-6.31a5,5,0,0,0-4.73-2.45,10.25,10.25,0,0,0-3.84.81c-.11-1-.54-3.66-2.07-4.9a3,3,0,0,0-1.86-.66m-5.38,17.37c-.92-9.68.69-15.55,4.57-16.53a3.1,3.1,0,0,1,.81-.11,2.36,2.36,0,0,1,1.51.53c1.7,1.36,1.92,4.85,1.92,4.85v.44l.38-.17a10,10,0,0,1,4-.92,4.42,4.42,0,0,1,4.19,2.13c.86,1.73,0,3.85-2.3,5.48-5.24,3.81-13.48,4.23-15.05,4.27"
                  transform="translate(2.38)"
                />
                <g class="cls3-208">
                  <rect
                    class="cls3-30"
                    x="406.49"
                    y="343.61"
                    width="35.76"
                    height="38.7"
                  />
                  <g class="cls3-209">
                    <image
                      class="cls3-33"
                      width="62"
                      height="58"
                      transform="matrix(0.66, 0, 0, -0.72, 403.65, 384.06)"
                      xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAABACAYAAACtK6/LAAAACXBIWXMAABDDAAAQwwHmNsGNAAAEh0lEQVRoQ+1bbZabMAwUfXuPHrXtBXrRHsL9AcaSNdLIJJvs22R+9GEhwKOPsWHTrbXW5LWw9YMfmdd3x0c/+Pvn32lsoouhgaMxsp65r7V439L1Lfft9iYiv37/lAwn+V4LTUS2Y9SO0fDRhDdj6x79On0/mUa7xfvqZ9ngquuPw61h3w08K8JJXraDjJEAHYQx1oQ1zSUSp2edhAmpOUSE9X0xfOaPIEjDZGw1RNQXSChkJGw1KWJbOy/B1RTjLXgie9RMdLcRu94KOpNxBchp53rgS373RBnE7XHaN3W90YMYo+cFP7SJCNcDXPIoOJQECUKplWrcLfmOSIRkQQ+YKJZIHGCiGFdTDlP2HQ0+WE0QBKHWErhCOIl8PgKv50gzj4JwXRdwS3BdGHYUBKYLGVzmI8KzTY4z579UF8aYtQQiwYIw+1o7hlnnfdb6OW/Tdj2Zr7dPiDFlPsuajeZ9W+JzlkoGutT5rHlfZDNkaEvgrKPgaF8JfKtw21s9itbXahDGlTYIlZZgurDaEggq8/UoM8Jfb6nEeO/tLfLo2nLyFSAyZ9DbzjstiSLWAyaKGdyLjUX1AXnJr+jB/fcJMSbBwyRQ/9kH1PTg0fsEBrjORyTwQzEJnzWb9fu2BN4nMMB1npHQN2eqG1UTqxAzE9oSeD4M9AMmI9HtTBdWWoLpQqUlKqVf/oDJSKAStOUXlW73zCtE53JtnxDDL3UkuoxEVIL1luIVct6J6AJDvNTRG3MSuAQ9CR2wW1vCVm6O8MXGoNgSEYlhv1ZNV5dKhvf2VmTuqSCDd9ODx+4TIoBXWvsASIKoLSNhn4YDxlqJtQen7l5p46UjDYJIuAtjJLqdieKKHlxQe009ywjKpEhVFFdaQgesVxMLwmzPYDK/9soYPOzJuiDGN8e0yfGE9RQQGdoST9QFBri3x9GvTCYJgsjTdCEC+HNVnvV7tMQjdSGD29ujjERZZ5Oh1XCzLuAqFOMbI9zb4yDsZ/Z/eYXc2hKWBArCsKMqZICfsaIlRGcEZf2yLohItSXmypp97SxyvPf2HSy6jxTF2/WA933wYiPHMX7As0RxTQ948YdqvyOPMtODR4hiTQ8wSj9O4FFeaQlcISgIfTwuOIK6sE/IoD5gikirl3kU5SstEenCPkqqgegCg13ng18zap+BWkvMGUGEozCN89daggF/wwM/6KuU+Zw16zd8dRBi6nlLuJ6+5QOmjZV6wHFC/6qRZXjO2uyrA/aZSyVDutQZEsWWiISH++KsowqZg8taIkLxxabeEld0YfZFWb+8VCZw3/DGqEDicGEtIWYyeIL1lsAVgoLA8N7bi/S8+2zv50gG1elqj899m/kyPcj2CRngi00Do91CSBRF8XQS0EqT76w9iDDbJ0QAn7FE9MSyIMy+VVEU0ffIs1aZV1YhGfyfqAVPbI5/5mtIHKeZKK60RDQvVCEZIPkO1n+oGm5tiXCJpb5rWRch5DsqpTf7foV9AkOJvAYrPe837I7E4cJaQt/XtJSxIt8c2yv/R+IPPXg1vPQO7z8u1i9c98x90wAAAABJRU5ErkJggg=="
                    />
                  </g>
                </g>
                <path
                  class="cls3-210"
                  d="M311.49,966.18c-.84,14.82-1.81-108.83-7.42-120.39-12.82-26.33-19.68-57.37-11.72-75.68"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-211"
                  d="M391.1,874.25s17.34,77-65.41,74.23C325.69,948.48,431.55,996.62,391.1,874.25Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-211"
                  d="M322.51,751.12S288.58,782.21,309,815.47l20.46,33.3h0S312.51,789.58,322.51,751.12Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-211"
                  d="M392,784.58s-14.47,9.87-4.25,43.55c0,0,1.32-23.92,11.31-35.39l-2-11.54Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-212"
                  d="M268.92,549.57s-13.47,13.36-16.84,17-5.61,1.22-5.61,1.22l-7.86-12.15a36.22,36.22,0,0,1-5.61-8.5c-2.24-4.86,1.12-6.08,1.12-6.08l11.23-12.14,3.36-3.65c3.37-3.64,5.61,0,5.61,0s11.26,13.37,14.6,18.2S268.92,549.57,268.92,549.57ZM362.82,714a110,110,0,0,0-2.4-18.65s.93-51.93-1.45-74c-3.8,4.69-9.16,7.89-14.32,10.07h0a63.86,63.86,0,0,1-16,4.38l2-27.86-2-42.15c-2-42.15-13.73-62.32-48.53-73.58-34.3-11.1-71.34,7.46-72.41,8h0a56.2,56.2,0,0,0-11.2,17.21c-15.71,37.66-15,72.89-15.91,93.54,0,0,3.55-7.29,45.66,0,0,0,76.91,1.22,87,4.86s9.28,5.74,8.06,15.62c-.25,1.73-.42,3.16-.57,4.39-.2,1.58-.35,2.7-.46,3.51l-.25,2s.29,3.69.71,9.71c1.33,18.65,4,59.57,3.73,83.17,3.67-.37,26-3.11,38.45-17.29-.07-1.1-.09-2-.13-3Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-213"
                  d="M362.93,716.88A60.66,60.66,0,0,1,360.45,736c-5.61,17-32.56,26.79-32.56,26.79S237,753.11,204.4,748.25s-25.82-15.79-25.82-15.79c3.37,8.5,137,20.65,137,20.65l6.51-1.19c1.62-.28,2.32-7.3,2.43-17.69C328.15,733.8,350.5,731,362.93,716.88Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-214"
                  d="M324.48,734.18c-.11,10.38-.81,17.4-2.43,17.69l-6.51,1.18S182,740.89,178.56,732.4c-2.93-27.69-1.56-62.11,0-88.43,0,0,12.88,2.19,53.88,6.13s72.73,10,88.29.91C322.08,669.6,324.75,710.57,324.48,734.18Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-215"
                  d="M320,641.29s.29,3.7.71,9.72c-15.56,9.11-47.34,3-88.29-.91S178.58,644,178.58,644c.38-6.59.79-12.57,1.13-17.88,3.12,1,13.38,3.72,38.56,5.31,31.59,2,86.92,11.55,102.48,4.38-.2,1.58-.35,2.71-.46,3.51Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-216"
                  d="M321.3,631.4c-.25,1.73-.42,3.15-.57,4.38-15.56,7.21-70.89-2.34-102.48-4.38-25.18-1.59-35.44-4.28-38.56-5.31.4-6.14.74-11.31.92-15.17,0,0,3.55-7.3,45.66,0,0,0,76.91,1.22,87,4.86S322.58,621.51,321.3,631.4Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-216"
                  d="M344.68,631.38h0a63.46,63.46,0,0,1-16,4.39l2-27.86-2-42.15c-2-42.15-13.73-62.32-48.53-73.58-34.3-11.1-71.34,7.46-72.41,8a62,62,0,0,1,15.11-11.54h0c1.84-.56,60.43-18,98.42,17.55C359.57,542,344.88,630.17,344.68,631.38Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-215"
                  d="M359,621.34h0c-3.8,4.69-9.16,7.9-14.32,10.07.2-1.22,14.94-89.36-23.36-125.23-38-35.54-96.58-18.11-98.42-17.54a86.5,86.5,0,0,1,35.47-10.07q3.93.53,8.06,1c4.5.57,9.13,1.16,13.8,1.81,5.13.72,10.31,1.52,15.46,2.5,4.6.88,9.16,1.89,13.61,3.11,11.51,3.16,22.27,7.68,31,14.64,21.33,17,14.6,97.17,18,114.18C358.5,617.28,358.76,619.14,359,621.34Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-217"
                  d="M179.71,626.09a11.75,11.75,0,0,1-1.13-.41"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-214"
                  d="M295.64,452.08s-5.13,6.58-5.79,12-9.67,17.28-9.67,17.28c-4.67-.64-9.3-1.24-13.8-1.81,0,0,20.54-35.64,30.22-32.62s12.61,40,12.61,40c-4.45-1.23-9-2.2-13.61-3.12C295.64,483.84,316.71,476.08,295.64,452.08Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-213"
                  d="M268.92,548.76s-13.45,13.38-16.82,17-5.61,1.22-5.61,1.22l-7.86-12.15a36.22,36.22,0,0,1-5.61-8.5c-2.24-4.86,1.12-6.08,1.12-6.08l11.23-12.12,3.36-3.64c3.37-3.64,5.61,0,5.61,0s11.25,13.29,14.58,18.19S268.92,548.76,268.92,548.76Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-212"
                  d="M335.47,500.23s35.25-30.5,50.36-22.86c0,0,14,5.27,4.5-2.79s-9.55-12.46-20.61-11.37-42.13,12-49.74,27.22C320,490.43,331.37,494.76,335.47,500.23Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-216"
                  d="M335.47,500.23s3.15-11.09,18.72-18.59,26.57-14.26,36.17-7.06-4.5,2.79-4.5,2.79S357.56,480.6,335.47,500.23Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-212"
                  d="M252.86,478.5s-3.7-10.32,19.86-19.32l6.24-2.89s-14.33,9.5-15.11,22.92Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-218"
                  d="M782.46,957.87,815,962.15S760.57,775.73,710.08,705c0,0-11.37,6.92-6.75,18.19s94.45,174.11,77.71,243"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-218"
                  points="694.24 704.5 741.24 647.83 729.67 628.83 673.67 698.51 685.24 712.84 694.24 704.5"
                />
                <polygon
                  class="cls3-218"
                  points="203.22 425.56 194 446.74 198.62 449.92 203.22 425.56"
                />
                <path
                  class="cls3-218"
                  d="M541.64,554.25S663.91,619,687.93,674.54l-11.81,13.7S602.78,594.05,541.64,554.25Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-218"
                  d="M669.8,853.31,672.92,916s-29.38-70.49-50.52-107.49-52.75-75.4-52.75-75.4S655.81,821.87,669.8,853.31Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-218"
                  d="M586.41,880.11s34.3,51.48,45.22,82H619.09S607.78,912.5,586.41,880.11Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-218"
                  d="M494.54,844.12l-1.35,13.16s-38.33-46.23-64.77-66C428.4,791.25,485.39,828.52,494.54,844.12Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-218"
                  d="M488.49,734.18l.45,11.75S467.87,718,447,705C447,705,473.39,719.73,488.49,734.18Z"
                  transform="translate(2.38)"
                />
                <polygon
                  class="cls3-17"
                  points="759.04 449.9 799.98 447.81 799.98 575.97 757.16 574.99 759.04 449.9"
                />
                <path
                  class="cls3-17"
                  d="M939.94,723.15s9.61,34.15-13.53,40.14-74-4.53-74-4.53S931.33,764.2,939.94,723.15Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-29"
                  d="M555.09,453.53s-1.74-42.43,21.22-53.95,20,17.91,20,17.91,10.56-5.26,38.49-2.64,17-25.84,43.09-37.19,47.25.28,40.72,17.33,20.31,12,20.31,12,3.59,21.6-33.78,23.7-47.93,10.3-70.34,19.27-34.49-2-55.11,10.57S555.09,453.53,555.09,453.53Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-29"
                  d="M61.17,328.76l68.3,6.46s3-44.27-22.31-39.27S58.57,302.1,61.17,328.76Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-219"
                  d="M837.27,465.67c0-1.56-.07-2.34-.11-3.89l3.34-.17c0,2,.08,3,.15,4.94h-.33Zm2.46,18.38c-.46-7.39-.78-14.88-1-22.32l3.62-.17c.13,7.22.45,14.64.9,22.09l.15,2.34c.48,7.59,1.1,14.95,1.88,22.18l-3.59.68c-.66-7.19-1.27-14.62-1.76-22.14C839.83,485.61,839.79,485.1,839.73,484.05ZM843,503.64c.18,1.95.27,2.93.47,4.87l-3.32.63c-.16-1.54-.23-2.31-.37-3.84,1.15-.65,1.74-1,2.9-1.59Zm2.6-42.24c.65,1.57,1,2.36,1.63,3.92-2.64.14-4,.22-6.59.38,0-1.62-.07-2.43-.12-4.06l7.29-.34c.18,4.85.31,7.26.58,12.07l-1.74.13c-.47-4.8-.67-7.23-1-12.06Zm.63,24.57c-1.83.21-2.75.32-4.57.55-.11-1.69-.16-2.52-.26-4.21l4.57-.5C846.07,483.48,846.07,484.27,846.21,486Zm3.94,9.17c.33,4.79.51,7.18.94,12l-7.64,1.41c-.16-1.58-.24-2.37-.38-3.95l6.95-1.2c-.45,1.64-.68,2.47-1.12,4.13-.24-4.84-.33-7.25-.47-12.06Zm-4.76-12.06c0-2.72,0-4.08-.06-6.8l1.2-.11c.31,6.06.5,9.09.94,15.11l-1.21.16c-.33-2.81-.49-4.23-.79-7.06a7,7,0,0,0-.08-1.28Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-219"
                  d="M860.25,496.12c-.3-3.56-1-5.09-2.33-6.75l-1-1.21c-2.7-3.35-4.4-7.31-4.76-15-.38-8.3,1.56-13.47,4.72-13.57,1.48-.05,3,1.19,4,3.3,0,3.78.08,5.68.18,9.46l-1.91.13c-.39-4.07-.56-6.12-.88-10.22l1.73,1.86c0,1.36.07,2,.12,3.39-1.21-2.54-2-3.92-3.11-3.87s-2.08,2.59-1.91,6.35.9,5.49,2.22,7.18l1,1.37c2.87,3.65,4.18,7.2,4.71,14,.63,7.86-.65,13.73-4.18,14.38-1.55.27-3.41-.54-4.84-2.77-.34-4.08-.5-6.12-.77-10.22l1.94-.26c.56,4.39.86,6.58,1.51,11L855,503.23c-.13-1.31-.19-2-.3-3.29,1.52,2.13,2.49,3.2,3.82,3C860,502.7,860.56,499.77,860.25,496.12Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-219"
                  d="M864.72,464.21c0-1.44-.07-2.19-.1-3.59l3.35-.11c0,1.81.08,2.72.14,4.53h-.32Zm2.4,16.89c-.41-6.8-.71-13.69-1-20.53l3.62-.11c.12,6.63.41,13.45.84,20.3.09,1.59.15,2.39.25,4,.36,5.33.9,11.9,1.63,18.55l-3.6.61c-.6-6.58-1.17-13.44-1.62-20.36-.06-1-.06-1.5-.16-2.44ZM870.89,499l3.1.51c.13,1.38.19,2.07.33,3.45-2.78.46-4.17.7-7,1.19-.14-1.42-.21-2.12-.34-3.53,1.16-.6,1.74-.88,2.91-1.46Zm.72-12.06-2.32.26c-.11-1.47-.16-2.19-.25-3.67l2.34-.24c1.85-.2,2.47-4.24,2.19-10.16s-1.39-9-3.21-8.92l-2.27.1c0-1.51-.08-2.28-.12-3.79l2.31-.08c4.35-.13,6.18,4.88,6.55,12.51.36,7.29-.71,13.46-5.22,14Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-219"
                  d="M893.62,479.85c.91,13.92-1.39,21.36-4.8,21.94s-7.45-6-8.39-20.74c-.93-14.57,2.22-22.09,5.64-22.15S892.72,465.78,893.62,479.85Zm-5.16,18.36c2.09-.31,2.14-7.9,1.49-18s-1.69-17.78-3.78-17.73-2.72,7.95-2,18.24S886.35,498.5,888.46,498.21Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-219"
                  d="M909.13,492c.11,1.18.17,1.76.29,2.93l-1.31,1c-.07-3.62-.1-5.43-.12-9l1.59-.16c.25,3.5.39,5.24.7,8.77a5.88,5.88,0,0,1-4,3.54c-4,.61-8.06-5.55-8.92-19.47-.92-14.13,2.52-20.84,6.43-20.84,1.58,0,2.87,1,4.16,2.83.16,3.58.25,5.36.46,8.93l-1.59.07c-.47-3.64-.69-5.48-1.09-9.14l1.43.87c0,1.29.06,1.92.11,3.19-1.09-2.44-2-3.47-2.89-3.45-2.23,0-4.12,5.25-3.34,17.29s3.25,16.67,5.44,16.37C907.5,495.5,908.36,494.19,909.13,492Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-219"
                  d="M911.36,462.78l-.1-3h6.57l.1,3-3,.88h-.6Zm2.3,14.44c-.38-5.79-.66-11.66-.89-17.55h3.63c.1,5.65.37,11.45.74,17.27,0,.68.07,1,.12,1.7.4,6.06.91,11.79,1.55,17.43l-3.59.51c-.53-5.62-1-11.43-1.43-17.32,0-.79-.08-1.21-.13-2Zm3.19,15.35,3.1.44c.11,1.18.17,1.76.29,2.93l-6.52.92c-.13-1.19-.2-1.8-.31-3l2.82-1.21Zm-1.29-13.32c-.09-1.3-.13-1.94-.21-3.29l7.92-.49c.09,1.27.13,1.89.22,3.15Zm3.83-16.56-.1-3h6.56l.1,2.9-3,.84h-.58Zm2.21,14c-.36-5.61-.63-11.31-.86-17h3.61c.11,5.49.37,11.1.75,16.75,0,.8.08,1.2.13,2,.39,5.48.87,11.09,1.51,16.56l-3.61.49c-.5-5.48-1-11.09-1.42-17.15a9.31,9.31,0,0,1-.11-1.67Zm3.3,14.86,3,.44c.11,1.1.16,1.7.28,2.84l-6.53.89-.3-2.92,2.9-1.18Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M556.4,500.31l-3.8.31c.26,3.22.4,4.83.69,8l4.22-.42c.08.95.13,1.43.21,2.39l-5.47.57c-.83-8.93-1.19-13.41-1.76-22.36l5.28-.3c.06,1,.09,1.43.16,2.4l-4,.25c.19,2.82.29,4.24.5,7.05l3.8-.29Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M558.87,507a3,3,0,0,0,2.39,1.2c1.29-.13,1.9-1.72,1.71-3.92a5,5,0,0,0-2.2-4.19,7.44,7.44,0,0,1-3-6c-.25-3.44.86-6.06,2.75-6.17a2.72,2.72,0,0,1,2.24.95l-.2,2.32a2.53,2.53,0,0,0-1.93-.93c-1.33.09-1.72,1.92-1.61,3.41a4.79,4.79,0,0,0,2.26,4.09c1.76,1.31,2.74,3,3,6.21s-.56,6.37-2.85,6.58a3.19,3.19,0,0,1-2.62-1.1Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M573.23,508.3a3.59,3.59,0,0,1-2.47,1.29c-2.75.29-5.2-3.3-5.77-10.48-.53-6.8,1.26-11.53,4.29-11.7a3.1,3.1,0,0,1,2.38.82l-.15,2.27a2.8,2.8,0,0,0-2-.77c-2.29.15-3.61,3.49-3.16,9.18.42,5.3,2.11,8.56,4.48,8.33a2.94,2.94,0,0,0,2-1.1C573,507,573.1,507.44,573.23,508.3Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M574.46,487.46c.32,5,.51,7.56.92,12.58.38,4.76,1.55,6.67,2.85,6.58s2.17-2.3,1.79-6.94c-.4-5-.58-7.47-.9-12.45l1.26-.07c.33,4.89.51,7.33.9,12.22.52,6.44-.78,9.24-2.89,9.47s-3.76-2.13-4.29-8.77c-.41-5-.6-7.53-.92-12.55Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M588.44,497.66l-3.8.32c.25,3,.37,4.5.64,7.49l4.22-.41.2,2.19-5.47.57c-.77-8.33-1.11-12.5-1.65-20.84l5.29-.31c0,.9.08,1.34.14,2.2l-4,.25c.17,2.63.27,3.95.47,6.58l3.79-.29C588.33,496.3,588.37,496.79,588.44,497.66Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M589.72,486.59l1.26-.07c.48,7.3.77,11,1.42,18.24l4.16-.41.2,2.2-5.42.56C590.58,498.91,590.22,494.81,589.72,486.59Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M599.18,499.91c-.19,2.57-.28,3.85-.45,6.43l-1.3.13c.57-8.21.91-12.31,1.73-20.42l1.52-.09c1.85,7.94,2.83,11.87,4.9,19.65l-1.34.15c-.65-2.46-1-3.69-1.6-6.17Zm3-2.3c-.56-2.27-.85-3.41-1.4-5.68-.31-1.3-.54-2.48-.76-3.63h0c-.07,1.2-.14,2.43-.24,3.67-.21,2.35-.31,3.52-.51,5.88Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M609.62,502.08a3.11,3.11,0,0,0,2.37,1.1c1.29-.13,1.91-1.56,1.75-3.52a4.32,4.32,0,0,0-2.15-3.72,6.26,6.26,0,0,1-3-5.35c-.23-3.06.89-5.42,2.79-5.49a2.89,2.89,0,0,1,2.22.83c-.08.83-.13,1.24-.21,2.07a2.62,2.62,0,0,0-1.91-.81c-1.34.09-1.74,1.71-1.64,3.05a4.13,4.13,0,0,0,2.22,3.63,6.48,6.48,0,0,1,3,5.48c.25,3-.61,5.69-2.91,5.94a3.32,3.32,0,0,1-2.6-1C609.54,503.38,609.57,502.94,609.62,502.08Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M617,485c.29,4.56.46,6.84.83,11.39.36,4.31,1.49,6,2.79,5.92s2.2-2.11,1.86-6.31c-.37-4.51-.54-6.76-.83-11.28l1.28-.06c.28,4.38.44,6.58.81,11.06.47,5.83-.86,8.37-3,8.6s-3.72-1.89-4.21-7.87c-.37-4.55-.53-6.82-.83-11.39Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M625.08,484.79a7.34,7.34,0,0,1,2.42-.55,3,3,0,0,1,2.85,1.39,7.89,7.89,0,0,1,1.13,3.84,9.13,9.13,0,0,1-.45,4,3.38,3.38,0,0,1-2.82,2.31,2.46,2.46,0,0,1-1-.08c.24,3,.38,4.52.65,7.53l-1.25.13C625.87,496,625.57,492.24,625.08,484.79Zm1.92,9a2.3,2.3,0,0,0,1,.11c1.52-.12,2.33-1.6,2.14-4.18s-1.17-3.6-2.56-3.51a3,3,0,0,0-1.09.23c.17,3,.27,4.39.5,7.35Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M638.57,493.53l-3.79.32c.22,2.65.33,4,.57,6.64l4.22-.43c.07.79.11,1.19.18,2l-5.48.58c-.68-7.39-1-11.1-1.46-18.5l5.28-.31c.06.79.08,1.18.13,2l-4,.26c.15,2.33.24,3.51.42,5.83l3.79-.29Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M640,483.94a7.11,7.11,0,0,1,2.4-.51,3,3,0,0,1,2.92,1.3,6.91,6.91,0,0,1,1,3.36c.17,2.36-.52,4-1.49,4.71v.08c.79.42,1.34,1.67,1.73,3.5a42.54,42.54,0,0,0,1.19,4.83l-1.3.14a38.63,38.63,0,0,1-1-4.22c-.5-2.44-1.09-3.35-2.25-3.3l-1.17.1c.25,3.14.38,4.71.67,7.85l-1.26.13C640.7,494.71,640.42,491.13,640,483.94Zm1.85,8.18,1.29-.09c1.34-.11,2.09-1.54,1.95-3.59-.17-2.32-1.17-3.29-2.49-3.21a2.8,2.8,0,0,0-1.23.28C641.5,488.16,641.59,489.54,641.8,492.12Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M649,483.14c.46,7.11.74,10.65,1.4,17.75l-1.25.13c-.67-7.12-.95-10.68-1.41-17.81Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M660.17,491c.46,5.93-1.26,9.29-3.74,9.55s-4.73-3.15-5.16-8.49c-.44-5.61,1.27-9.4,3.88-9.55S659.72,485.91,660.17,491Zm-7.56.9c.3,3.76,1.73,7,3.72,6.81s2.82-3.58,2.52-7.5c-.27-3.45-1.53-7-3.64-6.85s-2.9,3.66-2.6,7.53Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M661.22,482.71a7.34,7.34,0,0,1,2.4-.49,3,3,0,0,1,2.92,1.22,6.22,6.22,0,0,1,1,3.16c.16,2.19-.53,3.77-1.51,4.46v.08c.78.39,1.33,1.57,1.71,3.29a39.55,39.55,0,0,0,1.16,4.56l-1.3.13a31.77,31.77,0,0,1-1-4c-.5-2.3-1.07-3.15-2.23-3.13l-1.18.1c.23,3,.36,4.39.63,7.41l-1.25.13C661.93,492.88,661.67,489.54,661.22,482.71Zm1.82,7.68,1.29-.1c1.35-.11,2.1-1.46,2-3.4-.16-2.19-1.15-3.09-2.47-3a3.39,3.39,0,0,0-1.24.28c.13,2.54.22,3.79.41,6.29Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M672.1,482a9,9,0,0,1,2.4-.46,3.12,3.12,0,0,1,2.83,1.21,6.38,6.38,0,0,1,1.1,3.38,7.21,7.21,0,0,1-.49,3.56,3.45,3.45,0,0,1-3.84,2c.22,2.66.33,4,.58,6.65l-1.26.13C672.82,491.92,672.54,488.63,672.1,482Zm1.84,7.95a3,3,0,0,0,1,.08c1.52-.13,2.35-1.44,2.19-3.72s-1.14-3.17-2.54-3.08a3.46,3.46,0,0,0-1.18.25c.23,2.59.32,3.89.53,6.48Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M688.72,488.72c.43,5.49-1.32,8.59-3.8,8.86s-4.7-2.88-5.09-7.83c-.42-5.17,1.31-8.68,3.93-8.77S688.35,484.05,688.72,488.72Zm-7.55.88c.28,3.48,1.69,6.47,3.66,6.27s2.85-3.29,2.57-6.94c-.25-3.18-1.49-6.44-3.59-6.3S680.89,486,681.17,489.6Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M689.81,480.84l1.26-.08c.36,5.64.58,8.45,1.09,14.07l4.17-.41.15,1.69-5.42.55C690.46,490.35,690.22,487.18,689.81,480.84Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M697.92,480.37c.4,6.19.64,9.29,1.22,15.45l-1.26.13c-.58-6.2-.82-9.3-1.22-15.51Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M702.09,481.86l-3,.18c0-.68-.06-1-.11-1.68l7.24-.42c0,.66.06,1,.11,1.65l-3,.19c.37,5.42.58,8.13,1.08,13.54l-1.26.13C702.68,490,702.46,487.25,702.09,481.86Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M713,487.34l-3.8.32c.18,2.19.27,3.24.46,5.39l4.22-.42.15,1.59-5.48.58c-.56-6-.79-9-1.18-15l5.27-.3c0,.64.07,1,.11,1.6l-4,.25.35,4.73,3.79-.29C712.9,486.43,712.92,486.76,713,487.34Zm-1-11.2-1.69,2.68h-1c.47-1.1.7-1.6,1.19-2.65Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M722.39,492.91a4.48,4.48,0,0,1-2.5,1c-2.74.28-5-2.11-5.45-6.93-.37-4.6,1.52-7.85,4.55-8a3.85,3.85,0,0,1,2.36.51l-.18,1.52a3.4,3.4,0,0,0-2-.49c-2.29.15-3.68,2.44-3.36,6.29.28,3.58,1.86,5.74,4.24,5.48a3.8,3.8,0,0,0,2-.8C722.17,492.05,722.24,492.34,722.39,492.91Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M724,493.22c-.52-5.7-.75-8.57-1.12-14.26l1.38-.09c1.44,2.81,2.17,4.21,3.64,6.95q1.17,2.19,2.14,4.38h0c-.28-1.86-.46-3.56-.63-5.73-.17-2.35-.26-3.52-.41-5.87l1.22,0c.36,5.58.58,8.37,1.1,13.94l-1.27.13c-1.5-2.71-2.25-4.08-3.71-6.84a47.3,47.3,0,0,1-2.17-4.61h0c.19,1.79.35,3.5.54,5.87s.3,3.64.52,6.06Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M733.7,478.32c.36,5.48.58,8.27,1.09,13.77l-1.26.13c-.51-5.48-.73-8.29-1.08-13.83Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M743.76,490.71a4.89,4.89,0,0,1-2.52.91c-2.74.28-5-1.93-5.41-6.42-.34-4.3,1.56-7.32,4.59-7.49a4.05,4.05,0,0,1,2.36.46c-.08.57-.13.86-.21,1.43a3.67,3.67,0,0,0-2-.44c-2.29.14-3.68,2.29-3.4,5.87.26,3.29,1.83,5.34,4.21,5.1a4.13,4.13,0,0,0,2-.76C743.52,489.91,743.6,490.18,743.76,490.71Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M746.64,486.66c-.26,1.7-.4,2.55-.65,4.26l-1.3.13c.83-5.48,1.29-8.15,2.28-13.5l1.52-.09c1.67,5.17,2.55,7.68,4.35,12.74l-1.34.14c-.57-1.58-.84-2.38-1.41-4Zm3.09-1.6c-.5-1.47-.76-2.19-1.25-3.68-.28-.85-.48-1.62-.67-2.37h0c-.1.77-.2,1.59-.33,2.4-.27,1.56-.4,2.33-.66,3.89Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M602.49,522a8.71,8.71,0,0,1,2.62-.79,4.11,4.11,0,0,1,4.22,1.9,15.09,15.09,0,0,1,2.23,6.83,18.61,18.61,0,0,1-.36,7.86,5.06,5.06,0,0,1-3.87,3.64,9.88,9.88,0,0,1-2.3.18C603.91,533.8,603.4,529.88,602.49,522ZM606,539.43a3.94,3.94,0,0,0,1.28-.09c2.67-.49,3.66-3.79,3-9.09-.59-4.63-2.22-7.39-4.87-7a4.1,4.1,0,0,0-1.43.48c.71,6.3,1.12,9.44,2,15.71Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M618.34,529.92l-3.76.62c.36,2.81.55,4.21.95,7l4.18-.78c.11.84.17,1.26.29,2.09l-5.42,1c-1.12-7.79-1.62-11.69-2.52-19.51l5.24-.74c.09.84.14,1.25.24,2.09l-4,.59c.29,2.46.45,3.68.76,6.14l3.76-.6C618.18,528.68,618.23,529.09,618.34,529.92Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M631.31,536.08a4,4,0,0,1-2.43,1.37c-2.71.52-5.27-2.47-6-8.71-.78-6,.83-10.31,3.85-10.74a3.23,3.23,0,0,1,2.39.51,17,17,0,0,1-.07,2,2.79,2.79,0,0,0-2-.49c-2.27.33-3.46,3.4-2.81,8.39.6,4.65,2.39,7.38,4.73,6.94a3.21,3.21,0,0,0,1.93-1.15Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M631.8,517.58c.36,3.12.55,4.67.94,7.79l4.68-.76c-.39-3.08-.57-4.62-.92-7.68l1.27-.17c.83,7.34,1.31,11,2.35,18.29l-1.26.24c-.49-3.43-.72-5.15-1.16-8.59l-4.69.78c.46,3.48.7,5.23,1.19,8.7l-1.24.23c-1.07-7.43-1.55-11.16-2.41-18.64Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M641.19,516.25c.84,7.26,1.31,10.89,2.35,18.13l-1.25.24c-1-7.26-1.51-10.9-2.35-18.19Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M652.77,524.69c-.39-2.45-.84-5.4-1.08-7.6h0c-.08,2.12-.22,4.38-.39,6.92-.24,3.55-.34,5.33-.53,8.9l-.95.18c-1.11-3.29-1.65-4.91-2.72-8.23-.78-2.44-1.46-4.7-2-6.8h0c.23,2.25.53,5.28.8,8,.31,3.1.47,4.65.8,7.75l-1.19.22c-.76-7.25-1.09-10.88-1.65-18.14l1.6-.23c1,3.39,1.6,5.07,2.71,8.41.69,2.14,1.28,4,1.77,5.84h0c0-1.84.08-3.85.22-6.17.26-3.55.39-5.32.69-8.85l1.59-.23c1,7,1.63,10.53,2.88,17.55l-1.22.23C653.54,529.31,653.28,527.77,652.77,524.69Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M655,514.53a7.43,7.43,0,0,1,2.25-.69,3,3,0,0,1,2.81.88,5.2,5.2,0,0,1,1.16,2.93,4.63,4.63,0,0,1-1.16,4.05h0c1,.26,2.21,1.43,2.56,4a6.92,6.92,0,0,1-.34,3.58,3.74,3.74,0,0,1-3.1,2.2,9,9,0,0,1-2,.16C656.23,524.82,655.79,521.43,655,514.53Zm2.11,7,1.14-.19c1.32-.21,1.94-1.57,1.74-3.29-.25-2-1.2-2.7-2.47-2.51a3,3,0,0,0-1.09.32c.29,2.24.4,3.36.68,5.64Zm1.12,8.34a3.8,3.8,0,0,0,1-.08c1.29-.25,2.36-1.31,2-3.81s-1.57-3.15-2.93-2.92l-1,.18C657.72,525.92,657.85,527.19,658.22,529.84Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M672.06,520.25c.75,5.77-.81,9.19-3.28,9.66s-4.85-2.68-5.52-7.87c-.71-5.48.81-9.29,3.4-9.65S671.42,515.24,672.06,520.25Zm-7.47,1.52c.47,3.65,2,6.71,4,6.34s2.65-3.73,2.15-7.55c-.43-3.29-1.85-6.68-3.94-6.38s-2.73,3.81-2.24,7.56Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M672.72,512a7.61,7.61,0,0,1,2.36-.69,3,3,0,0,1,3,.94,5.92,5.92,0,0,1,1.13,3,4.87,4.87,0,0,1-1.3,4.48v.08c.81.31,1.4,1.4,1.87,3.07a34.9,34.9,0,0,0,1.37,4.39l-1.29.25a28.07,28.07,0,0,1-1.2-3.81c-.6-2.19-1.22-3-2.36-2.86l-1.18.2c.38,2.87.58,4.31,1,7.18l-1.25.23C673.91,521.88,673.47,518.59,672.72,512Zm2.17,7.38,1.28-.21c1.33-.22,2-1.6,1.79-3.47-.26-2.13-1.28-2.93-2.6-2.76a3.19,3.19,0,0,0-1.21.39c.28,2.42.43,3.63.74,6Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M683.46,521.53c-.12,2.11-.18,3.17-.29,5.29l-1.29.24c.39-6.77.62-10.13,1.19-16.79l1.51-.22c2.08,6.27,3.14,9.36,5.38,15.48l-1.33.25c-.7-1.94-1-2.9-1.73-4.84Zm3-2.19c-.63-1.79-.94-2.69-1.55-4.48-.34-1-.6-2-.85-2.87h0c0,1-.07,2-.14,3l-.35,4.84Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M690.54,524.23c1.42-5.56,2.16-8.31,3.71-13.71v-.07l-4.92.73-.21-1.73,6.55-.93.15,1.23c-1.55,5.36-2.29,8.07-3.7,13.58v.07l5.39-1c.1.67.15,1,.24,1.67l-7,1.34C690.66,525,690.62,524.71,690.54,524.23Z"
                  transform="translate(2.38)"
                />
                <path
                  class="cls3-220"
                  d="M706.19,514.58c.66,5.21-.94,8.34-3.4,8.77s-4.8-2.35-5.41-7.05c-.64-4.94.92-8.45,3.51-8.78S705.6,510.09,706.19,514.58Zm-7.48,1.47c.43,3.29,2,6.06,3.92,5.69s2.69-3.42,2.25-6.88c-.4-3-1.78-6-3.86-5.72s-2.75,3.53-2.31,6.91Z"
                  transform="translate(2.38)"
                />
              </g>
            </g>
          </g>
        </g>
      </svg>
    </>
  );
};

export default PaseoVirtual;
